webpackJsonp([1],{

/***/ "+x5K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel connect",class:{'loading': _vm.loading}},[(_vm.autoService)?_c('a',{staticClass:"service auto-service",class:{'coming-soon': _vm.autoService.comingSoon},on:{"click":function($event){_vm.connectSource(_vm.autoService)}}},[_c('h3',[_vm._v("Click to connect to "+_vm._s(_vm.autoService.title))]),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('span',{staticClass:"helper"}),_vm._v(" "),_c('img',{attrs:{"src":_vm.autoService.logo,"alt":""}})])]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Connect to all your work apps here")]),_vm._v(" "),_c('section',{staticClass:"services"},[_vm._l((_vm.services),function(service){return _c('a',{staticClass:"service",class:{'coming-soon': service.comingSoon},on:{"click":function($event){_vm.connectSource(service)}}},[_c('div',{staticClass:"logo"},[_c('span',{staticClass:"helper"}),_vm._v(" "),_c('img',{attrs:{"src":service.logo,"alt":""}})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(service.title))])])}),_vm._v(" "),(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),(_vm.message && _vm.message.text)?_c('p',{staticClass:"message-block",class:_vm.message.type || 'success'},[_vm._v(_vm._s(_vm.message.text))]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/GM2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__explorer_ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__connect_vue__ = __webpack_require__("KZDm");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      doneMessage: false,
      autoService: null,
      organisation: {},
      services: [{
        title: 'Google Drive',
        id: 'gdrive',
        logo: '/static/images/icons/gdrive.png'
      }, {
        title: 'Trello',
        id: 'trello',
        logo: '/static/images/icons/trello.png'
      }, {
        title: 'Dropbox',
        id: 'dropbox',
        logo: '/static/images/icons/dropbox.png'
      }, {
        title: 'Gmail',
        id: 'gmail',
        logo: '/static/images/icons/gmail.png'
      }, {
        title: 'Asana',
        id: 'asana',
        logo: '/static/images/icons/asana.png',
        comingSoon: true
      }, {
        title: 'Sifter',
        id: 'sifter',
        logo: 'https://www.pcmag.com/sm/pcmagus/photo/default/sifterlogo6_14fe.png',
        comingSoon: true
      }, {
        title: 'Zoho',
        id: 'zoho',
        logo: 'https://d7uddx54veb4a.cloudfront.net/wp-content/uploads/2016/10/logo-zoho.png',
        comingSoon: true
      }, {
        title: 'Confluence',
        id: 'confluence',
        logo: 'https://wac-cdn.atlassian.com/dam/jcr:a22c9f02-b225-4e34-9f1d-e5ac0265e543/confluence_rgb_slate.png',
        comingSoon: true
      }]
    };
  },

  components: {
    ibutton: __WEBPACK_IMPORTED_MODULE_0__explorer_ibutton_vue__["a" /* default */],
    Connect: __WEBPACK_IMPORTED_MODULE_1__connect_vue__["a" /* default */]
  },
  computed: {
    organisationID: {
      get: function get() {
        return this.organisation.id;
      },
      set: function set(val) {
        this.organisation.id = val;
      }
    }
  },
  created: function created() {
    if (!this.organisation.id) this.organisation.id = getParameterByName('org');
    if (!this.autoService) {
      var serviceName = getParameterByName('service');
      var service = this.services.filter(function (service) {
        return service.id === serviceName;
      });
      if (service.length) this.autoService = service[0];
    }
  }
});

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/***/ }),

/***/ "/Rww":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1/oy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Dbx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",class:[{ editable: !(_vm.editable === false) }, _vm.myClass],attrs:{"contenteditable":!(_vm.editable === false),"placeholder":_vm.placeholder,"watches":['myContent'],"source":_vm.myContent,"linkify":true,"emoji":false,"anchorAttributes":{ target: '_blank' }},on:{"input":_vm.update}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2MVu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create__);



var gapi = window.gapi = window.gapi || {};gapi._bs = new Date().getTime();(function () {
  var m = this,
      aa = function aa(a, b, c) {
    return a.call.apply(a.bind, arguments);
  },
      ba = function ba(a, b, c) {
    if (!a) throw Error();if (2 < arguments.length) {
      var d = Array.prototype.slice.call(arguments, 2);return function () {
        var c = Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c, d);return a.apply(b, c);
      };
    }return function () {
      return a.apply(b, arguments);
    };
  },
      _ca = function ca(a, b, c) {
    _ca = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? aa : ba;return _ca.apply(null, arguments);
  },
      da = function da(a, b) {
    function c() {}c.prototype = b.prototype;a.ea = b.prototype;a.prototype = new c();a.prototype.constructor = a;a.w = function (a, c, f) {
      for (var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++) {
        d[e - 2] = arguments[e];
      }return b.prototype[c].apply(a, d);
    };
  }; /*
     gapi.loader.OBJECT_CREATE_TEST_OVERRIDE &&*/
  var p = window,
      t = document,
      ea = p.location,
      fa = function fa() {},
      ha = /\[native code\]/,
      v = function v(a, b, c) {
    return a[b] = a[b] || c;
  },
      ia = function ia(a) {
    for (var b = 0; b < this.length; b++) {
      if (this[b] === a) return b;
    }return -1;
  },
      ja = function ja(a) {
    a = a.sort();for (var b = [], c = void 0, d = 0; d < a.length; d++) {
      var e = a[d];e != c && b.push(e);c = e;
    }return b;
  },
      ka = /&/g,
      la = /</g,
      ma = />/g,
      na = /"/g,
      oa = /'/g,
      pa = function pa(a) {
    return String(a).replace(ka, "&amp;").replace(la, "&lt;").replace(ma, "&gt;").replace(na, "&quot;").replace(oa, "&#39;");
  },
      w = function w() {
    var a;if ((a = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_create___default.a) && ha.test(a)) a = a(null);else {
      a = {};for (var b in a) {
        a[b] = void 0;
      }
    }return a;
  },
      x = function x(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  },
      qa = function qa(a) {
    if (ha.test(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default.a)) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(a);var b = [],
        c;for (c in a) {
      x(a, c) && b.push(c);
    }return b;
  },
      z = function z(a, b) {
    a = a || {};for (var c in a) {
      x(a, c) && (b[c] = a[c]);
    }
  },
      ra = function ra(a) {
    return function () {
      p.setTimeout(a, 0);
    };
  },
      A = function A(a, b) {
    if (!a) throw Error(b || "");
  },
      B = v(p, "gapi", {});var C = function C(a, b, c) {
    var d = new RegExp("([#].*&|[#])" + b + "=([^&#]*)", "g");b = new RegExp("([?#].*&|[?#])" + b + "=([^&#]*)", "g");if (a = a && (d.exec(a) || b.exec(a))) try {
      c = decodeURIComponent(a[2]);
    } catch (e) {}return c;
  },
      sa = new RegExp(/^/.source + /([a-zA-Z][-+.a-zA-Z0-9]*:)?/.source + /(\/\/[^\/?#]*)?/.source + /([^?#]*)?/.source + /(\?([^#]*))?/.source + /(#((#|[^#])*))?/.source + /$/.source),
      ta = /[\ud800-\udbff][\udc00-\udfff]|[^!-~]/g,
      ua = new RegExp(/(%([^0-9a-fA-F%]|[0-9a-fA-F]([^0-9a-fA-F%])?)?)*/.source + /%($|[^0-9a-fA-F]|[0-9a-fA-F]($|[^0-9a-fA-F]))/.source, "g"),
      va = /%([a-f]|[0-9a-fA-F][a-f])/g,
      wa = /^(https?|ftp|file|chrome-extension):$/i,
      D = function D(a) {
    a = String(a);a = a.replace(ta, function (a) {
      try {
        return encodeURIComponent(a);
      } catch (f) {
        return encodeURIComponent(a.replace(/^[^%]+$/g, "\uFFFD"));
      }
    }).replace(ua, function (a) {
      return a.replace(/%/g, "%25");
    }).replace(va, function (a) {
      return a.toUpperCase();
    });a = a.match(sa) || [];var b = w(),
        c = function c(a) {
      return a.replace(/\\/g, "%5C").replace(/\^/g, "%5E").replace(/`/g, "%60").replace(/\{/g, "%7B").replace(/\|/g, "%7C").replace(/\}/g, "%7D");
    },
        d = !!(a[1] || "").match(wa);b.w = c((a[1] || "") + (a[2] || "") + (a[3] || (a[2] && d ? "/" : "")));d = function d(a) {
      return c(a.replace(/\?/g, "%3F").replace(/#/g, "%23"));
    };b.query = a[5] ? [d(a[5])] : [];b.g = a[7] ? [d(a[7])] : [];return b;
  },
      xa = function xa(a) {
    return a.w + (0 < a.query.length ? "?" + a.query.join("&") : "") + (0 < a.g.length ? "#" + a.g.join("&") : "");
  },
      ya = function ya(a, b) {
    var c = [];if (a) for (var d in a) {
      if (x(a, d) && null != a[d]) {
        var e = b ? b(a[d]) : a[d];c.push(encodeURIComponent(d) + "=" + encodeURIComponent(e));
      }
    }return c;
  },
      za = function za(a, b, c, d) {
    a = D(a);
    a.query.push.apply(a.query, ya(b, d));a.g.push.apply(a.g, ya(c, d));return xa(a);
  },
      Ba = new RegExp(/\/?\??#?/.source + "(" + /[\/?#]/i.source + "|" + /[\uD800-\uDBFF]/i.source + "|" + /%[c-f][0-9a-f](%[89ab][0-9a-f]){0,2}(%[89ab]?)?/i.source + "|" + /%[0-9a-f]?/i.source + ")$", "i"),
      Ca = function Ca(a, b) {
    var c = D(b);b = c.w;c.query.length && (b += "?" + c.query.join(""));c.g.length && (b += "#" + c.g.join(""));var d = "";2E3 < b.length && (c = b, b = b.substr(0, 2E3), b = b.replace(Ba, ""), d = c.substr(b.length));var e = a.createElement("div");a = a.createElement("a");
    c = D(b);b = c.w;c.query.length && (b += "?" + c.query.join(""));c.g.length && (b += "#" + c.g.join(""));a.href = b;e.appendChild(a);e.innerHTML = e.innerHTML;b = String(e.firstChild.href);e.parentNode && e.parentNode.removeChild(e);c = D(b + d);b = c.w;c.query.length && (b += "?" + c.query.join(""));c.g.length && (b += "#" + c.g.join(""));return b;
  },
      Da = /^https?:\/\/[^\/%\\?#\s]+\/[^\s]*$/i;var Ea = function Ea(a, b, c, d) {
    if (p[c + "EventListener"]) p[c + "EventListener"](a, b, !1);else if (p[d + "tachEvent"]) p[d + "tachEvent"]("on" + a, b);
  },
      Fa = function Fa() {
    var a = t.readyState;return "complete" === a || "interactive" === a && -1 == navigator.userAgent.indexOf("MSIE");
  },
      Ia = function Ia(a) {
    var b = Ga;if (!Fa()) try {
      b();
    } catch (c) {}Ha(a);
  },
      Ha = function Ha(a) {
    if (Fa()) a();else {
      var b = !1,
          c = function c() {
        if (!b) return b = !0, a.apply(this, arguments);
      };p.addEventListener ? (p.addEventListener("load", c, !1), p.addEventListener("DOMContentLoaded", c, !1)) : p.attachEvent && (p.attachEvent("onreadystatechange", function () {
        Fa() && c.apply(this, arguments);
      }), p.attachEvent("onload", c));
    }
  },
      Ja = function Ja(a) {
    for (; a.firstChild;) {
      a.removeChild(a.firstChild);
    }
  },
      Ka = { button: !0, div: !0, span: !0 };var F;F = v(p, "___jsl", w());v(F, "I", 0);v(F, "hel", 10);var La = function La(a) {
    return F.dpo ? F.h : C(a, "jsh", F.h);
  },
      Ma = function Ma(a) {
    var b = v(F, "sws", []);b.push.apply(b, a);
  },
      Na = function Na(a) {
    return v(F, "watt", w())[a];
  },
      Oa = function Oa(a) {
    var b = v(F, "PQ", []);F.PQ = [];var c = b.length;if (0 === c) a();else for (var d = 0, e = function e() {
      ++d === c && a();
    }, f = 0; f < c; f++) {
      b[f](e);
    }
  },
      Pa = function Pa(a) {
    return v(v(F, "H", w()), a, w());
  };var Qa = v(F, "perf", w()),
      Ra = v(Qa, "g", w()),
      Sa = v(Qa, "i", w());v(Qa, "r", []);w();w();
  var Ta = function Ta(a, b, c) {
    var d = Qa.r;"function" === typeof d ? d(a, b, c) : d.push([a, b, c]);
  },
      G = function G(a, b, c) {
    Ra[a] = !b && Ra[a] || c || new Date().getTime();Ta(a);
  },
      Va = function Va(a, b, c) {
    b && 0 < b.length && (b = Ua(b), c && 0 < c.length && (b += "___" + Ua(c)), 28 < b.length && (b = b.substr(0, 28) + (b.length - 28)), c = b, b = v(Sa, "_p", w()), v(b, c, w())[a] = new Date().getTime(), Ta(a, "_p", c));
  },
      Ua = function Ua(a) {
    return a.join("__").replace(/\./g, "_").replace(/\-/g, "_").replace(/,/g, "_");
  };var Wa = w(),
      H = [],
      J = function J(a) {
    throw Error("Bad hint" + (a ? ": " + a : ""));
  };H.push(["jsl", function (a) {
    for (var b in a) {
      if (x(a, b)) {
        var c = a[b];"object" == (typeof c === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(c)) ? F[b] = v(F, b, []).concat(c) : v(F, b, c);
      }
    }if (b = a.u) a = v(F, "us", []), a.push(b), (b = /^https:(.*)$/.exec(b)) && a.push("http:" + b[1]);
  }]);var Xa = /^(\/[a-zA-Z0-9_\-]+)+$/,
      Ya = [/\/amp\//, /\/amp$/, /^\/amp$/],
      Za = /^[a-zA-Z0-9\-_\.,!]+$/,
      $a = /^gapi\.loaded_[0-9]+$/,
      ab = /^[a-zA-Z0-9,._-]+$/,
      eb = function eb(a, b, c, d) {
    var e = a.split(";"),
        f = e.shift(),
        g = Wa[f],
        h = null;g ? h = g(e, b, c, d) : J("no hint processor for: " + f);h || J("failed to generate load url");b = h;c = b.match(bb);(d = b.match(cb)) && 1 === d.length && db.test(b) && c && 1 === c.length || J("failed sanity: " + a);return h;
  },
      hb = function hb(a, b, c, d) {
    a = fb(a);$a.test(c) || J("invalid_callback");b = gb(b);d = d && d.length ? gb(d) : null;var e = function e(a) {
      return encodeURIComponent(a).replace(/%2C/g, ",");
    };return [encodeURIComponent(a.pathPrefix).replace(/%2C/g, ",").replace(/%2F/g, "/"), "/k=", e(a.version), "/m=", e(b), d ? "/exm=" + e(d) : "", "/rt=j/sv=1/d=1/ed=1", a.L ? "/am=" + e(a.L) : "", a.T ? "/rs=" + e(a.T) : "", a.V ? "/t=" + e(a.V) : "", "/cb=", e(c)].join("");
  },
      fb = function fb(a) {
    "/" !== a.charAt(0) && J("relative path");for (var b = a.substring(1).split("/"), c = []; b.length;) {
      a = b.shift();if (!a.length || 0 == a.indexOf(".")) J("empty/relative directory");else if (0 < a.indexOf("=")) {
        b.unshift(a);
        break;
      }c.push(a);
    }a = {};for (var d = 0, e = b.length; d < e; ++d) {
      var f = b[d].split("="),
          g = decodeURIComponent(f[0]),
          h = decodeURIComponent(f[1]);2 == f.length && g && h && (a[g] = a[g] || h);
    }b = "/" + c.join("/");Xa.test(b) || J("invalid_prefix");c = 0;for (d = Ya.length; c < d; ++c) {
      Ya[c].test(b) && J("invalid_prefix");
    }c = ib(a, "k", !0);d = ib(a, "am");e = ib(a, "rs");a = ib(a, "t");return { pathPrefix: b, version: c, L: d, T: e, V: a };
  },
      gb = function gb(a) {
    for (var b = [], c = 0, d = a.length; c < d; ++c) {
      var e = a[c].replace(/\./g, "_").replace(/-/g, "_");ab.test(e) && b.push(e);
    }return b.join(",");
  },
      ib = function ib(a, b, c) {
    a = a[b];!a && c && J("missing: " + b);if (a) {
      if (Za.test(a)) return a;J("invalid: " + b);
    }return null;
  },
      db = /^https?:\/\/[a-z0-9_.-]+\.google(rs)?\.com(:\d+)?\/[a-zA-Z0-9_.,!=\-\/]+$/,
      cb = /\/cb=/g,
      bb = /\/\//g,
      jb = function jb() {
    var a = La(ea.href);if (!a) throw Error("Bad hint");return a;
  };Wa.m = function (a, b, c, d) {
    (a = a[0]) || J("missing_hint");return "https://apis.google.com" + hb(a, b, c, d);
  };var K = decodeURI("%73cript"),
      kb = /^[-+_0-9\/A-Za-z]+={0,2}$/,
      lb = function lb(a, b) {
    for (var c = [], d = 0; d < a.length; ++d) {
      var e = a[d];e && 0 > ia.call(b, e) && c.push(e);
    }return c;
  },
      mb = function mb() {
    var a = F.nonce;if (void 0 !== a) return a && a === String(a) && a.match(kb) ? a : F.nonce = null;var b = v(F, "us", []);if (!b || !b.length) return F.nonce = null;for (var c = t.getElementsByTagName(K), d = 0, e = c.length; d < e; ++d) {
      var f = c[d];if (f.src && (a = String(f.nonce || f.getAttribute("nonce") || "") || null)) {
        for (var g = 0, h = b.length; g < h && b[g] !== f.src; ++g) {}if (g !== h && a && a === String(a) && a.match(kb)) return F.nonce = a;
      }
    }return null;
  },
      ob = function ob(a) {
    if ("loading" != t.readyState) nb(a);else {
      var b = mb(),
          c = "";null !== b && (c = ' nonce="' + b + '"');t.write("<" + K + ' src="' + encodeURI(a) + '"' + c + "></" + K + ">");
    }
  },
      nb = function nb(a) {
    var b = t.createElement(K);b.setAttribute("src", a);a = mb();null !== a && b.setAttribute("nonce", a);b.async = "true";(a = t.getElementsByTagName(K)[0]) ? a.parentNode.insertBefore(b, a) : (t.head || t.body || t.documentElement).appendChild(b);
  },
      pb = function pb(a, b) {
    var c = b && b._c;if (c) for (var d = 0; d < H.length; d++) {
      var e = H[d][0],
          f = H[d][1];f && x(c, e) && f(c[e], a, b);
    }
  },
      rb = function rb(a, b, c) {
    qb(function () {
      var c = b === La(ea.href) ? v(B, "_", w()) : w();c = v(Pa(b), "_", c);a(c);
    }, c);
  },
      L = function L(a, b) {
    var c = b || {};"function" == typeof b && (c = {}, c.callback = b);pb(a, c);b = a ? a.split(":") : [];var d = c.h || jb(),
        e = v(F, "ah", w());if (e["::"] && b.length) {
      a = [];for (var f = null; f = b.shift();) {
        var g = f.split(".");g = e[f] || e[g[1] && "ns:" + g[0] || ""] || d;var h = a.length && a[a.length - 1] || null,
            k = h;h && h.hint == g || (k = { hint: g, O: [] }, a.push(k));k.O.push(f);
      }var l = a.length;if (1 < l) {
        var q = c.callback;q && (c.callback = function () {
          0 == --l && q();
        });
      }for (; b = a.shift();) {
        sb(b.O, c, b.hint);
      }
    } else sb(b || [], c, d);
  },
      sb = function sb(a, b, c) {
    a = ja(a) || [];var d = b.callback,
        e = b.config,
        f = b.timeout,
        g = b.ontimeout,
        h = b.onerror,
        k = void 0;"function" == typeof h && (k = h);var l = null,
        q = !1;if (f && !g || !f && g) throw "Timeout requires both the timeout parameter and ontimeout parameter to be set";h = v(Pa(c), "r", []).sort();var n = v(Pa(c), "L", []).sort(),
        r = [].concat(h),
        u = function u(a, b) {
      if (q) return 0;p.clearTimeout(l);n.push.apply(n, y);var d = ((B || {}).config || {}).update;d ? d(e) : e && v(F, "cu", []).push(e);if (b) {
        Va("me0", a, r);try {
          rb(b, c, k);
        } finally {
          Va("me1", a, r);
        }
      }return 1;
    };0 < f && (l = p.setTimeout(function () {
      q = !0;g();
    }, f));var y = lb(a, n);if (y.length) {
      y = lb(a, h);var E = v(F, "CP", []),
          I = E.length;E[I] = function (a) {
        if (!a) return 0;Va("ml1", y, r);var b = function b(_b) {
          E[I] = null;u(y, a) && Oa(function () {
            d && d();_b();
          });
        },
            c = function c() {
          var a = E[I + 1];a && a();
        };0 < I && E[I - 1] ? E[I] = function () {
          b(c);
        } : b(c);
      };if (y.length) {
        var Aa = "loaded_" + F.I++;B[Aa] = function (a) {
          E[I](a);B[Aa] = null;
        };
        a = eb(c, y, "gapi." + Aa, h);h.push.apply(h, y);Va("ml0", y, r);b.sync || p.___gapisync ? ob(a) : nb(a);
      } else E[I](fa);
    } else u(y) && d && d();
  };var qb = function qb(a, b) {
    if (F.hee && 0 < F.hel) try {
      return a();
    } catch (c) {
      b && b(c), F.hel--, L("debug_error", function () {
        try {
          window.___jsl.hefn(c);
        } catch (d) {
          throw c;
        }
      });
    } else try {
      return a();
    } catch (c) {
      throw b && b(c), c;
    }
  };B.load = function (a, b) {
    return qb(function () {
      return L(a, b);
    });
  };var M = function M(a) {
    var b = window.___jsl = window.___jsl || {};b[a] = b[a] || [];return b[a];
  },
      N = function N(a) {
    var b = window.___jsl = window.___jsl || {};b.cfg = !a && b.cfg || {};return b.cfg;
  },
      tb = function tb(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(a)) && /\[native code\]/.test(a.push);
  },
      O = function O(a, b, c) {
    if (b && "object" === (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b))) for (var d in b) {
      !Object.prototype.hasOwnProperty.call(b, d) || c && "___goc" === d && "undefined" === typeof b[d] || (a[d] && b[d] && "object" === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(a[d]) && "object" === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b[d]) && !tb(a[d]) && !tb(b[d]) ? O(a[d], b[d]) : b[d] && "object" === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b[d]) ? (a[d] = tb(b[d]) ? [] : {}, O(a[d], b[d])) : a[d] = b[d]);
    }
  },
      ub = function ub(a) {
    if (a && !/^\s+$/.test(a)) {
      for (; 0 == a.charCodeAt(a.length - 1);) {
        a = a.substring(0, a.length - 1);
      }try {
        var b = window.JSON.parse(a);
      } catch (c) {}if ("object" === (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b))) return b;try {
        b = new Function("return (" + a + "\n)")();
      } catch (c) {}if ("object" === (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b))) return b;try {
        b = new Function("return ({" + a + "\n})")();
      } catch (c) {}return "object" === (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) ? b : {};
    }
  },
      vb = function vb(a, b) {
    var c = { ___goc: void 0 };a.length && a[a.length - 1] && Object.hasOwnProperty.call(a[a.length - 1], "___goc") && "undefined" === typeof a[a.length - 1].___goc && (c = a.pop());O(c, b);a.push(c);
  },
      wb = function wb(a) {
    N(!0);var b = window.___gcfg,
        c = M("cu"),
        d = window.___gu;b && b !== d && (vb(c, b), window.___gu = b);b = M("cu");var e = document.scripts || document.getElementsByTagName("script") || [];d = [];var f = [];f.push.apply(f, M("us"));for (var g = 0; g < e.length; ++g) {
      for (var h = e[g], k = 0; k < f.length; ++k) {
        h.src && 0 == h.src.indexOf(f[k]) && d.push(h);
      }
    }0 == d.length && 0 < e.length && e[e.length - 1].src && d.push(e[e.length - 1]);for (e = 0; e < d.length; ++e) {
      d[e].getAttribute("gapi_processed") || (d[e].setAttribute("gapi_processed", !0), (f = d[e]) ? (g = f.nodeType, f = 3 == g || 4 == g ? f.nodeValue : f.textContent || f.innerText || f.innerHTML || "") : f = void 0, (f = ub(f)) && b.push(f));
    }a && vb(c, a);d = M("cd");a = 0;for (b = d.length; a < b; ++a) {
      O(N(), d[a], !0);
    }d = M("ci");a = 0;for (b = d.length; a < b; ++a) {
      O(N(), d[a], !0);
    }a = 0;for (b = c.length; a < b; ++a) {
      O(N(), c[a], !0);
    }
  },
      P = function P(a) {
    var b = N();if (!a) return b;a = a.split("/");for (var c = 0, d = a.length; b && "object" === (typeof b === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(b)) && c < d; ++c) {
      b = b[a[c]];
    }return c === a.length && void 0 !== b ? b : void 0;
  },
      xb = function xb(a, b) {
    var c;
    if ("string" === typeof a) {
      var d = c = {};a = a.split("/");for (var e = 0, f = a.length; e < f - 1; ++e) {
        var g = {};d = d[a[e]] = g;
      }d[a[e]] = b;
    } else c = a;wb(c);
  };var yb = function yb() {
    var a = window.__GOOGLEAPIS;a && (a.googleapis && !a["googleapis.config"] && (a["googleapis.config"] = a.googleapis), v(F, "ci", []).push(a), window.__GOOGLEAPIS = void 0);
  };var zb = { apppackagename: 1, callback: 1, clientid: 1, cookiepolicy: 1, openidrealm: -1, includegrantedscopes: -1, requestvisibleactions: 1, scope: 1 },
      Ab = !1,
      Bb = w(),
      Cb = function Cb() {
    if (!Ab) {
      for (var a = document.getElementsByTagName("meta"), b = 0; b < a.length; ++b) {
        var c = a[b].name.toLowerCase();if (0 == c.lastIndexOf("google-signin-", 0)) {
          c = c.substring(14);var d = a[b].content;zb[c] && d && (Bb[c] = d);
        }
      }if (window.self !== window.top) {
        a = document.location.toString();for (var e in zb) {
          0 < zb[e] && (b = C(a, e, "")) && (Bb[e] = b);
        }
      }Ab = !0;
    }e = w();z(Bb, e);return e;
  },
      Db = function Db(a) {
    return !!(a.clientid && a.scope && a.callback);
  };var Eb = window.console,
      Fb = function Fb(a) {
    Eb && Eb.log && Eb.log(a);
  };var Gb = function Gb() {
    return !!F.oa;
  },
      Hb = function Hb() {};var Q = v(F, "rw", w()),
      Ib = function Ib(a) {
    for (var b in Q) {
      a(Q[b]);
    }
  },
      Jb = function Jb(a, b) {
    (a = Q[a]) && a.state < b && (a.state = b);
  };var Kb;var Lb = /^https?:\/\/(?:\w|[\-\.])+\.google\.(?:\w|[\-:\.])+(?:\/[^\?#]*)?\/u\/(\d)\//,
      Mb = /^https?:\/\/(?:\w|[\-\.])+\.google\.(?:\w|[\-:\.])+(?:\/[^\?#]*)?\/b\/(\d{10,21})\//,
      Nb = function Nb(a) {
    var b = P("googleapis.config/sessionIndex");"string" === typeof b && 254 < b.length && (b = null);null == b && (b = window.__X_GOOG_AUTHUSER);"string" === typeof b && 254 < b.length && (b = null);if (null == b) {
      var c = window.google;c && (b = c.authuser);
    }"string" === typeof b && 254 < b.length && (b = null);null == b && (a = a || window.location.href, b = C(a, "authuser") || null, null == b && (b = (b = a.match(Lb)) ? b[1] : null));if (null == b) return null;b = String(b);254 < b.length && (b = null);return b;
  },
      Ob = function Ob(a) {
    var b = P("googleapis.config/sessionDelegate");"string" === typeof b && 21 < b.length && (b = null);null == b && (b = (a = (a || window.location.href).match(Mb)) ? a[1] : null);if (null == b) return null;b = String(b);21 < b.length && (b = null);return b;
  };var Pb,
      R,
      S = void 0,
      T = function T(a) {
    try {
      return m.JSON.parse.call(m.JSON, a);
    } catch (b) {
      return !1;
    }
  },
      U = function U(a) {
    return Object.prototype.toString.call(a);
  },
      Qb = U(0),
      Rb = U(new Date(0)),
      Sb = U(!0),
      Tb = U(""),
      Ub = U({}),
      Vb = U([]),
      V = function V(a, b) {
    if (b) for (var c = 0, d = b.length; c < d; ++c) {
      if (a === b[c]) throw new TypeError("Converting circular structure to JSON");
    }d = typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(a);if ("undefined" !== d) {
      c = Array.prototype.slice.call(b || [], 0);c[c.length] = a;b = [];var e = U(a);if (null != a && "function" === typeof a.toJSON && (Object.prototype.hasOwnProperty.call(a, "toJSON") || (e !== Vb || a.constructor !== Array && a.constructor !== Object) && (e !== Ub || a.constructor !== Array && a.constructor !== Object) && e !== Tb && e !== Qb && e !== Sb && e !== Rb)) return V(a.toJSON.call(a), c);if (null == a) b[b.length] = "null";else if (e === Qb) a = Number(a), isNaN(a) || isNaN(a - a) ? a = "null" : -0 === a && 0 > 1 / a && (a = "-0"), b[b.length] = String(a);else if (e === Sb) b[b.length] = String(!!Number(a));else {
        if (e === Rb) return V(a.toISOString.call(a), c);if (e === Vb && U(a.length) === Qb) {
          b[b.length] = "[";var f = 0;for (d = Number(a.length) >> 0; f < d; ++f) {
            f && (b[b.length] = ","), b[b.length] = V(a[f], c) || "null";
          }b[b.length] = "]";
        } else if (e == Tb && U(a.length) === Qb) {
          b[b.length] = '"';f = 0;for (c = Number(a.length) >> 0; f < c; ++f) {
            d = String.prototype.charAt.call(a, f), e = String.prototype.charCodeAt.call(a, f), b[b.length] = "\b" === d ? "\\b" : "\f" === d ? "\\f" : "\n" === d ? "\\n" : "\r" === d ? "\\r" : "\t" === d ? "\\t" : "\\" === d || '"' === d ? "\\" + d : 31 >= e ? "\\u" + (e + 65536).toString(16).substr(1) : 32 <= e && 65535 >= e ? d : "\uFFFD";
          }b[b.length] = '"';
        } else if ("object" === d) {
          b[b.length] = "{";d = 0;for (f in a) {
            Object.prototype.hasOwnProperty.call(a, f) && (e = V(a[f], c), void 0 !== e && (d++ && (b[b.length] = ","), b[b.length] = V(f), b[b.length] = ":", b[b.length] = e));
          }b[b.length] = "}";
        } else return;
      }return b.join("");
    }
  },
      Wb = /[\0-\x07\x0b\x0e-\x1f]/,
      Xb = /^([^"]*"([^\\"]|\\.)*")*[^"]*"([^"\\]|\\.)*[\0-\x1f]/,
      Yb = /^([^"]*"([^\\"]|\\.)*")*[^"]*"([^"\\]|\\.)*\\[^\\\/"bfnrtu]/,
      Zb = /^([^"]*"([^\\"]|\\.)*")*[^"]*"([^"\\]|\\.)*\\u([0-9a-fA-F]{0,3}[^0-9a-fA-F])/,
      $b = /"([^\0-\x1f\\"]|\\[\\\/"bfnrt]|\\u[0-9a-fA-F]{4})*"/g,
      ac = /-?(0|[1-9][0-9]*)(\.[0-9]+)?([eE][-+]?[0-9]+)?/g,
      bc = /[ \t\n\r]+/g,
      cc = /[^"]:/,
      dc = /""/g,
      ec = /true|false|null/g,
      fc = /00/,
      gc = /[\{]([^0\}]|0[^:])/,
      hc = /(^|\[)[,:]|[,:](\]|\}|[,:]|$)/,
      ic = /[^\[,:][\[\{]/,
      jc = /^(\{|\}|\[|\]|,|:|0)+/,
      kc = /\u2028/g,
      lc = /\u2029/g,
      mc = function mc(a) {
    a = String(a);if (Wb.test(a) || Xb.test(a) || Yb.test(a) || Zb.test(a)) return !1;var b = a.replace($b, '""');b = b.replace(ac, "0");b = b.replace(bc, "");if (cc.test(b)) return !1;b = b.replace(dc, "0");b = b.replace(ec, "0");if (fc.test(b) || gc.test(b) || hc.test(b) || ic.test(b) || !b || (b = b.replace(jc, ""))) return !1;a = a.replace(kc, "\\u2028").replace(lc, "\\u2029");b = void 0;try {
      b = S ? [T(a)] : eval("(function (var_args) {\n  return Array.prototype.slice.call(arguments, 0);\n})(\n" + a + "\n)");
    } catch (c) {
      return !1;
    }return b && 1 === b.length ? b[0] : !1;
  },
      nc = function nc() {
    var a = ((m.document || {}).scripts || []).length;if ((void 0 === Pb || void 0 === S || R !== a) && -1 !== R) {
      Pb = S = !1;R = -1;try {
        try {
          S = !!m.JSON && '{"a":[3,true,"1970-01-01T00:00:00.000Z"]}' === m.JSON.stringify.call(m.JSON, { a: [3, !0, new Date(0)], c: function c() {} }) && !0 === T("true") && 3 === T('[{"a":3}]')[0].a;
        } catch (b) {}Pb = S && !T("[00]") && !T("\"\x07\"") && !T('"\\0"') && !T('"\\v"');
      } finally {
        R = a;
      }
    }
  },
      oc = function oc(a) {
    if (-1 === R) return !1;nc();return (Pb ? T : mc)(a);
  },
      pc = function pc(a) {
    if (-1 !== R) return nc(), S ? m.JSON.stringify.call(m.JSON, a) : V(a);
  },
      qc = !Date.prototype.toISOString || "function" !== typeof Date.prototype.toISOString || "1970-01-01T00:00:00.000Z" !== new Date(0).toISOString(),
      rc = function rc() {
    var a = Date.prototype.getUTCFullYear.call(this);return [0 > a ? "-" + String(1E6 - a).substr(1) : 9999 >= a ? String(1E4 + a).substr(1) : "+" + String(1E6 + a).substr(1), "-", String(101 + Date.prototype.getUTCMonth.call(this)).substr(1), "-", String(100 + Date.prototype.getUTCDate.call(this)).substr(1), "T", String(100 + Date.prototype.getUTCHours.call(this)).substr(1), ":", String(100 + Date.prototype.getUTCMinutes.call(this)).substr(1), ":", String(100 + Date.prototype.getUTCSeconds.call(this)).substr(1), ".", String(1E3 + Date.prototype.getUTCMilliseconds.call(this)).substr(1), "Z"].join("");
  };Date.prototype.toISOString = qc ? rc : Date.prototype.toISOString;var sc = function sc() {
    this.j = -1;
  };var W = function W() {
    this.j = 64;this.b = [];this.F = [];this.W = [];this.B = [];this.B[0] = 128;for (var a = 1; a < this.j; ++a) {
      this.B[a] = 0;
    }this.C = this.o = 0;this.reset();
  };da(W, sc);W.prototype.reset = function () {
    this.b[0] = 1732584193;this.b[1] = 4023233417;this.b[2] = 2562383102;this.b[3] = 271733878;this.b[4] = 3285377520;this.C = this.o = 0;
  };
  var tc = function tc(a, b, c) {
    c || (c = 0);var d = a.W;if ("string" == typeof b) for (var e = 0; 16 > e; e++) {
      d[e] = b.charCodeAt(c) << 24 | b.charCodeAt(c + 1) << 16 | b.charCodeAt(c + 2) << 8 | b.charCodeAt(c + 3), c += 4;
    } else for (e = 0; 16 > e; e++) {
      d[e] = b[c] << 24 | b[c + 1] << 16 | b[c + 2] << 8 | b[c + 3], c += 4;
    }for (e = 16; 80 > e; e++) {
      var f = d[e - 3] ^ d[e - 8] ^ d[e - 14] ^ d[e - 16];d[e] = (f << 1 | f >>> 31) & 4294967295;
    }b = a.b[0];c = a.b[1];var g = a.b[2],
        h = a.b[3],
        k = a.b[4];for (e = 0; 80 > e; e++) {
      if (40 > e) {
        if (20 > e) {
          f = h ^ c & (g ^ h);var l = 1518500249;
        } else f = c ^ g ^ h, l = 1859775393;
      } else 60 > e ? (f = c & g | h & (c | g), l = 2400959708) : (f = c ^ g ^ h, l = 3395469782);f = (b << 5 | b >>> 27) + f + k + l + d[e] & 4294967295;k = h;h = g;g = (c << 30 | c >>> 2) & 4294967295;c = b;b = f;
    }a.b[0] = a.b[0] + b & 4294967295;a.b[1] = a.b[1] + c & 4294967295;a.b[2] = a.b[2] + g & 4294967295;a.b[3] = a.b[3] + h & 4294967295;a.b[4] = a.b[4] + k & 4294967295;
  };
  W.prototype.update = function (a, b) {
    if (null != a) {
      void 0 === b && (b = a.length);for (var c = b - this.j, d = 0, e = this.F, f = this.o; d < b;) {
        if (0 == f) for (; d <= c;) {
          tc(this, a, d), d += this.j;
        }if ("string" == typeof a) for (; d < b;) {
          if (e[f] = a.charCodeAt(d), ++f, ++d, f == this.j) {
            tc(this, e);f = 0;break;
          }
        } else for (; d < b;) {
          if (e[f] = a[d], ++f, ++d, f == this.j) {
            tc(this, e);f = 0;break;
          }
        }
      }this.o = f;this.C += b;
    }
  };
  W.prototype.digest = function () {
    var a = [],
        b = 8 * this.C;56 > this.o ? this.update(this.B, 56 - this.o) : this.update(this.B, this.j - (this.o - 56));for (var c = this.j - 1; 56 <= c; c--) {
      this.F[c] = b & 255, b /= 256;
    }tc(this, this.F);for (c = b = 0; 5 > c; c++) {
      for (var d = 24; 0 <= d; d -= 8) {
        a[b] = this.b[c] >> d & 255, ++b;
      }
    }return a;
  };var uc = function uc() {
    this.J = new W();
  };uc.prototype.reset = function () {
    this.J.reset();
  };var vc = p.crypto,
      wc = !1,
      xc = 0,
      yc = 0,
      zc = 1,
      Ac = 0,
      Bc = "",
      Cc = function Cc(a) {
    a = a || p.event;var b = a.screenX + a.clientX << 16;b += a.screenY + a.clientY;b *= new Date().getTime() % 1E6;zc = zc * b % Ac;0 < xc && ++yc == xc && Ea("mousemove", Cc, "remove", "de");
  },
      Dc = function Dc(a) {
    var b = new uc();a = unescape(encodeURIComponent(a));for (var c = [], d = 0, e = a.length; d < e; ++d) {
      c.push(a.charCodeAt(d));
    }b.J.update(c);b = b.J.digest();a = "";for (c = 0; c < b.length; c++) {
      a += "0123456789ABCDEF".charAt(Math.floor(b[c] / 16)) + "0123456789ABCDEF".charAt(b[c] % 16);
    }return a;
  };
  wc = !!vc && "function" == typeof vc.getRandomValues;wc || (Ac = 1E6 * (screen.width * screen.width + screen.height), Bc = Dc(t.cookie + "|" + t.location + "|" + new Date().getTime() + "|" + Math.random()), xc = P("random/maxObserveMousemove") || 0, 0 != xc && Ea("mousemove", Cc, "add", "at"));var Ec = function Ec() {
    var a = zc;a += parseInt(Bc.substr(0, 20), 16);Bc = Dc(Bc);return a / (Ac + Math.pow(16, 20));
  },
      Fc = function Fc() {
    var a = new p.Uint32Array(1);vc.getRandomValues(a);return Number("0." + a[0]);
  };var Gc = function Gc() {
    var a = F.onl;if (!a) {
      a = w();F.onl = a;var b = w();a.e = function (a) {
        var c = b[a];c && (delete b[a], c());
      };a.a = function (a, d) {
        b[a] = d;
      };a.r = function (a) {
        delete b[a];
      };
    }return a;
  },
      Hc = function Hc(a, b) {
    b = b.onload;return "function" === typeof b ? (Gc().a(a, b), b) : null;
  },
      Ic = function Ic(a) {
    A(/^\w+$/.test(a), "Unsupported id - " + a);Gc();return 'onload="window.___jsl.onl.e(&#34;' + a + '&#34;)"';
  },
      Jc = function Jc(a) {
    Gc().r(a);
  };var Kc = { allowtransparency: "true", frameborder: "0", hspace: "0", marginheight: "0", marginwidth: "0", scrolling: "no", style: "", tabindex: "0", vspace: "0", width: "100%" },
      Lc = { allowtransparency: !0, onload: !0 },
      Mc = 0,
      Nc = function Nc(a) {
    A(!a || Da.test(a), "Illegal url for new iframe - " + a);
  },
      Oc = function Oc(a, b, c, d, e) {
    Nc(c.src);var f,
        g = Hc(d, c),
        h = g ? Ic(d) : "";try {
      document.all && (f = a.createElement('<iframe frameborder="' + pa(String(c.frameborder)) + '" scrolling="' + pa(String(c.scrolling)) + '" ' + h + ' name="' + pa(String(c.name)) + '"/>'));
    } catch (l) {} finally {
      f || (f = a.createElement("iframe"), g && (f.onload = function () {
        f.onload = null;g.call(this);
      }, Jc(d)));
    }f.setAttribute("ng-non-bindable", "");for (var k in c) {
      a = c[k], "style" === k && "object" === (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(a)) ? z(a, f.style) : Lc[k] || f.setAttribute(k, String(a));
    }(k = e && e.beforeNode || null) || e && e.dontclear || Ja(b);b.insertBefore(f, k);f = k ? k.previousSibling : b.lastChild;c.allowtransparency && (f.allowTransparency = !0);return f;
  };var Pc = /^:[\w]+$/,
      Qc = /:([a-zA-Z_]+):/g,
      Rc = function Rc() {
    var a = Nb() || "0",
        b = Ob();var c = Nb(void 0) || a;var d = Ob(void 0),
        e = "";c && (e += "u/" + encodeURIComponent(String(c)) + "/");d && (e += "b/" + encodeURIComponent(String(d)) + "/");c = e || null;(e = (d = !1 === P("isLoggedIn")) ? "_/im/" : "") && (c = "");var f = P("iframes/:socialhost:"),
        g = P("iframes/:im_socialhost:");return Kb = { socialhost: f, ctx_socialhost: d ? g : f, session_index: a, session_delegate: b, session_prefix: c, im_prefix: e };
  },
      Sc = function Sc(a, b) {
    return Rc()[b] || "";
  },
      Tc = function Tc(a) {
    return function (b, c) {
      return a ? Rc()[c] || a[c] || "" : Rc()[c] || "";
    };
  };var Uc = function Uc(a) {
    var b;a.match(/^https?%3A/i) && (b = decodeURIComponent(a));return Ca(document, b ? b : a);
  },
      Vc = function Vc(a) {
    a = a || "canonical";for (var b = document.getElementsByTagName("link"), c = 0, d = b.length; c < d; c++) {
      var e = b[c],
          f = e.getAttribute("rel");if (f && f.toLowerCase() == a && (e = e.getAttribute("href")) && (e = Uc(e)) && null != e.match(/^https?:\/\/[\w\-_\.]+/i)) return e;
    }return window.location.href;
  };var Wc = { se: "0" },
      Xc = { post: !0 },
      Yc = { style: "position:absolute;top:-10000px;width:450px;margin:0px;border-style:none" },
      Zc = "onPlusOne _ready _close _open _resizeMe _renderstart oncircled drefresh erefresh".split(" "),
      $c = v(F, "WI", w()),
      ad = function ad(a, b, c) {
    var d;var e = {};var f = d = a;"plus" == a && b.action && (d = a + "_" + b.action, f = a + "/" + b.action);(d = P("iframes/" + d + "/url")) || (d = ":im_socialhost:/:session_prefix::im_prefix:_/widget/render/" + f + "?usegapi=1");for (var g in Wc) {
      e[g] = g + "/" + (b[g] || Wc[g]) + "/";
    }e = Ca(t, d.replace(Qc, Tc(e)));g = "iframes/" + a + "/params/";f = {};z(b, f);(d = P("lang") || P("gwidget/lang")) && (f.hl = d);Xc[a] || (f.origin = window.location.origin || window.location.protocol + "//" + window.location.host);f.exp = P(g + "exp");if (g = P(g + "location")) for (d = 0; d < g.length; d++) {
      var h = g[d];f[h] = p.location[h];
    }switch (a) {case "plus":case "follow":
        g = f.href;d = b.action ? void 0 : "publisher";g = (g = "string" == typeof g ? g : void 0) ? Uc(g) : Vc(d);f.url = g;delete f.href;break;case "plusone":
        g = (g = b.href) ? Uc(g) : Vc();f.url = g;g = b.db;d = P();null == g && d && (g = d.db, null == g && (g = d.gwidget && d.gwidget.db));f.db = g || void 0;g = b.ecp;d = P();null == g && d && (g = d.ecp, null == g && (g = d.gwidget && d.gwidget.ecp));f.ecp = g || void 0;delete f.href;break;case "signin":
        f.url = Vc();}F.ILI && (f.iloader = "1");delete f["data-onload"];delete f.rd;for (var k in Wc) {
      f[k] && delete f[k];
    }f.gsrc = P("iframes/:source:");k = P("inline/css");"undefined" !== typeof k && 0 < c && k >= c && (f.ic = "1");k = /^#|^fr-/;c = {};for (var l in f) {
      x(f, l) && k.test(l) && (c[l.replace(k, "")] = f[l], delete f[l]);
    }l = "q" == P("iframes/" + a + "/params/si") ? f : c;k = Cb();for (var q in k) {
      !x(k, q) || x(f, q) || x(c, q) || (l[q] = k[q]);
    }q = [].concat(Zc);(l = P("iframes/" + a + "/methods")) && "object" === (typeof l === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(l)) && ha.test(l.push) && (q = q.concat(l));for (var n in b) {
      x(b, n) && /^on/.test(n) && ("plus" != a || "onconnect" != n) && (q.push(n), delete f[n]);
    }delete f.callback;c._methods = q.join(",");return za(e, f, c);
  },
      bd = ["style", "data-gapiscan"],
      dd = function dd(a) {
    for (var b = w(), c = 0 != a.nodeName.toLowerCase().indexOf("g:"), d = 0, e = a.attributes.length; d < e; d++) {
      var f = a.attributes[d],
          g = f.name,
          h = f.value;0 <= ia.call(bd, g) || c && 0 != g.indexOf("data-") || "null" === h || "specified" in f && !f.specified || (c && (g = g.substr(5)), b[g.toLowerCase()] = h);
    }a = a.style;(c = cd(a && a.height)) && (b.height = String(c));(a = cd(a && a.width)) && (b.width = String(a));return b;
  },
      cd = function cd(a) {
    var b = void 0;"number" === typeof a ? b = a : "string" === typeof a && (b = parseInt(a, 10));return b;
  },
      fd = function fd() {
    var a = F.drw;Ib(function (b) {
      if (a !== b.id && 4 != b.state && "share" != b.type) {
        var c = b.id,
            d = b.type,
            e = b.url;b = b.userParams;var f = t.getElementById(c);if (f) {
          var g = ad(d, b, 0);g ? (f = f.parentNode, e.replace(/#.*/, "").replace(/(\?|&)ic=1/, "") !== g.replace(/#.*/, "").replace(/(\?|&)ic=1/, "") && (b.dontclear = !0, b.rd = !0, b.ri = !0, b.type = d, ed(f, b), (d = Q[f.lastChild.id]) && (d.oid = c), Jb(c, 4))) : delete Q[c];
        } else delete Q[c];
      }
    });
  };var gd,
      hd,
      X,
      id,
      jd,
      kd = /(?:^|\s)g-((\S)*)(?:$|\s)/,
      ld = { plusone: !0, autocomplete: !0, profile: !0, signin: !0, signin2: !0 };gd = v(F, "SW", w());hd = v(F, "SA", w());X = v(F, "SM", w());id = v(F, "FW", []);jd = null;
  var nd = function nd(a, b) {
    md(void 0, !1, a, b);
  },
      md = function md(a, b, c, d) {
    G("ps0", !0);c = ("string" === typeof c ? document.getElementById(c) : c) || t;var e = t.documentMode;if (c.querySelectorAll && (!e || 8 < e)) {
      e = d ? [d] : qa(gd).concat(qa(hd)).concat(qa(X));for (var f = [], g = 0; g < e.length; g++) {
        var h = e[g];f.push(".g-" + h, "g\\:" + h);
      }e = c.querySelectorAll(f.join(","));
    } else e = c.getElementsByTagName("*");c = w();for (f = 0; f < e.length; f++) {
      g = e[f];var k = g;h = d;var l = k.nodeName.toLowerCase(),
          q = void 0;if (k.getAttribute("data-gapiscan")) h = null;else {
        var n = l.indexOf("g:");0 == n ? q = l.substr(2) : (n = (n = String(k.className || k.getAttribute("class"))) && kd.exec(n)) && (q = n[1]);h = !q || !(gd[q] || hd[q] || X[q]) || h && q !== h ? null : q;
      }h && (ld[h] || 0 == g.nodeName.toLowerCase().indexOf("g:") || 0 != qa(dd(g)).length) && (g.setAttribute("data-gapiscan", !0), v(c, h, []).push(g));
    }if (b) for (var r in c) {
      for (b = c[r], d = 0; d < b.length; d++) {
        b[d].setAttribute("data-onload", !0);
      }
    }for (var u in c) {
      id.push(u);
    }G("ps1", !0);if ((r = id.join(":")) || a) try {
      B.load(r, a);
    } catch (E) {
      Fb(E);return;
    }if (od(jd || {})) for (var y in c) {
      a = c[y];u = 0;for (b = a.length; u < b; u++) {
        a[u].removeAttribute("data-gapiscan");
      }pd(y);
    } else {
      d = [];for (y in c) {
        for (a = c[y], u = 0, b = a.length; u < b; u++) {
          e = a[u], qd(y, e, dd(e), d, b);
        }
      }rd(r, d);
    }
  },
      sd = function sd(a) {
    var b = v(B, a, {});b.go || (b.go = function (b) {
      return nd(b, a);
    }, b.render = function (b, d) {
      d = d || {};d.type = a;return ed(b, d);
    });
  },
      td = function td(a) {
    gd[a] = !0;
  },
      ud = function ud(a) {
    hd[a] = !0;
  },
      vd = function vd(a) {
    X[a] = !0;
  };var pd = function pd(a, b) {
    var c = Na(a);b && c ? (c(b), (c = b.iframeNode) && c.setAttribute("data-gapiattached", !0)) : B.load(a, function () {
      var c = Na(a),
          e = b && b.iframeNode,
          f = b && b.userParams;e && c ? (c(b), e.setAttribute("data-gapiattached", !0)) : (c = B[a].go, "signin2" == a ? c(e, f) : c(e && e.parentNode, f));
    });
  },
      od = function od() {
    return !1;
  },
      rd = function rd() {},
      qd = function qd(a, b, c, d, e, f, g) {
    switch (wd(b, a, f)) {case 0:
        a = X[a] ? a + "_annotation" : a;d = {};d.iframeNode = b;d.userParams = c;pd(a, d);break;case 1:
        if (b.parentNode) {
          for (var h in c) {
            if (f = x(c, h)) f = c[h], f = !!f && "object" === (typeof f === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(f)) && (!f.toString || f.toString === Object.prototype.toString || f.toString === Array.prototype.toString);if (f) try {
              c[h] = pc(c[h]);
            } catch (y) {
              delete c[h];
            }
          }f = !0;c.dontclear && (f = !1);delete c.dontclear;Hb();h = ad(a, c, e);e = g || {};e.allowPost = 1;e.attributes = Yc;e.dontclear = !f;g = {};g.userParams = c;g.url = h;g.type = a;if (c.rd) var k = b;else k = document.createElement("div"), b.setAttribute("data-gapistub", !0), k.style.cssText = "position:absolute;width:450px;left:-10000px;", b.parentNode.insertBefore(k, b);g.siteElement = k;k.id || (b = k, v($c, a, 0), f = "___" + a + "_" + $c[a]++, b.id = f);b = w();b[">type"] = a;z(c, b);f = h;c = k;h = e || {};b = h.attributes || {};A(!(h.allowPost || h.forcePost) || !b.onload, "onload is not supported by post iframe (allowPost or forcePost)");e = b = f;Pc.test(b) && (e = P("iframes/" + e.substring(1) + "/url"), A(!!e, "Unknown iframe url config for - " + b));f = Ca(t, e.replace(Qc, Sc));b = c.ownerDocument || t;k = 0;do {
            e = h.id || ["I", Mc++, "_", new Date().getTime()].join("");
          } while (b.getElementById(e) && 5 > ++k);A(5 > k, "Error creating iframe id");k = {};
          var l = {};b.documentMode && 9 > b.documentMode && (k.hostiemode = b.documentMode);z(h.queryParams || {}, k);z(h.fragmentParams || {}, l);var q = h.pfname;var n = w();P("iframes/dropLegacyIdParam") || (n.id = e);n._gfid = e;n.parent = b.location.protocol + "//" + b.location.host;var r = C(b.location.href, "parent");q = q || "";!q && r && (r = C(b.location.href, "_gfid", "") || C(b.location.href, "id", ""), q = C(b.location.href, "pfname", ""), q = r ? q + "/" + r : "");q || (r = oc(C(b.location.href, "jcp", ""))) && "object" == (typeof r === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(r)) && (q = (q = r.id) ? r.pfname + "/" + q : "");n.pfname = q;h.connectWithJsonParam && (r = {}, r.jcp = pc(n), n = r);r = C(f, "rpctoken") || k.rpctoken || l.rpctoken;r || (r = h.rpctoken || String(Math.round(1E8 * (wc ? Fc() : Ec()))), n.rpctoken = r);h.rpctoken = r;z(n, h.connectWithQueryParams ? k : l);r = b.location.href;n = w();(q = C(r, "_bsh", F.bsh)) && (n._bsh = q);(r = La(r)) && (n.jsh = r);h.hintInFragment ? z(n, l) : z(n, k);f = za(f, k, l, h.paramsSerializer);l = w();z(Kc, l);z(h.attributes, l);l.name = l.id = e;l.src = f;h.eurl = f;k = h || {};n = !!k.allowPost;if (k.forcePost || n && 2E3 < f.length) {
            k = D(f);l.src = "";l["data-postorigin"] = f;f = Oc(b, c, l, e);if (-1 != navigator.userAgent.indexOf("WebKit")) {
              var u = f.contentWindow.document;u.open();l = u.createElement("div");n = {};r = e + "_inner";n.name = r;n.src = "";n.style = "display:none";Oc(b, l, n, r, h);
            }l = (h = k.query[0]) ? h.split("&") : [];h = [];for (n = 0; n < l.length; n++) {
              r = l[n].split("=", 2), h.push([decodeURIComponent(r[0]), decodeURIComponent(r[1])]);
            }k.query = [];l = xa(k);A(Da.test(l), "Invalid URL: " + l);k = b.createElement("form");k.action = l;k.method = "POST";k.target = e;k.style.display = "none";for (e = 0; e < h.length; e++) {
              l = b.createElement("input"), l.type = "hidden", l.name = h[e][0], l.value = h[e][1], k.appendChild(l);
            }c.appendChild(k);k.submit();k.parentNode.removeChild(k);u && u.close();u = f;
          } else u = Oc(b, c, l, e, h);g.iframeNode = u;g.id = u.getAttribute("id");u = g.id;c = w();c.id = u;c.userParams = g.userParams;c.url = g.url;c.type = g.type;c.state = 1;Q[u] = c;u = g;
        } else u = null;u && ((g = u.id) && d.push(g), pd(a, u));}
  },
      wd = function wd(a, b, c) {
    if (a && 1 === a.nodeType && b) {
      if (c) return 1;if (X[b]) {
        if (Ka[a.nodeName.toLowerCase()]) return (a = a.innerHTML) && a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "") ? 0 : 1;
      } else {
        if (hd[b]) return 0;if (gd[b]) return 1;
      }
    }return null;
  },
      ed = function ed(a, b) {
    var c = b.type;delete b.type;var d = ("string" === typeof a ? document.getElementById(a) : a) || void 0;if (d) {
      a = {};for (var e in b) {
        x(b, e) && (a[e.toLowerCase()] = b[e]);
      }a.rd = 1;(b = !!a.ri) && delete a.ri;e = [];qd(c, d, a, e, 0, b, void 0);rd(c, e);
    } else Fb("string" === "gapi." + c + ".render: missing element " + (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(a)) ? a : "");
  };v(B, "platform", {}).go = nd;od = function od(a) {
    for (var b = ["_c", "jsl", "h"], c = 0; c < b.length && a; c++) {
      a = a[b[c]];
    }b = La(ea.href);return !a || 0 != a.indexOf("n;") && 0 != b.indexOf("n;") && a !== b;
  };rd = function rd(a, b) {
    xd(a, b);
  };var Ga = function Ga(a) {
    md(a, !0);
  },
      yd = function yd(a, b) {
    b = b || [];for (var c = 0; c < b.length; ++c) {
      a(b[c]);
    }for (a = 0; a < b.length; a++) {
      sd(b[a]);
    }
  };
  H.push(["platform", function (a, b, c) {
    jd = c;b && id.push(b);yd(td, a);yd(ud, c._c.annotation);yd(vd, c._c.bimodal);yb();wb();if ("explicit" != P("parsetags")) {
      Ma(a);Db(Cb()) && !P("disableRealtimeCallback") && Hb();if (c && (a = c.callback)) {
        var d = ra(a);delete c.callback;
      }Ia(function () {
        Ga(d);
      });
    }
  }]);B._pl = !0;var zd = function zd(a) {
    a = (a = Q[a]) ? a.oid : void 0;if (a) {
      var b = t.getElementById(a);b && b.parentNode.removeChild(b);delete Q[a];zd(a);
    }
  };var Ad = /^\{h:'/,
      Bd = /^!_/,
      Cd = "",
      xd = function xd(a, b) {
    function c() {
      Ea("message", d, "remove", "de");
    }function d(d) {
      var f = d.data,
          h = d.origin;if (Dd(f, b)) {
        var k = e;e = !1;k && G("rqe");Ed(a, function () {
          k && G("rqd");c();for (var a = v(F, "RPMQ", []), b = 0; b < a.length; b++) {
            a[b]({ data: f, origin: h });
          }
        });
      }
    }if (0 !== b.length) {
      Cd = C(ea.href, "pfname", "");var e = !0;Ea("message", d, "add", "at");L(a, c);
    }
  },
      Dd = function Dd(a, b) {
    a = String(a);if (Ad.test(a)) return !0;var c = !1;Bd.test(a) && (c = !0, a = a.substr(2));if (!/^\{/.test(a)) return !1;var d = oc(a);if (!d) return !1;
    a = d.f;if (d.s && a && -1 != ia.call(b, a)) {
      if ("_renderstart" === d.s || d.s === Cd + "/" + a + "::_renderstart") if (d = d.a && d.a[c ? 0 : 1], b = t.getElementById(a), Jb(a, 2), d && b && d.width && d.height) {
        a: {
          c = b.parentNode;a = d || {};if (Gb()) {
            var e = b.id;if (e) {
              d = (d = Q[e]) ? d.state : void 0;if (1 === d || 4 === d) break a;zd(e);
            }
          }(d = c.nextSibling) && d.getAttribute && d.getAttribute("data-gapistub") && (c.parentNode.removeChild(d), c.style.cssText = "");d = a.width;var f = a.height,
              g = c.style;g.textIndent = "0";g.margin = "0";g.padding = "0";g.background = "transparent";g.borderStyle = "none";g.cssFloat = "none";g.styleFloat = "none";g.lineHeight = "normal";g.fontSize = "1px";g.verticalAlign = "baseline";c = c.style;c.display = "inline-block";g = b.style;g.position = "static";g.left = "0";g.top = "0";g.visibility = "visible";d && (c.width = g.width = d + "px");f && (c.height = g.height = f + "px");a.verticalAlign && (c.verticalAlign = a.verticalAlign);e && Jb(e, 3);
        }b["data-csi-wdt"] = new Date().getTime();
      }return !0;
    }return !1;
  },
      Ed = function Ed(a, b) {
    L(a, b);
  };var Fd = function Fd(a, b) {
    this.H = a;a = b || {};this.Y = Number(a.maxAge) || 0;this.N = a.domain;this.R = a.path;this.Z = !!a.secure;
  },
      Gd = /^[-+/_=.:|%&a-zA-Z0-9@]*$/,
      Hd = /^[A-Z_][A-Z0-9_]{0,63}$/;Fd.prototype.read = function () {
    for (var a = this.H + "=", b = document.cookie.split(/;\s*/), c = 0; c < b.length; ++c) {
      var d = b[c];if (0 == d.indexOf(a)) return d.substr(a.length);
    }
  };
  Fd.prototype.write = function (a, b) {
    if (!Hd.test(this.H)) throw "Invalid cookie name";if (!Gd.test(a)) throw "Invalid cookie value";a = this.H + "=" + a;this.N && (a += ";domain=" + this.N);this.R && (a += ";path=" + this.R);b = "number" === typeof b ? b : this.Y;if (0 <= b) {
      var c = new Date();c.setSeconds(c.getSeconds() + b);a += ";expires=" + c.toUTCString();
    }this.Z && (a += ";secure");document.cookie = a;return !0;
  };Fd.prototype.clear = function () {
    this.write("", 0);
  };
  Fd.iterate = function (a) {
    for (var b = document.cookie.split(/;\s*/), c = 0; c < b.length; ++c) {
      var d = b[c].split("="),
          e = d.shift();a(e, d.join("="));
    }
  };var Id = function Id(a) {
    this.A = a;
  },
      Y = {};Id.prototype.read = function () {
    if (Y.hasOwnProperty(this.A)) return Y[this.A];
  };Id.prototype.write = function (a) {
    Y[this.A] = a;return !0;
  };Id.prototype.clear = function () {
    delete Y[this.A];
  };Id.iterate = function (a) {
    for (var b in Y) {
      Y.hasOwnProperty(b) && a(b, Y[b]);
    }
  };var Jd = "https:" === window.location.protocol,
      Kd = Jd || "http:" === window.location.protocol ? Fd : Id,
      Ld = function Ld(a) {
    var b = a.substr(1),
        c = "",
        d = window.location.hostname;if ("" !== b) {
      c = parseInt(b, 10);if (isNaN(c)) return null;b = d.split(".");if (b.length < c - 1) return null;b.length == c - 1 && (d = "." + d);
    } else d = "";return { i: "S" == a.charAt(0), domain: d, l: c };
  },
      Md = function Md() {
    var a,
        b = null;Kd.iterate(function (c, d) {
      0 === c.indexOf("G_AUTHUSER_") && (c = Ld(c.substring(11)), !a || c.i && !a.i || c.i == a.i && c.l > a.l) && (a = c, b = d);
    });return { X: a, D: b };
  };var Nd = function Nd(a) {
    if (0 !== a.indexOf("GCSC")) return null;var b = { P: !1 };a = a.substr(4);if (!a) return b;var c = a.charAt(0);a = a.substr(1);var d = a.lastIndexOf("_");if (-1 == d) return b;var e = Ld(a.substr(d + 1));if (null == e) return b;a = a.substring(0, d);if ("_" !== a.charAt(0)) return b;d = "E" === c && e.i;return !d && ("U" !== c || e.i) || d && !Jd ? b : { P: !0, i: d, ba: a.substr(1), domain: e.domain, l: e.l };
  },
      Od = function Od(a) {
    if (!a) return [];a = a.split("=");return a[1] ? a[1].split("|") : [];
  },
      Pd = function Pd(a) {
    a = a.split(":");return { clientId: a[0].split("=")[1],
      aa: Od(a[1]), da: Od(a[2]), ca: Od(a[3]) };
  },
      Qd = function Qd() {
    var a = Md(),
        b = a.X;a = a.D;if (null !== a) {
      var c;Kd.iterate(function (a, d) {
        (a = Nd(a)) && a.P && a.i == b.i && a.l == b.l && (c = d);
      });if (c) {
        var d = Pd(c),
            e = d && d.aa[Number(a)];d = d && d.clientId;if (e) return { D: a, $: e, clientId: d };
      }
    }return null;
  };var Z = function Z() {
    this.M = Rd;
  };Z.prototype.v = 0;Z.prototype.K = 2;Z.prototype.M = null;Z.prototype.G = !1;Z.prototype.U = function () {
    this.G || (this.v = 0, this.G = !0, this.S());
  };Z.prototype.S = function () {
    this.G && (this.M() ? this.v = this.K : this.v = Math.min(2 * (this.v || this.K), 120), window.setTimeout(_ca(this.S, this), 1E3 * this.v));
  };for (var Sd = 0; 64 > Sd; ++Sd) {}var Td = null;Gb = function Gb() {
    return F.oa = !0;
  };Hb = function Hb() {
    F.oa = !0;var a = Qd();(a = a && a.D) && xb("googleapis.config/sessionIndex", a);Td || (Td = v(F, "ss", new Z()));a = Td;a.U && a.U();
  };
  var Rd = function Rd() {
    var a = Qd(),
        b = a && a.$ || null,
        c = a && a.clientId;L("auth", { callback: function callback() {
        var a = p.gapi.auth,
            e = { client_id: c, session_state: b };a.checkSessionState(e, function (b) {
          var c = e.session_state,
              d = P("isLoggedIn");b = P("debug/forceIm") ? !1 : c && b || !c && !b;if (d = d != b) xb("isLoggedIn", b), Hb(), fd(), b || ((b = a.signOut) ? b() : (b = a.setToken) && b(null));b = Cb();var f = P("savedUserState");c = a._guss(b.cookiepolicy);f = f != c && "undefined" != typeof f;xb("savedUserState", c);(d || f) && Db(b) && !P("disableRealtimeCallback") && a._pimf(b, !0);
        });
      } });return !0;
  };G("bs0", !0, window.gapi._bs);G("bs1", !0);delete window.gapi._bs;
}).call(this);
gapi.load("client", { callback: window["start"], _c: { "jsl": { "ci": { "deviceType": "desktop", "oauth-flow": { "authUrl": "https://accounts.google.com/o/oauth2/auth", "proxyUrl": "https://accounts.google.com/o/oauth2/postmessageRelay", "disableOpt": true, "idpIframeUrl": "https://accounts.google.com/o/oauth2/iframe", "usegapi": false }, "debug": { "reportExceptionRate": 0.05, "forceIm": false, "rethrowException": false, "host": "https://apis.google.com" }, "enableMultilogin": true, "googleapis.config": { "auth": { "useFirstPartyAuthV2": true } }, "isPlusUser": false, "inline": { "css": 1 }, "disableRealtimeCallback": false, "drive_share": { "skipInitCommand": true }, "csi": { "rate": 0.01 }, "client": { "cors": false }, "isLoggedIn": true, "signInDeprecation": { "rate": 0.0 }, "include_granted_scopes": true, "llang": "en", "iframes": { "ytsubscribe": { "url": "https://www.youtube.com/subscribe_embed?usegapi=1" }, "plus_share": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix::se:_/+1/sharebutton?plusShare=true&usegapi=1" }, ":source:": "3p", "playemm": { "url": "https://play.google.com/work/embedded/search?usegapi=1&usegapi=1" }, "partnersbadge": { "url": "https://www.gstatic.com/partners/badge/templates/badge.html?usegapi=1" }, "dataconnector": { "url": "https://dataconnector.corp.google.com/:session_prefix:ui/widgetview?usegapi=1" }, "shortlists": { "url": "" }, "plus_followers": { "params": { "url": "" }, "url": ":socialhost:/_/im/_/widget/render/plus/followers?usegapi=1" }, "post": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix::im_prefix:_/widget/render/post?usegapi=1" }, "signin": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix:_/widget/render/signin?usegapi=1", "methods": ["onauth"] }, "donation": { "url": "https://onetoday.google.com/home/donationWidget?usegapi=1" }, "plusone": { "params": { "count": "", "size": "", "url": "" }, "url": ":socialhost:/:session_prefix::se:_/+1/fastbutton?usegapi=1" }, ":im_socialhost:": "https://plus.googleapis.com", "backdrop": { "url": "https://clients3.google.com/cast/chromecast/home/widget/backdrop?usegapi=1" }, "visibility": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix:_/widget/render/visibility?usegapi=1" }, "additnow": { "url": "https://apis.google.com/additnow/additnow.html?usegapi=1", "methods": ["launchurl"] }, ":signuphost:": "https://plus.google.com", "community": { "url": ":ctx_socialhost:/:session_prefix::im_prefix:_/widget/render/community?usegapi=1" }, "plus": { "url": ":socialhost:/:session_prefix:_/widget/render/badge?usegapi=1" }, "commentcount": { "url": ":socialhost:/:session_prefix:_/widget/render/commentcount?usegapi=1" }, "zoomableimage": { "url": "https://ssl.gstatic.com/microscope/embed/" }, "appfinder": { "url": "https://gsuite.google.com/:session_prefix:marketplace/appfinder?usegapi=1" }, "person": { "url": ":socialhost:/:session_prefix:_/widget/render/person?usegapi=1" }, "savetodrive": { "url": "https://drive.google.com/savetodrivebutton?usegapi=1", "methods": ["save"] }, "page": { "url": ":socialhost:/:session_prefix:_/widget/render/page?usegapi=1" }, "card": { "url": ":socialhost:/:session_prefix:_/hovercard/card" }, "youtube": { "params": { "location": ["search", "hash"] }, "url": ":socialhost:/:session_prefix:_/widget/render/youtube?usegapi=1", "methods": ["scroll", "openwindow"] }, "plus_circle": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix::se:_/widget/plus/circle?usegapi=1" }, "rbr_s": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix::se:_/widget/render/recobarsimplescroller" }, "udc_webconsentflow": { "params": { "url": "" }, "url": "https://myaccount.google.com/webconsent?usegapi=1" }, "savetoandroidpay": { "url": "https://androidpay.google.com/a/widget/save" }, "blogger": { "params": { "location": ["search", "hash"] }, "url": ":socialhost:/:session_prefix:_/widget/render/blogger?usegapi=1", "methods": ["scroll", "openwindow"] }, "evwidget": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix:_/events/widget?usegapi=1" }, "surveyoptin": { "url": "https://www.google.com/shopping/customerreviews/optin?usegapi=1" }, ":socialhost:": "https://apis.google.com", "hangout": { "url": "https://talkgadget.google.com/:session_prefix:talkgadget/_/widget" }, ":gplus_url:": "https://plus.google.com", "rbr_i": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix::se:_/widget/render/recobarinvitation" }, "share": { "url": ":socialhost:/:session_prefix::im_prefix:_/widget/render/share?usegapi=1" }, "comments": { "params": { "location": ["search", "hash"] }, "url": ":socialhost:/:session_prefix:_/widget/render/comments?usegapi=1", "methods": ["scroll", "openwindow"] }, "autocomplete": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix:_/widget/render/autocomplete" }, "ratingbadge": { "url": "https://www.google.com/shopping/customerreviews/badge?usegapi=1" }, "appcirclepicker": { "url": ":socialhost:/:session_prefix:_/widget/render/appcirclepicker" }, "follow": { "url": ":socialhost:/:session_prefix:_/widget/render/follow?usegapi=1" }, "sharetoclassroom": { "url": "https://www.gstatic.com/classroom/sharewidget/widget_stable.html?usegapi=1" }, "ytshare": { "params": { "url": "" }, "url": ":socialhost:/:session_prefix:_/widget/render/ytshare?usegapi=1" }, "family_creation": { "params": { "url": "" }, "url": "https://families.google.com/webcreation?usegapi=1&usegapi=1" }, "configurator": { "url": ":socialhost:/:session_prefix:_/plusbuttonconfigurator?usegapi=1" }, "savetowallet": { "url": "https://androidpay.google.com/a/widget/save" } } }, "h": "m;/_/scs/apps-static/_/js/k=oz.gapi.en.j5eA2OggHfc.O/m=__features__/am=AQ/rt=j/d=1/rs=AGLTcCMv9KPPcflLNWdRK9za8j9skel9nA", "u": "https://apis.google.com/js/client:platform.js?onload=start", "hee": true, "fp": "59aa8a51484ffc25b2dd8aabb93730d172a8c26f", "dpo": false }, "platform": ["additnow", "backdrop", "blogger", "comments", "commentcount", "community", "family_creation", "follow", "hangout", "page", "partnersbadge", "person", "playemm", "playreview", "plus", "plusone", "post", "savetoandroidpay", "savetodrive", "savetowallet", "shortlists", "signin2", "udc_webconsentflow", "visibility", "youtube", "ytsubscribe", "zoomableimage", "sharetoclassroom", "donation", "ratingbadge", "surveyoptin"], "fp": "59aa8a51484ffc25b2dd8aabb93730d172a8c26f", "annotation": ["interactivepost", "recobar", "signin2", "autocomplete", "profile"], "bimodal": ["signin", "share"] } });

/***/ }),

/***/ "3bC4":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "4Wcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('img',{staticClass:"image-main",attrs:{"src":__webpack_require__("gCcF"),"alt":""}}),_vm._v(" "),_c('h1',[_vm._v("Connect Savvy to Your Content 🚀")]),_vm._v(" "),_c('h2',[_vm._v("Use the Savvy integrations to securely search for files, emails and answers within them.")]),_vm._v(" "),_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v("\n    \"What are our brand guidelines?\"  ●  \n    \"Where is the privacy policy?\"  ●  \n    \"How do we issue a refund?\"\n  ")]),_vm._v(" "),(_vm.doneMessage)?_c('div',{staticClass:"done-message"},[_vm._v("\n    Thanks for connecting up your Google Drive! We're indexing your content right now and it'll be ready for you on Slack within a few minutes.\n  ")]):_vm._e(),_vm._v(" "),_c('connect',{attrs:{"services":_vm.services,"organisationID":_vm.organisationID,"autoService":_vm.autoService}}),_vm._v(" "),_c('img',{staticClass:"compliance",attrs:{"src":__webpack_require__("b2/t"),"alt":""}}),_vm._v(" "),_c('img',{staticClass:"compliance",attrs:{"src":__webpack_require__("YsCb"),"alt":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4fNz":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "69NR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['show', 'type', 'duration', 'title'],
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "6Pqw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_field_vue__ = __webpack_require__("y9AU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89c37828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_field_vue__ = __webpack_require__("alVV");
function injectStyle (ssrContext) {
  __webpack_require__("qkup")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_field_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89c37828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_field_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6a8q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_airship_js__ = __webpack_require__("cMp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__explorer_explorer_vue__ = __webpack_require__("IICg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__spinner_vue__ = __webpack_require__("spwi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__popup_panel_vue__ = __webpack_require__("bSwa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__connect_vue__ = __webpack_require__("KZDm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__explorer_ibutton_vue__ = __webpack_require__("r+yu");



var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














console.log('chrome.vue running');

__WEBPACK_IMPORTED_MODULE_2_loglevel___default.a.setLevel('debug');

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['sidebar', 'local', 'testing', 'Controller', 'authState', 'user', 'mode', 'parentError'],
  data: function data() {
    return {
      organisation: {},
      organisationID: '',
      orgLoading: false,
      error: null,
      plugin: true,
      logo: '/static/images/logo.png',
      pageCards: [], // ???
      cards: [], // ???
      // sidebar: true,
      justClicked: false,
      showConnectPanel: false,
      demoInfoPanel: this.mode === 'demo',
      services: [{
        title: 'Google Drive',
        id: 'gdrive',
        logo: '/static/images/icons/gdrive.png'
      }, {
        title: 'Trello',
        id: 'trello',
        logo: '/static/images/icons/trello.png'
      }, {
        title: 'Dropbox',
        id: 'dropbox',
        logo: '/static/images/icons/dropbox.png'
      }, {
        title: 'Gmail',
        id: 'gmail',
        logo: '/static/images/icons/gmail.png'
      }, {
        title: 'Asana',
        id: 'asana',
        logo: '/static/images/icons/asana.png',
        comingSoon: true
      }, {
        title: 'Sifter',
        id: 'sifter',
        logo: 'https://www.pcmag.com/sm/pcmagus/photo/default/sifterlogo6_14fe.png',
        comingSoon: true
      }, {
        title: 'Zoho',
        id: 'zoho',
        logo: 'https://d7uddx54veb4a.cloudfront.net/wp-content/uploads/2016/10/logo-zoho.png',
        comingSoon: true
      }, {
        title: 'Confluence',
        id: 'confluence',
        logo: 'https://wac-cdn.atlassian.com/dam/jcr:a22c9f02-b225-4e34-9f1d-e5ac0265e543/confluence_rgb_slate.png',
        comingSoon: true
      }]
    };
  },

  computed: {
    profileImage: function profileImage() {
      return this.user && this.user.auth && this.user.auth.photoURL ? this.user.auth.photoURL : '/static/images/profile.jpg'; // //static//
    },
    errorMessage: function errorMessage() {
      return _this.error && _this.error.length ? _this.error : _this.parentError && _this.parentError.message && _this.parentError.message.length ? _this.parentError.message : null;
    }
  },
  watch: {
    authState: function authState(val) {
      var _this2 = this;

      if (val === 'loggedIn') {
        this.airship.identify({
          type: 'User',
          id: this.user.uid,
          displayName: this.user.auth.emails ? this.user.auth.emails[0] : this.user.auth.email,
          attributes: {
            organisationID: this.user.data ? this.user.data.organisationID : '0'
          },
          group: {
            type: 'Organisation',
            id: this.user.data ? this.user.data.organisationID : '0'
          }
        }).then(function () {
          _this2.services.forEach(function (service) {
            console.log('integration-' + service.id);
            console.log(_this2.airship.isEnabled('integration-' + service.id));
            service.comingSoon = !_this2.airship.isEnabled('integration-' + service.id);
          });
        });
      }
    }
  },
  components: {
    BootstrapVue: __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_12__explorer_ibutton_vue__["a" /* default */],
    Explorer: __WEBPACK_IMPORTED_MODULE_8__explorer_explorer_vue__["a" /* default */],
    PopupPanel: __WEBPACK_IMPORTED_MODULE_10__popup_panel_vue__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_9__spinner_vue__["a" /* default */],
    Connect: __WEBPACK_IMPORTED_MODULE_11__connect_vue__["a" /* default */]
    // Connect: () => import('../connect.vue'),
  },
  created: function created(a) {
    var self = this;
    console.log('chrome.vue created');
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue__["a" /* default */]);
    this.airship = new __WEBPACK_IMPORTED_MODULE_4_airship_js__["a" /* default */]({ webApiKey: 'yqfb07697ad5lak33tu75docb2duty5f', envKey: 'ky4t3nn8vp56n169' });
    if (self.testing) {
      console.log('In Testing Mode!');
      self.organisation = {
        id: 'explaain'
        // } else if (self.plugin) {
        //   console.log('chrome.vue plugin')
        //   this.refreshUser()
        //   .then(res => {
        //     console.log('self.organisation:', self.organisation)
        //     console.log('self.authState', self.authState)
        //   })
        //   // self.fromPage()
      };
    }

    window.addEventListener('message', function (event) {
      // log.info(event.data.action)
      switch (event.data.action) {
        case 'setLoading':
          self.$emit('setLoading');
          break;
        case 'updatePageResults':
          __WEBPACK_IMPORTED_MODULE_2_loglevel___default.a.info(event.data);
          self.pageCards = event.data.data.pageResults;
          __WEBPACK_IMPORTED_MODULE_2_loglevel___default.a.info(self.pageCards);
          self.updateCards(self.pageCards, 'No cards found from page');
          break;
        case 'closingDrawer':
          __WEBPACK_IMPORTED_MODULE_2_loglevel___default.a.info('[frame] Closing Drawer!');
          window.scrollTo(0, 0);
          self.$emit('closingDrawer');
          break;
      }
    }, false);
  },
  methods: {
    forceUser: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(toForce) {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('Forcing');
                if (toForce === 'toggle') toForce = this.user.data.role === 'admin' ? 'member' : 'admin';
                _context.next = 4;
                return this.Controller.force({ user: toForce });

              case 4:
                user = _context.sent;

                console.log('forced:', user);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function forceUser(_x) {
        return _ref.apply(this, arguments);
      }

      return forceUser;
    }(),
    signIn: function signIn() {
      var self = this;
      console.log(self.Controller);
      self.Controller.signIn();
      self.justClicked = true;
    },
    signOut: function signOut() {
      this.Controller.signOut();
    },
    fromPage: function fromPage() {
      console.log('fromPage');
      var message = { action: 'getPageResults' };
      window.parent.postMessage(message, '*');
      this.$emit('setLoading');
    },
    updateCards: function updateCards(cards, noCardMessage) {
      console.log(cards);
      var data = {
        cards: cards,
        noCardMessage: noCardMessage
      };
      __WEBPACK_IMPORTED_MODULE_2_loglevel___default.a.debug(data);
      this.$emit('updateCards', data);
    },
    closeDrawer: function closeDrawer() {
      console.log('closeDrawer');
      var message = { action: 'closeDrawer' };
      window.parent.postMessage(message, '*');
    },
    showDemoInfoPanel: function showDemoInfoPanel() {
      this.demoInfoPanel = true;
    },
    hideDemoInfoPanel: function hideDemoInfoPanel() {
      this.demoInfoPanel = false;
    }
  }
});

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.42e9f64.png";

/***/ }),

/***/ "80oC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card shadow",class:{ highlight: _vm.highlight || _vm.card.highlight, editing: _vm.editing, loading: _vm.loading || _vm.card.loading, full: _vm.full },on:{"mouseover":_vm.cardMouseover,"mouseout":_vm.cardMouseout,"click":function($event){$event.stopPropagation();_vm.cardClick($event)}}},[_c('div',{staticClass:"buttons-top-right edit-buttons"},[(_vm.mode !== 'demo')?_c('ibutton',{staticClass:"small left delete",attrs:{"icon":"trash","text":"Delete","click":_vm.deleteCard}}):_vm._e(),_vm._v(" "),(!_vm.editing)?_c('ibutton',{staticClass:"small edit",class:{ right: _vm.mode !== 'demo' },attrs:{"icon":"pencil","text":"Edit","click":_vm.editCard}}):_vm._e(),_vm._v(" "),(!_vm.explaain)?_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard",value:(_vm.fullText),expression:"fullText"}],staticClass:"small copy",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();_vm.copy($event)}}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.copyIcon}}),_vm._v("Copy")]):_vm._e()],1),_vm._v(" "),(!_vm.fileFormat)?_c('section',{staticStyle:{"overflow":"hidden"},on:{"click":_vm.linkClick}},[_c('img',{staticClass:"file-icons",attrs:{"src":_vm.cardIcon,"alt":""}}),_vm._v(" "),(_vm.full && _vm.card.highlight)?_c('div',{staticClass:"label"},[(_vm.card.highlight)?_c('span',{staticClass:"top-hit"},[_c('icon',{attrs:{"name":"bolt"}}),_vm._v(" Top Hit")],1):_vm._e(),_c('span',{staticClass:"type"})]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('h3',{staticStyle:{"margin":"15px 10px 10px"}},[_vm._v("Enter your card details:")]):_vm._e(),_vm._v(" "),_c(_vm.format,{tag:"component",attrs:{"showPending":_vm.showPending,"content":_vm.content,"full":_vm.full,"allCards":_vm.allCards,"auth":_vm.auth,"position":_vm.position,"highlight":_vm.highlight,"editing":_vm.editing},on:{"update":_vm.update,"contentUpdate":_vm.contentUpdate,"cardletClick":_vm.cardletClick}}),_vm._v(" "),_c('spinner')],1):_vm._e(),_vm._v(" "),_vm._l((_vm.card.files),function(file, i){return (_vm.fileFormat)?_c('a',{staticClass:"file",on:{"click":function($event){$event.stopPropagation();_vm.fileClick(file)}}},[_c('div',{staticClass:"thumb",style:({backgroundImage: 'url(' + (file.thumbnail || '/static/images/thumbnail.png') + ')'})}),_vm._v(" "),_c('div',{staticClass:"name"},[(_vm.getFileIcon(file))?_c('img',{attrs:{"src":_vm.getFileIcon(file),"alt":""}}):_vm._e(),_vm._v(_vm._s(file.title)+"\n    ")])]):_vm._e()}),_vm._v(" "),(_vm.warningMessage)?_c('p',{staticClass:"message-block warning"},[_c('icon',{attrs:{"name":"exclamation-circle"}}),_vm._v(_vm._s(_vm.warningMessage)+"\n    "),(_vm.card.pendingDelete)?_c('ibutton',{staticClass:"small",attrs:{"icon":"close","text":"Cancel","click":_vm.cancelPendingDelete}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.errorMessage)?_c('p',{staticClass:"message-block error"},[_c('icon',{attrs:{"name":"exclamation-triangle"}}),_vm._v(_vm._s(_vm.errorMessage))],1):_vm._e(),_vm._v(" "),(_vm.full && _vm.card.extractedFrom)?_c('p',{staticClass:"extractedFrom"},[_vm._v("Extracted from "),_c('a',{attrs:{"href":_vm.card.extractedFrom.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.card.extractedFrom.title))])]):_vm._e(),_vm._v(" "),_c('footer',[(_vm.card.modified)?_c('p',{staticClass:"modified"},[(new Date() - _vm.card.modified*1000 < 6*604800000)?_c('icon',{attrs:{"name":"check"}}):_vm._e(),_vm._v(" Updated: "),_c('span',[_vm._v(_vm._s(_vm.lastUpdatedText))])],1):_vm._e(),_vm._v(" "),(_vm.full && _vm.content && Object.keys(_vm.content).length)?_c('topics',{attrs:{"topics":_vm.content.topics,"editing":_vm.editing},on:{"update":_vm.update}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"sources"},[(!_vm.fileFormat && _vm.card.files && _vm.card.files.length && _vm.card.files[0])?_c('div',{staticClass:"source-individual from"},[_c('p',[_vm._v("From:")]),_vm._v(" "),_vm._l((_vm.card.files),function(file, i){return _c('a',{staticClass:"source-link",on:{"click":function($event){$event.stopPropagation();_vm.fileClick(file)}}},[(_vm.getFileIcon(file))?_c('img',{attrs:{"src":_vm.getFileIcon(file),"alt":""}}):_vm._e(),_vm._v(_vm._s(file.title)+"\n        ")])})],2):_vm._e(),_vm._v(" "),(_vm.card.files && _vm.card.files.length && _vm.card.files[0])?_c('div',{staticClass:"source-individual in"},[_c('p',[_vm._v("In:")]),_vm._v(" "),_vm._l((_vm.card.files),function(file, i){return (_vm.card.files && _vm.card.files.length && _vm.card.files[0])?_c('a',{staticClass:"source-link",on:{"click":function($event){$event.stopPropagation();_vm.serviceClick(_vm.getService(_vm.card, file))}}},[(_vm.getService(_vm.card, file).icon)?_c('img',{attrs:{"src":_vm.getService(_vm.card, file).icon,"alt":""}}):_vm._e(),_vm._v(_vm._s(_vm.getService(_vm.card, file).name)+"\n        ")]):_vm._e()})],2):_vm._e()]),_vm._v(" "),(_vm.card.sources && _vm.card.sources.length)?_c('div',{staticClass:"sources"},[_vm._v("\n      Source"+_vm._s(_vm.card.sources.length > 1 ? 's' : '')+": "),_vm._l((_vm.card.sources),function(source, i){return _c('span',[_c('a',{attrs:{"href":source.url,"target":"_blank"}},[_vm._v(_vm._s(source.name))]),_vm._v(_vm._s(i < _vm.card.sources.length - 1 ? ', ' : ''))])})],2):_vm._e(),_vm._v(" "),(_vm.editing)?_c('div',{staticClass:"buttons save-buttons"},[_c('ibutton',{staticClass:"small left cancel",attrs:{"icon":"close","text":"Cancel","click":_vm.cancelEdit}}),_vm._v(" "),_c('ibutton',{staticClass:"small right save",attrs:{"icon":"check","text":_vm.userIsSavvy ? 'Save Card' : 'Submit for Approval',"click":_vm.saveEdit}})],1):_vm._e(),_vm._v(" "),(!_vm.editing && _vm.card.pendingContent && Object.keys(_vm.card.pendingContent).length)?_c('div',{staticClass:"pending-toggle"},[_c('toggle-button',{attrs:{"sync":true,"labels":true},model:{value:(_vm.showPending),callback:function ($$v) {_vm.showPending=$$v},expression:"showPending"}}),_vm._v(" "),_c('span',[_vm._v("Show Pending Changes")])],1):_vm._e()],1),_vm._v(" "),(_vm.userIsSavvy && _vm.card.pendingContent && Object.keys(_vm.card.pendingContent).length)?_c('div',{staticClass:"buttons small verify"},[_c('ibutton',{staticClass:"approve left",attrs:{"icon":"check","text":"Approve " + _vm.numberOfPendingChanges + " Change" + (_vm.numberOfPendingChanges > 1 ? 's' : ''),"click":_vm.verify,"clickProps":true}}),_vm._v(" "),_c('ibutton',{staticClass:"reject right",attrs:{"icon":"close","text":"Reject","click":_vm.verify,"clickProps":false}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer-logo"},[_vm._v(_vm._s(_vm.explaain ? 'Explaain' : 'Savvy'))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8KUl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

(function () {
  var opts = { "version": 1, "apiEndpoint": "https://api.trello.com", "authEndpoint": "https://trello.com", "intentEndpoint": "https://trello.com", "key": "40bf04080255c5fe6b5e9643a9b9011b" };
  var deferred,
      isFunction,
      isReady,
      ready,
      waitUntil,
      wrapper,
      slice = [].slice;
  wrapper = function wrapper(b, f, a) {
    var h, e, p, x, z, m, A, q, k, s, t, r, B, y, u, g, v, w;k = a.key;g = a.token;e = a.apiEndpoint;p = a.authEndpoint;A = a.intentEndpoint;v = a.version;z = e + "/" + v + "/";r = b.location;h = { version: function version() {
        return v;
      }, key: function key() {
        return k;
      }, setKey: function setKey(c) {
        k = c;
      }, token: function token() {
        return g;
      }, setToken: function setToken(c) {
        g = c;
      }, rest: function rest() {
        var c, b, n, d;b = arguments[0];c = 2 <= arguments.length ? slice.call(arguments, 1) : [];d = B(c);n = d[0];c = d[1];a = { url: "" + z + n, type: b, data: {}, dataType: "json", success: d[2], error: d[3] };k && (a.data.key = k);g && (a.data.token = g);null != c && f.extend(a.data, c);return f.ajax(a);
      }, authorized: function authorized() {
        return null != g;
      }, deauthorize: function deauthorize() {
        g = null;w("token", g);
      }, authorize: function authorize(c) {
        var l, n, d, e, k;a = f.extend(!0, { type: "redirect", persist: !0, interactive: !0, scope: { read: !0, write: !1, account: !1 }, expiration: "30days" }, c);c = /[&#]?token=([0-9a-f]{64})/;n = function n() {
          if (a.persist && null != g) return w("token", g);
        };a.persist && null == g && (g = y("token"));null == g && (g = null != (d = c.exec(r.hash)) ? d[1] : void 0);if (this.authorized()) return n(), r.hash = r.hash.replace(c, ""), "function" === typeof a.success ? a.success() : void 0;if (!a.interactive) return "function" === typeof a.error ? a.error() : void 0;e = function () {
          var b, c;b = a.scope;c = [];for (l in b) {
            (k = b[l]) && c.push(l);
          }return c;
        }().join(",");switch (a.type) {case "popup":
            (function () {
              var c, d, l, _f, k, m;waitUntil("authorized", function (c) {
                return function (c) {
                  return c ? (n(), "function" === typeof a.success ? a.success() : void 0) : "function" === typeof a.error ? a.error() : void 0;
                };
              }(this));d = b.screenX + (b.innerWidth - 420) / 2;m = b.screenY + (b.innerHeight - 470) / 2;l = null != (k = /^[a-z]+:\/\/[^\/]*/.exec(r)) ? k[0] : void 0;c = b.open(x({ return_url: l, callback_method: "postMessage", scope: e, expiration: a.expiration, name: a.name }), "trello", "width=420,height=470,left=" + d + ",top=" + m);_f = function f(a) {
                var d;a.origin === p && a.source === c && (null != (d = a.source) && d.close(), g = null != a.data && /[0-9a-f]{64}/.test(a.data) ? a.data : null, "function" === typeof b.removeEventListener && b.removeEventListener("message", _f, !1), isReady("authorized", h.authorized()));
              };return "function" === typeof b.addEventListener ? b.addEventListener("message", _f, !1) : void 0;
            })();break;default:
            b.location = x({ redirect_uri: r.href, callback_method: "fragment", scope: e, expiration: a.expiration, name: a.name });}
      }, addCard: function addCard(c, a) {
        var n, d;n = { mode: "popup", source: k || b.location.host };d = function d(a) {
          var d, _l, e;_l = function l(c) {
            var d;b.removeEventListener("message", _l);try {
              return d = JSON.parse(c.data), d.success ? a(null, d.card) : a(Error(d.error));
            } catch (e) {}
          };"function" === typeof b.addEventListener && b.addEventListener("message", _l, !1);d = b.screenX + (b.outerWidth - 500) / 2;e = b.screenY + (b.outerHeight - 600) / 2;return b.open(A + "/add-card?" + f.param(f.extend(n, c)), "trello", "width=500,height=600,left=" + d + ",top=" + e);
        };return null != a ? d(a) : b.Promise ? new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (c, a) {
          return d(function (b, d) {
            return b ? a(b) : c(d);
          });
        }) : d(function () {});
      } };s = ["GET", "PUT", "POST", "DELETE"];e = function e(c) {
      return h[c.toLowerCase()] = function () {
        return this.rest.apply(this, [c].concat(slice.call(arguments)));
      };
    };m = 0;for (q = s.length; m < q; m++) {
      u = s[m], e(u);
    }h.del = h["delete"];
    u = "actions cards checklists boards lists members organizations lists".split(" ");m = function m(c) {
      return h[c] = { get: function get(a, b, d, e) {
          return h.get(c + "/" + a, b, d, e);
        } };
    };q = 0;for (s = u.length; q < s; q++) {
      e = u[q], m(e);
    }b.Trello = h;x = function x(c) {
      return p + "/" + v + "/authorize?" + f.param(f.extend({ response_type: "token", key: k }, c));
    };B = function B(c) {
      var a, b, d;b = c[0];a = c[1];d = c[2];c = c[3];isFunction(a) && (c = d, d = a, a = {});b = b.replace(/^\/*/, "");return [b, a, d, c];
    };t = b.localStorage;null != t ? (y = function y(a) {
      return t["trello_" + a];
    }, w = function w(a, b) {
      if (null === b) return delete t["trello_" + a];try {
        return t["trello_" + a] = b;
      } catch (e) {}
    }) : y = w = function w() {};
  };deferred = {};ready = {};waitUntil = function waitUntil(b, f) {
    return null != ready[b] ? f(ready[b]) : (null != deferred[b] ? deferred[b] : deferred[b] = []).push(f);
  };isReady = function isReady(b, f) {
    var a, h, e, p;ready[b] = f;if (deferred[b]) for (h = deferred[b], delete deferred[b], e = 0, p = h.length; e < p; e++) {
      a = h[e], a(f);
    }
  };isFunction = function isFunction(b) {
    return "function" === typeof b;
  };wrapper(window, jQuery, opts);
})();

/***/ }),

/***/ "8LWO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cardlet_vue__ = __webpack_require__("t8wU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_explaain_search_js__ = __webpack_require__("Huz3");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['allCards', 'setCard', 'auth'],
  mixins: [__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["mixin"]],
  data: function data() {
    return {
      query: '',
      resultList: [],
      loading: false
    };
  },
  computed: {
    results: function results() {
      var self = this;
      return self.resultList.map(function (objectID) {
        return self.allCards[objectID];
      });
    }
  },
  components: {
    cardlet: __WEBPACK_IMPORTED_MODULE_2__cardlet_vue__["a" /* default */]
  },
  methods: {
    clearResults: function clearResults() {
      this.resultList = [];
    },
    selectResult: function selectResult(card) {
      this.clearResults();
      this.$emit('select', card);
    },
    search: function search() {
      console.log('searchsearchsearch');
      var self = this;
      self.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__plugins_explaain_search_js__["a" /* default */].searchCards(self.auth.user, self.query, 6).then(function (hits) {
        self.loading = false;
        self.resultList = hits.map(function (card) {
          return card.objectID;
        });
        hits.forEach(function (hit) {
          self.setCard(hit.objectID, hit);
        });
      }).catch(function (err) {
        console.log(err);
      });
    },
    searchTempLocal: function searchTempLocal() {
      var self = this;
      var hits = [{ 'intent': 'store', 'sender': '1627888800569309', 'listItems': ['620064670', '620064680', '620064690', '620064700'], 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117869, 'objectID': '619948630', 'description': 'Inject Meeting Notes' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117257, 'objectID': '620064700', 'description': 'Keep all signed timesheets and receipts' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117225, 'objectID': '620064690', 'description': 'Business model => pro version only' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426117152, 'objectID': '620064680', 'description': 'Languages' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508426116967, 'objectID': '620064670', 'description': 'Finish card creation & editing' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateCreated': 1508425700874, 'dateUpdated': 1508425700874, 'objectID': '651610261', 'description': 'Asdf' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'listItems': ['645331361', '610938240', '610473050'], 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421510702, 'objectID': '639442471', 'description': 'Here is a list' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421509549, 'objectID': '610938240', 'description': 'This is a brand new list' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421508835, 'objectID': '645331361', 'description': 'A serious item' }, { 'intent': 'storeMemory', 'sender': '1627888800569309', 'hasAttachments': false, 'userID': '1627888800569309', 'dateUpdated': 1508421508588, 'objectID': '610473050', 'description': 'Another list item' }];
      // self.cards = hits
      self.resultList = hits.map(function (card) {
        return card.objectID;
      });
      hits.forEach(function (hit) {
        self.setCard(hit.objectID, hit);
      });
    }
  }
});

/***/ }),

/***/ "8tDu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9SFg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9pb1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__field_vue__ = __webpack_require__("6Pqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list_vue__ = __webpack_require__("qK+6");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'full', 'allCards', 'position', 'editing'],
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__field_vue__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_1__list_vue__["a" /* default */]
  },
  methods: {
    update: function update(data) {
      this.$emit('update', data);
    },
    cardletClick: function cardletClick(card) {
      console.log('cardletClick (basic.vue)', card);
      this.$emit('cardletClick', card);
    }
  }
});

/***/ }),

/***/ "AwYf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


!function () {
  "use strict";
  function e(e, t, o) {
    var s;if ("undefined" != typeof XMLHttpRequest) s = new XMLHttpRequest();else for (var n = ["MSXML2.XmlHttp.5.0", "MSXML2.XmlHttp.4.0", "MSXML2.XmlHttp.3.0", "MSXML2.XmlHttp.2.0", "Microsoft.XmlHttp"], i = 0, r = n.length; r > i; i++) {
      try {
        s = new ActiveXObject(n[i]);break;
      } catch (l) {}
    }s.onreadystatechange = function () {
      4 === s.readyState && o(s);
    }, s.open("GET", e, !0), t && s.setRequestHeader && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(t).forEach(function (e, o) {
      s.setRequestHeader(e, t[e]);
    }), s.send("");
  }var t = !1;void 0 === window.Kloudless && (window.Kloudless = {}), window.Kloudless.baseUrl = "https://api.kloudless.com", window.Kloudless.apiVersion = "v1", window.Kloudless._authenticators = {}, window.Kloudless._authenticators_by_element = {}, window.Kloudless._authenticator_iframe = void 0, window.Kloudless._popup = void 0;var o = navigator.userAgent.toLowerCase(),
      s = !1,
      n = -1;-1 !== o.indexOf("msie") ? (s = !0, n = parseInt(o.split("msie")[1])) : -1 !== o.indexOf("trident/") && (s = !0, n = parseInt(o.split("rv:")[1])), window.addEventListener("message", function (e) {
    var o = "kloudless:";if (t && console.log("[DEBUG] Message received", e), e.origin !== window.Kloudless.baseUrl) return void console.log("[ERROR] Origin mismatch:", e);if (0 !== e.data.indexOf(o)) return void console.log("[ERROR] Namespace mismsatch:", e);var n = JSON.parse(e.data.substring(o.length));return "authentication" != n.type ? void console.log("[ERROR] Incorrect content type:", e) : (setTimeout(function () {
      var e = window.Kloudless._authenticators[n.id];e ? e.callback(n.data) : console.log("[ERROR] No Authenticator found for ID:", n.id);
    }, 0), s ? e.source.postMessage("kloudless:" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ type: "close" }), e.origin) : window.Kloudless._popup && (window.Kloudless._popup.close(), window.Kloudless._popup = void 0), void (t && console.log("[DEBUG] Confirmation sent", e.origin)));
  }, !1);var i = function i(e) {
    var t = "/services/";return "string" == typeof e.services && (e.services = [e.services]), void 0 === e.services ? t += "?" : 1 == e.services.length ? t += e.services[0] + "?" : e.services.length > 1 && (t += "?services=" + e.services.map(function (e) {
      return e.trim();
    }).join(",") + "&"), t += "app_id=" + e.app_id + "&admin=" + (e.admin ? 1 : "") + "&extra=" + (e.extra ? e.extra : "") + "&callback=&retrieve_account_key=", e.group && (t += "&group=" + e.group), e.edit_account && (t += "&edit_account=" + e.edit_account), e.developer && (t += "&developer=true"), t;
  },
      r = function r(e) {
    var t = "/" + window.Kloudless.apiVersion + "/oauth/?";return e.redirect_uri = "urn:ietf:wg:oauth:2.0:oob", e.response_type = "token", e.state = parseInt(Math.random() * Math.pow(10, 10)), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(e).forEach(function (o, s) {
      var n = e[o];"scopes" == o && n.join && (n = n.join(" ")), t += "&" + o + "=" + n;
    }), t;
  },
      l = function l() {
    if (void 0 === window.Kloudless._authenticator_iframe) {
      var e = document.createElement("iframe");e.setAttribute("id", "kloudless_iexd"), e.setAttribute("src", window.Kloudless.baseUrl + "/static/iexd.html"), e.style.display = "none", document.getElementsByTagName("body")[0].appendChild(e), window.Kloudless._authenticator_iframe = e;
    }
  },
      a = function a(e) {
    return function (t) {
      e(null, t);
    };
  },
      d = function d(t, o) {
    return function (s) {
      if (!s.state || s.state.toString() !== o.toString()) return t({ error: "invalid_state" });if (!s.access_token) return t(s);var n = { Authorization: "Bearer " + s.access_token };e(window.Kloudless.baseUrl + "/" + window.Kloudless.apiVersion + "/oauth/token/", n, function (o) {
        200 !== o.status && t(s);var i = JSON.parse(o.responseText).account_id;e(window.Kloudless.baseUrl + "/" + window.Kloudless.apiVersion + "/accounts/" + i + "/?retrieve_full=False", n, function (e) {
          200 === e.status && (s.account = JSON.parse(e.responseText)), t(s);
        });
      });
    };
  };window.Kloudless.authenticator = function (e, o, n) {
    if (l(), void 0 !== window.jQuery && e instanceof window.jQuery && (e = e.get(0)), e && !(e instanceof Element)) {
      if (n) throw new Error("'element' must be an Element or jQuery object.");n = o, o = e, e = null;
    }if (!o.client_id && !o.app_id) throw new Error("An App ID is required.");var u;o.app_id ? (u = i(o), n = a(n)) : (u = r(o), n = d(n, o.state));var c = parseInt(Math.random() * Math.pow(10, 10)),
        w = window.location.protocol + "//" + window.location.host;u += "&request_id=" + c, u += "&origin=" + encodeURIComponent(w), t && console.log("[DEBUG]", "Path is", window.Kloudless.baseUrl + u);var p = function p() {
      var e = 600,
          t = 1e3,
          o = (screen.height - e) / 2 - 50,
          n = (screen.width - t) / 2,
          i = "resizable,scrollbars,status,height=" + e + ",width=" + t + ",top=" + o + ",left=" + n;if (s) {
        var r = { type: "prepareToOpenAuthenticator", url: window.Kloudless.baseUrl + u, params: i },
            l = window.Kloudless._authenticator_iframe;l.contentWindow.postMessage("kloudless:" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(r), l.src), l.style.position = "fixed", l.style.display = "block", l.style.height = "100%", l.style.width = "100%", l.style.top = "0", l.style.bottom = "0", l.style.left = "0", l.style.right = "0";var a = 1,
            d = setInterval(function () {
          .75 >= a && (clearInterval(d), l.style.display = "none"), l.style.opacity = a, l.style.filter = "alpha(opacity=" + 100 * a + ")", a -= .01 * a;
        }, 120);
      } else window.Kloudless._popup = window.open(window.Kloudless.baseUrl + u, "kPOPUP", i), window.Kloudless._popup.focus();
    };return e && void 0 !== window.Kloudless._authenticators_by_element[e.outerHTML] && window.Kloudless.stop(e), window.Kloudless._authenticators[c] = { clickHandler: p, callback: n }, e && (window.Kloudless._authenticators_by_element[e.outerHTML] = c, e.addEventListener("click", p)), { launch: p };
  }, window.Kloudless.stop = function (e) {
    void 0 !== window.jQuery && e instanceof window.jQuery && (e = e.get(0));var t = window.Kloudless._authenticators_by_element[e.outerHTML];if (t) {
      var o = window.Kloudless._authenticators[t];e.removeEventListener("click", o.clickHandler), delete window.Kloudless._authenticators[t], delete window.Kloudless._authenticators_by_element[e.outerHTML];
    } else console.log("No click listener found to remove.");
  };
}();
!function () {
  "use strict";
  if (window.Event.prototype.preventDefault || (window.Event.prototype.preventDefault = function () {
    this.returnValue = !1;
  }), !Element.prototype.addEventListener) {
    var e = [],
        t = function t(_t, n) {
      var o = this,
          r = function r(e) {
        e.target = e.srcElement, e.currentTarget = o, n.handleEvent ? n.handleEvent(e) : n.call(o, e);
      };this.attachEvent("on" + _t, r), e.push({ object: this, type: _t, listener: n, wrapper: r });
    },
        n = function n(t, _n) {
      for (var o = 0; o < e.length;) {
        var r = e[o];if (r.object == this && r.type == t && r.listener == _n) {
          this.detachEvent("on" + t, r.wrapper);break;
        }++o;
      }
    };Element.prototype.addEventListener = t, Element.prototype.removeEventListener = n, window.HTMLDocument && (window.HTMLDocument.prototype.addEventListener = t, window.HTMLDocument.prototype.removeEventListener = n), window.Window && (window.Window.prototype.addEventListener = t, window.Window.prototype.removeEventListener = n);
  }
}();

/***/ }),

/***/ "C+/b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__("Sazm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__controller__ = __webpack_require__("R2a2");





var stateChangeListeners = [];

/* Gets called when the auth state changes, and proceeds to call every listenerFunction */
var stateChangeCallback = function stateChangeCallback(state, user) {
  console.log('stateChangeCallback (controller-interface.js)', state, user);
  console.log('stateChangeListeners to call (controller-interface.js):', stateChangeListeners);
  stateChangeListeners.forEach(function (listenerFunction) {
    listenerFunction(state, user);
  });
};

var ControllerInterface = function () {
  function ControllerInterface(config) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ControllerInterface);

    config.firebaseInstance = __WEBPACK_IMPORTED_MODULE_2_firebase__;
    config.stateChangeCallback = stateChangeCallback;
    this.Controller = new __WEBPACK_IMPORTED_MODULE_3__controller__["a" /* default */](config);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ControllerInterface, [{
    key: 'signIn',
    value: function signIn() {
      return this.Controller.signIn();
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      return this.Controller.signOut();
    }
  }, {
    key: 'getUser',
    value: function getUser() {
      return this.Controller.getUser();
    }
  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return this.Controller.getAccessToken();
    }
  }, {
    key: 'refreshUserToken',
    value: function refreshUserToken() {
      return this.Controller.refreshUserToken();
    }
  }, {
    key: 'saveCard',
    value: function saveCard(data) {
      return this.Controller.saveCard(data);
    }
  }, {
    key: 'deleteCard',
    value: function deleteCard(data) {
      return this.Controller.deleteCard(data);
    }
  }, {
    key: 'verifyCard',
    value: function verifyCard(data) {
      return this.Controller.verifyCard(data);
    }
  }, {
    key: 'searchCards',
    value: function searchCards(data) {
      return this.Controller.searchCards(data);
    }
  }, {
    key: 'getCard',
    value: function getCard(data) {
      return this.Controller.getCard(data);
    }
  }, {
    key: 'addStateChangeListener',
    value: function addStateChangeListener(listenerFunction) {
      console.log('AAAA addStateChangeListener', listenerFunction);
      stateChangeListeners.push(listenerFunction);
    }
  }, {
    key: 'force',
    value: function force(toForce) {
      return this.Controller.force(toForce);
    }
  }]);

  return ControllerInterface;
}();

/* harmony default export */ __webpack_exports__["a"] = (ControllerInterface);

/***/ }),

/***/ "CGSI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CNux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['title', 'description'],
  // data: function() {
  //   return {
  //
  //   }
  // },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  }
  // methods: {
  // }
});

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d0258de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("FMyu");
function injectStyle (ssrContext) {
  __webpack_require__("wTBZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5d0258de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DlG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.click)?_c('button',{staticClass:"btn",attrs:{"type":"button","href":_vm.link},on:{"click":function($event){$event.stopPropagation();_vm.clickEvent($event)}}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.image)?_c('img',{staticClass:"icon",attrs:{"src":_vm.image,"alt":""}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1):_c('a',{staticClass:"btn",attrs:{"href":_vm.link,"target":_vm.samePage ? '' : '_blank'}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon}}):_vm._e(),_vm._v(" "),(_vm.image)?_c('img',{staticClass:"icon",attrs:{"src":_vm.image,"alt":""}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FMyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v("\b\n    "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FdW5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HUDD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clipboards__ = __webpack_require__("Yk46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clipboards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clipboards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cardlet_vue__ = __webpack_require__("t8wU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__editable_vue__ = __webpack_require__("srgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__editable_markdown_vue__ = __webpack_require__("uE8u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__search_vue__ = __webpack_require__("OFKv");
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_clipboards___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['listItems', 'listCards', 'full', 'allCards', 'editing', 'showPending'],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_3_vue_awesome_components_Icon_vue__["a" /* default */],
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_4_vue_markdown___default.a,
    ibutton: __WEBPACK_IMPORTED_MODULE_6__ibutton_vue__["a" /* default */],
    Cardlet: __WEBPACK_IMPORTED_MODULE_7__cardlet_vue__["a" /* default */],
    Editable: __WEBPACK_IMPORTED_MODULE_8__editable_vue__["a" /* default */],
    Draggable: __WEBPACK_IMPORTED_MODULE_5_vuedraggable___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_10__search_vue__["a" /* default */],
    EditableMarkdown: __WEBPACK_IMPORTED_MODULE_9__editable_markdown_vue__["a" /* default */]
  },
  data: function data() {
    return {
      listContent: {},
      showListSearch: false,
      listFull: false
    };
  },
  watch: {
    editing: function editing(val) {
      if (val) this.listContent = this.listCards.value.map(function (card) {
        return card;
      });
      // @TODO: Figure out whether the below stuff is necessary (and if so then how to cope without objectIDs)
      // self.listCards.value.forEach(function(listCard) {
      //   self.listContent[listCard.objectID] = JSON.parse(JSON.stringify(listCard))
      // })
    }
  },
  methods: {
    updateItem: function updateItem(data) {
      console.log('updateItem (list)', data);
      this.listContent[data.objectID] = data;
      console.log('this.listContent');
      console.log(this.listContent);
      this.$emit('update', { field: 'list', value: this.listContent });
    },
    cardletClick: function cardletClick(card) {
      console.log('cardletClick (list.vue)', card);
      if (card.objectID === -1) this.listFull = true;else if (!this.editing) this.$emit('cardletClick', card);
    },
    addListItem: function addListItem(card) {
      console.log(card);
      var self = this;
      if (!card) card = {
        objectID: 'TEMP_' + Math.floor(Math.random() * 10000000000),
        intent: 'store',
        description: ''
      };
      self.listContent[card.objectID] = card;
      if (!self.listItems) __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(self.content, 'listItems', []);
      self.listItems.push(card.objectID);
    },
    removeListItem: function removeListItem(data) {
      if (this.listItems) {
        var listIndex = this.listItems.indexOf(data.objectID); // Doesn't account for same item appearing twice in list
        this.listItems.splice(listIndex, 1);
      } else {
        return null;
      }
    },
    toggleListSearch: function toggleListSearch() {
      this.showListSearch = !this.showListSearch;
    }
  }
});

/***/ }),

/***/ "Huz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_q__ = __webpack_require__("/Luh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);








__WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.setLevel('debug');

var Search = {
  install: function install(Vue, userAuth) {
    var _this = this;

    /**
    * Gets a card, generating and saving it if necessary
    *
    * @param  {Object} data - Should have one of [objectID, sameAs, query]
    * @param  {String} [data.objectID]
    * @param  {Array} [data.sameAs]
    * @param  {String} [data.query]
    * @param  {String} [data.refresh] - Forces refresh if present and true
    * @return {Object} card
    */
    var yieldCard = function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(data) {
        var card, retrievedCard;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('yieldCard', data);

                if (!(!data.objectID && (!data.sameAs || !data.sameAs[0]) && data.query)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return generateFromQuery(data.query);

              case 4:
                card = _context.sent;

                data.sameAs = card.sameAs;

              case 6:
                if (!data.objectID) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return getCard(data.objectID);

              case 9:
                retrievedCard = _context.sent;
                _context.next = 16;
                break;

              case 12:
                if (!(data.sameAs && data.sameAs[0])) {
                  _context.next = 16;
                  break;
                }

                _context.next = 15;
                return getFromSameAs(data.sameAs);

              case 15:
                retrievedCard = _context.sent;

              case 16:
                if (!(!retrievedCard || data.refresh)) {
                  _context.next = 24;
                  break;
                }

                if (card) {
                  _context.next = 21;
                  break;
                }

                _context.next = 20;
                return generateFromSameAs(data.sameAs);

              case 20:
                card = _context.sent;

              case 21:
                if (retrievedCard) card.objectID = retrievedCard.objectID;else card.objectID = calculateUniqueID(card);
                // const savedCard = await saveCard(card)
                // if (!card.objectID) card.objectID = savedCard.objectID
                _context.next = 25;
                break;

              case 24:
                // Otherwise, set card to retrieved data
                card = retrievedCard;

              case 25:

                // Return card
                console.log('Returning card:', card);
                return _context.abrupt('return', card);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function yieldCard(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    console.log('Installing ExplaainSearch', userAuth);

    var calculateUniqueID = function calculateUniqueID(card) {
      var splitBySlash = card.sameAs[0].split('/');
      return splitBySlash[splitBySlash.length - 1];
    };

    var generateFromQuery = function generateFromQuery(query) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('generateFromQuery', query);
        // axios.get('//lookup.dbpedia.org/api/search.asmx/KeywordSearch?QueryString=' + encodeURIComponent(query))
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post('//savvy-nlp--staging.herokuapp.com/generate-card-data', { query: query }).then(function (res) {
          console.log(res);
          var card = dbpediaQueryToCards(res.data.results.ArrayOfResult.Result[0] || res.data.results.ArrayOfResult.Result);
          console.log('Generated from Query: ', card);
          resolve(card);
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    };

    var generateFromSameAs = function generateFromSameAs(sameAs) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('generateFromSameAs', sameAs);
        var data = [];
        sameAs.forEach(function (uri) {
          var type = getSameAsType(uri);
          switch (type) {
            case 'dbpedia':
              data.push({
                type: 'dbpedia',
                uri: getDbpediaFetchURI(uri)
              });
              break;
          }
        });
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(data.map(function (source) {
          return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(source.uri);
        })).then(function (res) {
          console.log(res);
          var cardsToCombine = res.map(function (sourceResults, i) {
            console.log(sourceResults, i);
            return sourceDataToCard(data[i].type, sourceResults);
          });
          var card = combineLinkedData(cardsToCombine); // Should be better than just taking the first one!
          console.log('Generated from Query: ', card);
          resolve(card);
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    };

    var getFromSameAs = function getFromSameAs(sameAs) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('getFromSameAs', sameAs);
        var filters = 'sameAs: "' + sameAs.join('" OR sameAs: "') + '"';
        searchCards(userAuth, '', null, { filters: filters }).then(function (hits) {
          if (hits && hits.length) {
            console.log('Found from sameAs:', hits[0]);
            resolve(hits[0]);
          } else {
            console.log('Not found from sameAs.');
            resolve(null);
          }
        });
      });
    };

    var getSameAsType = function getSameAsType(uri) {
      if (uri.indexOf('dbpedia') > -1) {
        // Not very safe!
        return 'dbpedia';
      } else {
        return null;
      }
    };

    var sourceDataToCard = function sourceDataToCard(type, sourceData) {
      console.log('sourceDataToCard', type, sourceData);
      var card;
      switch (type) {
        case 'dbpedia':
          card = dbpediaToCards(sourceData);
      }
      return card;
    };

    var combineLinkedData = function combineLinkedData(data) {
      return data[0]; // @TODO
    };

    var getDbpediaFetchURI = function getDbpediaFetchURI(uri) {
      return uri.replace('//dbpedia.org/resource/', '//dbpedia.org/data/') + '.json';
    };

    var tailorDescription = function tailorDescription(description) {
      var maxChars = 300;
      description = description.replace(/ *\([^)]*\) */g, ' ').replace(/ \./g, '.');
      var sentences = description.split(/\. (?=[A-Z])/).map(function (s) {
        return s + '.';
      });
      while (sentences.join(' ').length > maxChars && sentences.length > 1) {
        sentences.pop();
      }
      description = sentences.join(' ');
      return description;
    };

    var dbpediaQueryToCards = function dbpediaQueryToCards(data) {
      console.log('dbpediaQueryToCards', data);
      console.log(data.Description);
      console.log(data.Description.replace(/ *\([^)]*\) */g, ' '));
      return {
        content: {
          title: data.Label,
          description: tailorDescription(data.Description)
        },
        sameAs: [data.URI],
        sources: [{
          type: 'source',
          name: 'Wikipedia',
          url: (data.URL || data.URI).replace('//dbpedia.org/resource/', '//en.wikipedia.org/wiki/')
        }]
      };
    };

    var dbpediaToCards = function dbpediaToCards(data) {
      console.log('dbpediaToCards', data);
      var resource = data.request.responseURL.replace('//dbpedia.org/data', '//dbpedia.org/resource').replace('.json', '');
      console.log('resource', resource);
      var title = data.data[resource]['http://www.w3.org/2000/01/rdf-schema#label'].filter(function (lang) {
        return lang.lang === 'en';
      })[0].value;
      console.log('title', title);
      var description = tailorDescription(data.data[resource]['http://www.w3.org/2000/01/rdf-schema#comment'].filter(function (lang) {
        return lang.lang === 'en';
      })[0].value);
      console.log('description', description);
      var wiki = data.data[resource]['http://xmlns.com/foaf/0.1/isPrimaryTopicOf'][0].value;
      console.log('wiki', wiki);
      return {
        content: {
          title: title,
          description: description
        },
        sameAs: [resource],
        sources: [{
          type: 'source',
          name: 'Wikipedia',
          url: wiki
        }]
      };
    };

    var advancedChunkSearch = function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(params) {
        var cards, content, hits, fileIDs;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('advancedChunkSearch');
                cards = [];

                if (params.filters && params.filters.indexOf('teams: ') > -1) delete params.filters; // Removing teams as a filter for now
                if (params.hitsPerPage === null) delete params.hitsPerPage;
                if (window.location.hostname === 'localhost') params.environment = 'local';
                console.log(params);
                // try {
                //
                // } catch (e) {
                //
                // }
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default()({
                  method: 'post',
                  // url: 'http://localhost:5000/api/memories/',
                  url: 'https://savvy-api--live.herokuapp.com/api/memories/',
                  timeout: 10000,
                  data: {
                    sender: params.sender,
                    parameters: params,
                    intent: 'query',
                    query: params.query,
                    organisationID: params.organisationID
                  }
                });

              case 8:
                content = _context3.sent;

                console.log('content');
                console.log(content);
                hits = content.hits || content.data && content.data.memories || []; // Accounts for the fact that we are often now using savvy-api for this

                _context3.next = 14;
                return hits.forEach(function () {
                  var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(hit) {
                    var correctedCard;
                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return correctCard(hit);

                          case 2:
                            correctedCard = _context2.sent;

                            cards.push(correctedCard);

                          case 4:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 14:
                fileIDs = cards.map(function (card) {
                  return card.fileID;
                });

                fileIDs = fileIDs.filter(function (item, pos) {
                  return item && fileIDs.indexOf(item) === pos;
                }); // Remove blanks and duplicates
                cards = combineDuplicateContents(cards);
                return _context3.abrupt('return', cards);

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this);
      }));

      return function advancedChunkSearch(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var searchCards = function searchCards(user, searchText, hitsPerPage, extraParams) {
      console.log('searchCards');
      var d = __WEBPACK_IMPORTED_MODULE_5_q___default.a.defer();
      var params = {
        query: searchText,
        // filters: 'teams: "' + user.data.teams.map(team => { return team.team }).join('" OR teams: "') + '"',
        hitsPerPage: hitsPerPage || null
      };
      if (extraParams) params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, extraParams);
      advancedChunkSearch(params).then(function (hits) {
        __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.trace(hits);
        d.resolve(hits);
      }).catch(function (e) {
        d.reject(e);
      });
      return d.promise;
    };

    var getCard = function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(objectID, data) {
        var getData, result, card;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('getCard', objectID, data);
                getData = data || {};

                getData.objectID = objectID;
                _context4.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default()({
                  method: 'post',
                  // url: 'http://localhost:5000/api/get-card/',
                  url: 'https://savvy-api--live.herokuapp.com/api/get-card/',
                  timeout: 10000,
                  data: getData
                });

              case 5:
                result = _context4.sent;
                _context4.next = 8;
                return correctCard(result.data);

              case 8:
                card = _context4.sent;

                console.log('gotCard:', card);
                return _context4.abrupt('return', card);

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this);
      }));

      return function getCard(_x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    var correctCard = function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5(card) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('correctCard', card);
                if (card.content && typeof card.content === 'string' && !card.description) {
                  card.description = card.content;
                  delete card.content;
                }
                if (card._highlightResult && card._highlightResult.content && card._highlightResult.content.value && typeof card._highlightResult.content.value === 'string' && !card._highlightResult.description) {
                  card._highlightResult.description = card._highlightResult.content;
                  delete card._highlightResult.content;
                }
                if (card.fileID) card.files = [{
                  url: card.fileUrl || null,
                  fileFormat: card.fileFormat || null,
                  mimeType: card.mimeType || card.fileType || null,
                  fileType: card.mimeType || card.fileType || null,
                  title: card.fileTitle || null,
                  fileTitle: card.fileTitle || null,
                  source: card.source || null,
                  superService: card.superService || null,
                  service: card.service || null,
                  subService: card.subService || null,
                  thumbnail: card.fileThumbnail || null,
                  objectID: card.fileID
                }];
                console.log('correctCard - RESULT', card);
                return _context5.abrupt('return', card);

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      return function correctCard(_x6) {
        return _ref5.apply(this, arguments);
      };
    }();

    var combineDuplicateContents = function combineDuplicateContents(cards) {
      console.log('combineDuplicateContents', cards);
      cards.forEach(function (card2, j) {
        cards.slice(0, j).forEach(function (card1, i) {
          if (card1 && card1.description && card1.description.length && card1.description === card2.description) {
            if (card1.files && card2.files && card1.files.objectID !== card2.files.objectID) card1.files = card1.files.concat(card2.files);
            cards[j] = null;
          }
        });
      });
      cards = cards.filter(function (card) {
        return card !== null;
      });
      return cards;
    };

    var compoundSearch = function compoundSearch(user, searchText) {
      console.log('compoundSearch');
      var d = __WEBPACK_IMPORTED_MODULE_5_q___default.a.defer();
      var maxLength = 400;
      var searchTextArray = [];
      var hitsPerPage = Math.min(Math.max(Math.ceil(10 / (searchText.length / maxLength)), 3), 12);
      for (var i = 0; i < searchText.length; i += maxLength) {
        searchTextArray.push(searchText.substring(i, i + maxLength));
      }var promises = searchTextArray.map(function (t, j) {
        return searchCards(user, t, hitsPerPage);
      });
      __WEBPACK_IMPORTED_MODULE_5_q___default.a.allSettled(promises).then(function (res) {
        var results = [].concat.apply([], res.map(function (r) {
          return r.value;
        }));
        results = removeDuplicates(results, 'objectID');
        __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.trace(results);
        d.resolve(results);
      }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_4_loglevel___default.a.trace(e);
      });
      return d.promise;
    };

    var removeDuplicates = function removeDuplicates(originalArray, objKey) {
      console.log('removeDuplicates');
      var trimmedArray = [];
      var values = [];
      var value;
      for (var i = 0; i < originalArray.length; i++) {
        value = originalArray[i][objKey];
        if (values.indexOf(value) === -1) {
          trimmedArray.push(originalArray[i]);
          values.push(value);
        }
      }
      return trimmedArray;
    };

    // const checkPageHit = function(pageData, results) {
    console.log('const');
    //   //Not yet accounting for capitals
    //   const boringWords = [
    //     'favourite',
    //     'world',
    //     'name',
    //     'this',
    //     'plan',
    //     'need',
    //     'best',
    //     'like',
    //     'the',
    //     'are',
    //     'is',
    //     'my',
    //     'my',
    //   ]
    //   const hits = []
    //   results.forEach(function(result, i) {
    //     log.trace('---')
    //     log.trace(i)
    //     var count = []
    //     result.context.forEach(function(c) {
    //       if (pageData.pageText.indexOf(c.value) > -1
    //       && hits.indexOf(result.objectID) == -1
    //       && c.value && c.value.length > 3
    //       && boringWords.indexOf(c.value) == -1
    //       && count.indexOf(c.value) == -1) {
    //         log.trace(c.value)
    //         count.push(c.value)
    //         (c.value.match(/ /g) || []).forEach(function() {
    //           count.push(c.value)
    //         })
    //       }
    //     })
    //     if (count.length > 2) {
    //       log.trace(result.sentence)
    //       hits.push(result)
    //     }
    //     log.trace('---')
    //   })
    //
    //   // return hits
    //   //Force no hits
    //   return []
    // }

    // const checkPageReminder = function(userID, pageData) {
    console.log('const');
    //   const d = Q.defer()
    //   log.trace(pageData)
    //   const urlRoot = pageData.baseUrl.replace('.com','').replace('.co.uk','').replace('.org','')
    //   const params = {
    //     query: '',
    //     filters: 'userID: ' + userID + ' AND (triggerUrl: ' + urlRoot + ' OR triggerUrl: ' + urlRoot + '.com OR triggerUrl: ' + urlRoot + '.co.uk OR triggerUrl: ' + urlRoot + '.org OR triggerURL: ' + urlRoot + ' OR triggerURL: ' + urlRoot + '.com OR triggerURL: ' + urlRoot + '.co.uk OR triggerURL: ' + urlRoot + '.org)'
    //   }
    //   log.trace('params')
    //   log.trace(params)
    //   advancedSearch(params)
    //   .then(function(reminders) {
    //     log.trace('reminders')
    //     log.trace(reminders)
    //     d.resolve(reminders)
    //   }).catch(function(e) {
    //     d.reject(e)
    //   })
    //   return d.promise
    // }

    this.getCard = getCard;
    this.searchCards = searchCards;
    this.compoundSearch = compoundSearch;
    this.removeDuplicates = removeDuplicates;
    this.correctCard = correctCard;
    this.yieldCard = yieldCard;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Search);

/***/ }),

/***/ "HyuK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IICg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_explorer_vue__ = __webpack_require__("j4tA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aed57ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explorer_vue__ = __webpack_require__("uoWA");
function injectStyle (ssrContext) {
  __webpack_require__("Lige")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_explorer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aed57ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_explorer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IJP5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",on:{"click":_vm.linkClick}},[_c('field',{attrs:{"label":"title","content":_vm.content.title,"editing":_vm.editing},on:{"update":_vm.update}}),_vm._v(" "),_c('field',{attrs:{"label":"description","content":_vm.content.description,"editing":_vm.editing,"truncate":_vm.full},on:{"update":_vm.update}}),_vm._v(" "),(_vm.content.integrationFields && _vm.content.integrationFields.value.status)?_c('ul',{staticClass:"status",class:_vm.content.integrationFields.value.status && _vm.content.integrationFields.value.status.toLowerCase()},[_c('li',{staticClass:"open"},[_vm._v("Open")]),_vm._v(" "),_c('li',{staticClass:"resolved"},[_vm._v("Resolved")]),_vm._v(" "),_c('li',{staticClass:"closed"},[_vm._v("Closed")])]):_vm._e(),_vm._v(" "),(_vm.full && _vm.content.attachments && _vm.content.attachments[0])?_c('img',{attrs:{"src":_vm.content.attachments[0].url}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IPVE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Id91":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAo3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listCards.value.length || _vm.editing)?_c('draggable',{staticClass:"list",attrs:{"options":{ disabled: !_vm.editing, handle: '.drag', draggable: '.cardlet' }},model:{value:(_vm.listCards.value),callback:function ($$v) {_vm.$set(_vm.listCards, "value", $$v)},expression:"listCards.value"}},[_vm._l(((_vm.full || _vm.listFull || _vm.listCards.value.length <= 6 ? _vm.listCards.value : _vm.listCards.value.slice(0, 6).concat([{ objectID: -1, description: 'Show more...' }]))),function(item){return _c('cardlet',{key:item.objectID,attrs:{"editing":_vm.editing,"editable":_vm.editing,"card":item},on:{"update":_vm.updateItem,"cardletClick":_vm.cardletClick,"remove":_vm.removeListItem}})}),_vm._v(" "),(_vm.editing)?_c('section',{staticClass:"buttons"},[(_vm.showListSearch)?_c('search',{attrs:{"allCards":_vm.allCards,"setCard":_vm.setCard,"auth":_vm.auth},on:{"select":_vm.addListItem}}):_vm._e()],1):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KZDm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connect_vue__ = __webpack_require__("jecr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428e3280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connect_vue__ = __webpack_require__("+x5K");
function injectStyle (ssrContext) {
  __webpack_require__("X0Wz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_428e3280_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lige":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LkkW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ editable: !(_vm.editable === false) },attrs:{"contenteditable":!(_vm.editable === false)},on:{"input":_vm.update}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MCnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__field_vue__ = __webpack_require__("6Pqw");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'full', 'allCards', 'position', 'editing'],
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__field_vue__["a" /* default */]
  },
  data: function data() {
    return {
      tempListCards: {},
      showListSearch: false
    };
  },
  computed: {
    updating: function updating() {
      return this.content.updating || false;
    },
    text: function text() {
      var text = this.content.description || '';
      var snippetLength = 100;
      var snippetStart = Math.max(text.indexOf('**') - snippetLength / 2, 0);
      return this.full ? text : text.trunc(snippetStart, snippetLength, true);
    },
    fullText: function fullText() {
      return (this.content.title ? this.content.title + '\n\n' : '') + this.text;
    },
    fontSize: function fontSize() {
      return 16 + 'px';
    }
  },
  watch: {
    data: {
      handler: function handler(val) {
        if (!this.editing) this.syncData();
      },
      deep: true
    }
  },
  methods: {
    update: function update(data) {
      console.log('update (basic)', data);
      this.$emit('update', data);
    },
    linkClick: function linkClick(event) {
      var self = this;
      if (event.srcElement.nodeName === 'A') {
        event.stopPropagation();
        var myRegexp = /\[.*?\]\((.*?)\)/g;
        var match = myRegexp.exec(self.text);
        var toLayerKeys = [];
        while (match != null) {
          toLayerKeys.push(match[1].replace('#', ''));
          match = myRegexp.exec(self.text);
        }
        var data = {
          // type: 'link',
          toURI: event.srcElement.hash.replace('#', ''),
          fromPos: self.position,
          toLayerKeys: toLayerKeys
        };
        data.toPos = [data.fromPos[0] + 1, data.toLayerKeys.indexOf(data.toURI)];
        this.$emit('showCard', data);
      }
    }
  }
});

String.prototype.trunc = function (start, length, useWordBoundary) {
  if (this.length <= length) return this;
  var subString = this.substr(start, length - 1);
  return (start > 0 ? '...' : '') + (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
};

/***/ }),

/***/ "MZ5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_media_vue__ = __webpack_require__("dKPT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f791ccce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_media_vue__ = __webpack_require__("RWnJ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_media_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f791ccce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_media_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Me1o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_explorer_ibutton_vue__ = __webpack_require__("r+yu");
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import log from 'loglevel'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_components_Icon_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_3__components_explorer_ibutton_vue__["a" /* default */]
  },
  props: ['Controller'],
  data: function data() {
    return {
      organisation: {},
      auth: {
        user: {
          uid: '',
          auth: {},
          data: {},
          organisation: this.organisation
        },
        authState: this.Controller.authState || 'pending',
        toggleSignIn: this.toggleSignIn,
        joinOrg: this.joinOrg
      },
      query: ''
    };
  },

  computed: {
    authButtonText: function authButtonText() {
      var self = this;
      var text;
      switch (self.auth.authState) {
        case 'loggedIn':
        case 'readyToJoinOrg':
        case 'readyToChooseOrg':
          text = 'Sign out';
          break;
        case 'loggedOut':
          text = 'Sign in with Google';
          break;
        case 'pending':
          text = 'Working...';
          break;
      }
      return text;
    }
  },
  created: function created() {
    var self = this;
    console.log('NODE_ENV:', "production");
    console.log('BACKEND_URL:', Object({"NODE_ENV":"production"}).BACKEND_URL);
    if (window.location.host.split('.')[2]) self.organisation.id = window.location.host.split('.')[0];
    console.log('self.organisation', self.organisation);
    self.Controller.addStateChangeListener(self.onAuthStateChanged);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].globalGetUser = function () {
      return self.Controller.getUser();
    };
    window.Intercom('boot', {
      app_id: 'et2ha1z8'
    });
  },
  methods: {
    toggleSignIn: function toggleSignIn() {
      _this.Controller.toggleSignIn();
    },
    onAuthStateChanged: function onAuthStateChanged(state, user) {
      var self = this;
      console.log('onAuthStateChanged');
      console.log(user);
      this.auth.user = user;
      this.auth.authState = self.Controller.authState;
      if (this.auth.authState === 'loggedIn') this.$router.push(this.$route.query.redirect || '/');else if (this.auth.authState === 'readyToJoinOrg' || this.auth.authState === 'readyToChooseOrg') this.$router.push(this.$route.query.redirect ? '/join?redirect=' + this.$route.query.redirect : '/join');else this.$router.push(this.$route.query.redirect ? '/login?redirect=' + this.$route.query.redirect : '/login');
      if (this.auth.authState === 'loggedIn') window.Intercom('boot', {
        app_id: 'et2ha1z8',
        email: self.auth.user.auth.email,
        created_at: 1234567890,
        name: self.auth.user.auth.displayName,
        user_id: self.auth.user.uid
      });
    },
    search: function search() {
      var self = this;
      self.$router.push('/card-manager?q=' + self.query);
      self.$emit('search');
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_logrocket__ = __webpack_require__("oeg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_airship_js__ = __webpack_require__("cMp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard__ = __webpack_require__("j9Xp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_chrome_chrome__ = __webpack_require__("lEdC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_connect_page__ = __webpack_require__("Zrdd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chrome_chrome_controller_interface__ = __webpack_require__("l3bJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__controller_interface__ = __webpack_require__("C+/b");

/* global window, chrome */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




// import router from './router'




 // Ideally this is only imported if we're testing

// import Popup from './components/explorer/popup'

__webpack_require__("h2zT");

__WEBPACK_IMPORTED_MODULE_1_logrocket___default.a.init('cqmhn2/savvy-development');

// Create an instance with webApiKey and envKey
var airship = new __WEBPACK_IMPORTED_MODULE_3_airship_js__["a" /* default */]({ webApiKey: 'yqfb07697ad5lak33tu75docb2duty5f', envKey: 'ky4t3nn8vp56n169' });
// Should be used as a singleton

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;

var errorToPassDown = {
  message: null

  // if (chrome && chrome.processes && chrome.processes.getProcessInfo) {
  //   console.log('Fetching Process Info')
  //   chrome.processes.getProcessInfo([], true, processes => {
  //     console.log('Fetched Process Info!')
  //     console.log(processes)
  //     console.log(JSON.stringify(processes))
  //   })
  // }

};
var Main = function Main(props) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Main);

  var mainSelf = this;
  // @TODO: This should choose Controller not just for testing but also for webapp
  console.log('props');
  console.log(props);
  var ControllerInterfaceClass = props.mode === 'chrome' && props.env !== 'testing' ? __WEBPACK_IMPORTED_MODULE_8__chrome_chrome_controller_interface__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__controller_interface__["a" /* default */];
  console.log('ControllerInterfaceClass');
  console.log(ControllerInterfaceClass);
  mainSelf.Controller = new ControllerInterfaceClass({ mode: props.mode });

  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].filter('capitalise', function (value, initial) {
    if (!value) return '';
    var splitChar = {
      kebab: '-',
      default: ' '
    }[initial || 'default'] || ' ';
    return value.toString().split(splitChar).map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
  });

  /* eslint-disable no-new */
  var v = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
    el: '#app',
    // router,
    render: function render(h) {
      return h(props.mode === 'connect' ? __WEBPACK_IMPORTED_MODULE_7__components_connect_page__["a" /* default */] : props.plugin || props.mode === 'demo' ? __WEBPACK_IMPORTED_MODULE_6__components_chrome_chrome__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__dashboard__["a" /* default */], {
        props: {
          Controller: mainSelf.Controller,
          authState: this.authState,
          user: this.user,
          sidebar: props.sidebar,
          mode: props.mode || false,
          parentError: errorToPassDown
        }
      });
    },

    data: {
      authState: 'pending',
      user: {}
    }
    // created: function () {
    //   window.addEventListener('keyup', this.keyPressed)
    // },
    // methods: {
    //   keyPressed: function (event) {
    //     console.log('keyPressed', event)
    //   }
    // }
  });

  var onAuthStateChanged = function onAuthStateChanged(state, user) {
    console.log('onAuthStateChanged (main.js)', state, user);
    if (state) v.authState = state;
    v.user = user;
    if (user && user.auth) {
      console.log(111);
      __WEBPACK_IMPORTED_MODULE_1_logrocket___default.a.identify(user.uid, {
        name: user.auth.displayName,
        email: user.auth.emails ? user.auth.emails[0] : user.auth.email,
        organisation: user.data ? user.data.organisationID : null
      });
      __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.setUserContext({
        name: user.auth.displayName,
        email: user.auth.emails ? user.auth.emails[0] : user.auth.email,
        id: user.auth.emails ? user.auth.emails[0] : user.auth.email || user.uid
      });
      console.log(222);
      if (user.data) {
        // Identifty the user, returns a Promise.
        airship.identify({
          type: 'User',
          id: user.uid,
          displayName: user.auth.emails ? user.auth.emails[0] : user.auth.email,
          attributes: {
            organisationID: user.data ? user.data.organisationID : '0'
          }
          // group: {
          //   type: 'Organisation',
          //   id: user.data ? user.data.organisationID : '0',
          //   displayName: 'SF Homeowners Club'
          // }
        }).then(function () {
          console.log(333);
          console.log('airship.isEnabled(\'new-design-ideas\')');
          console.log(airship.isEnabled('new-design-ideas'));
        });
      }
    }
    console.log('Current authState and user: ', v.authState, v.user);
  };

  this.Controller.addStateChangeListener(onAuthStateChanged);
  console.log('this.Controller.getUser (main.js)');
  this.Controller.getUser().then(function (user) {
    var authState = user && user.uid && user.data.organisationID ? 'loggedIn' : null;
    console.log('Forcing onAuthStateChanged()');
    onAuthStateChanged(authState, user);
  }).catch(function (err) {
    console.error('Failed to Log In', err);
    __WEBPACK_IMPORTED_MODULE_1_logrocket___default.a.captureMessage('Failed to Log In', {
      extra: {
        err: err,
        data: {
          authState: v.authState,
          user: v.user,
          sidebar: v.sidebar,
          mode: v.mode,
          parentError: v.parentError
        }
      }
    });
    __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureMessage('Failed to Log In', {
      extra: {
        err: err,
        data: {
          authState: v.authState,
          user: v.user,
          sidebar: v.sidebar,
          mode: v.mode,
          parentError: v.parentError
        }
      }
    });
  });

  // Just in case something went wron with login, try again after 6 seconds!
  setTimeout(function () {
    if (!v.authState || !v.user || !v.user.auth || !v.user.data) {
      console.log('Having to resort to a backup login attempt');
      __WEBPACK_IMPORTED_MODULE_1_logrocket___default.a.captureMessage('Having to resort to a backup login attempt', {
        extra: {
          data: {
            authState: v.authState,
            user: v.user,
            sidebar: v.sidebar,
            mode: v.mode,
            parentError: v.parentError
          }
        }
      });
      __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureMessage('Having to resort to a backup login attempt', {
        extra: {
          data: {
            authState: v.authState,
            user: v.user,
            sidebar: v.sidebar,
            mode: v.mode,
            parentError: v.parentError
          }
        }
      });
      _this.Controller.getUser().then(function (user) {
        var authState = user && user.uid && user.data.organisationID ? 'loggedIn' : null;
        console.log('Forcing onAuthStateChanged()');
        onAuthStateChanged(authState, user);
      }).catch(function (err) {
        console.error('Failed to Log In (even on the backup attempt)', err);
        __WEBPACK_IMPORTED_MODULE_1_logrocket___default.a.captureMessage('Failed to Log In (even on the backup attempt)', {
          extra: {
            err: err,
            data: {
              authState: v.authState,
              user: v.user,
              sidebar: v.sidebar,
              mode: v.mode,
              parentError: v.parentError
            }
          }
        });
        __WEBPACK_IMPORTED_MODULE_2_raven_js___default.a.captureMessage('Failed to Log In (even on the backup attempt)', {
          extra: {
            err: err,
            data: {
              authState: v.authState,
              user: v.user,
              sidebar: v.sidebar,
              mode: v.mode,
              parentError: v.parentError
            }
          }
        });
      });
    }
  }, 6000);

  window.addEventListener('message', function (event) {
    switch (event.data.action) {
      case 'stateChanged':
        console.log('stateChanged', event.data);
        onAuthStateChanged(event.data.data.state, event.data.data.user);
        break;
    }
  });

  if (chrome && chrome.runtime && chrome.runtime.onMessage) {
    chrome.runtime.onMessage.addListener(function (request, sender, sendResponse) {
      console.log('Request received (main.js)', request);
      if (request.action) switch (request.action) {
        case 'stateChanged':
          onAuthStateChanged(request.data.state, request.data.user);
          break;
      }
      return true;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Main);

/***/ }),

/***/ "NzvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topics field",class:_vm.topics && _vm.topics.state},[_vm._l(((_vm.displayTopics.length || _vm.editing ? _vm.displayTopics : ['general'])),function(topic){return _c('span',{on:{"click":_vm.topicClicked}},[_vm._v(_vm._s(_vm._f("capitalise")(topic,'kebab')))])}),_vm._v(" "),(_vm.editing)?_c('span',{staticClass:"add",on:{"click":_vm.add}},[_vm._v("+ "),(!_vm.displayTopics.length)?_c('span',[_vm._v("Add Topic")]):_vm._e()]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OFKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__ = __webpack_require__("8LWO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7448e39a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__ = __webpack_require__("va8O");
function injectStyle (ssrContext) {
  __webpack_require__("XtJQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7448e39a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OfUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"grower"},[_c('img',{staticClass:"fa-spin",attrs:{"src":"static/images/icon.png","alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QSjX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R2a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__plugins_auth__ = __webpack_require__("VrlL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__author_js__ = __webpack_require__("mRJL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__ = __webpack_require__("Huz3");




// @TODO: Remove toggleSignIn() from everywhere
// @TODO: Remove signedIn() from everywhere



 // Need to concolidate this + 'auth'

// import * as firebase from 'firebase'
// import CardDetection from '../plugins/card-detection.js'


__WEBPACK_IMPORTED_MODULE_5_loglevel___default.a.setLevel('debug');

var firebaseConfig = {
  apiKey: 'AIzaSyDbf9kOP-Mb5qroUdCkup00DFya0OP5Dls',
  authDomain: 'savvy-96d8b.firebaseapp.com'
};
var authorConfig = {
  url: 'https://' + (Object({"NODE_ENV":"production"}).BACKEND_URL || 'savvy-api--live.herokuapp.com') + '/api/memories',
  // url: 'http://localhost:5000/api/memories',
  importUrl: 'https://' + (Object({"NODE_ENV":"production"}).BACKEND_URL || 'savvy-api--live.herokuapp.com') + '/api/import'

  // var userForcedFromUrl = window && window.location && window.location.href.search('localhost:8080') > -1 ? {
  // var userForcedFromUrl = window && window.location && window.location.href.search('ngrok') > -1 ? {
  // var userForcedFromUrl = window && window.location && window.location.href.search('yc.heysavvy.com') > -1 ? {
};var userForcedFromUrl = {
  auth: {
    apiKey: 'AIzaSyDbf9kOP-Mb5qroUdCkup00DFya0OP5Dls',
    appName: '[DEFAULT]',
    authDomain: 'savvy-96d8b.firebaseapp.com',
    createdAt: '1509293764000',
    displayName: 'Paul Graham',
    email: 'pg@ycombinator.com',
    emailVerified: true,
    isAnonymous: false,
    lastLoginAt: '1521294455000',
    photoURL: 'https://futurestartup.com/wp-content/uploads/2012/08/PaulGraham-290x290.png',
    providerData: Array[1],
    redirectEventId: null,
    stsTokenManager: {
      // apiKey: 'AIzaSyDbf9kOP-Mb5qroUdCkup00DFya0OP5Dls',
      // expirationTime: 1521307900790,
      // refreshToken: 'APyOXy0YYTudP6lMvbDebmF3nLxEI3pg7RT6J2w9JV9o2vVz3tyCMTjbhND6NrhjUXwGPNszR4Ciklhd8j5X0vEdD6lJN-1QVel1MHpzFEmOz1nfEt7DbS96W0Df5jPwVmf37xMTU0Ow-hCQpltLOP-E53uPfpNDB_zQfygsiRQpSYawKQE3XwHWH78yY2aZpdQfYMD2GixAD5Ivpz34l0D1b636RaX3QsyuLUkkxmoNBgm4A-Nx7XJXRCCCzfAH3Q4dpc0oDaJG5vch4dueyqPjqIk6E8I7JB1hyuED93Nk6jV4Pc_MxgJZ_EmUuwwafbb0pO6xn0oNdibeP7aJQ9is_TVegnGqwMbYsSgj3aJSJ_JSIMSHNR4',
    },
    firebase: 'paul_graham',
    uid: 'paul_graham'
  },
  data: {
    firebase: '',
    first: 'Paul',
    last: 'Graham',
    objectID: '',
    organisationID: 'yc',
    role: 'admin',
    slack: ''
  },
  uid: 'paul_graham'
  // } : false

};console.log('STARTING1');
// console.log(userForcedFromUrl)
console.log(window.location.href);

var Controller = function () {
  function Controller(config) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Controller);

    console.log('Controller Constructed');
    config.firebaseConfig = firebaseConfig;
    if (config.mode !== 'demo') userForcedFromUrl = false;
    var stateChangeCallback = function stateChangeCallback(state, user) {
      var userToReturn = userForcedFromUrl || user;
      var stateToReturn = userForcedFromUrl ? 'loggedIn' : state;
      console.log('userForcedFromUrl', userForcedFromUrl);
      console.log('stateToReturn', stateToReturn);
      return config.stateChangeCallback(stateToReturn, userToReturn);
    };
    var newConfig = userForcedFromUrl ? {
      firebaseInstance: {
        apps: [],
        initializeApp: function initializeApp() {},
        auth: function auth() {}
      }
    } : config;
    if (!userForcedFromUrl) {
      this.Auth = new __WEBPACK_IMPORTED_MODULE_6__plugins_auth__["a" /* default */](stateChangeCallback, newConfig);
      this.authState = this.Auth.authState;
    }
    this.Author = new __WEBPACK_IMPORTED_MODULE_7__author_js__["a" /* default */](authorConfig);
    if (userForcedFromUrl) {
      console.log('forceeee');
      config.stateChangeCallback('loggedIn', userForcedFromUrl);
    }
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Controller, [{
    key: 'authSignIn',
    value: function authSignIn(token) {
      console.log('❇️ CONTROLLER ❇️ - authSignIn', token);
      return this.Auth.authSignIn(token);
    }
  }, {
    key: 'signIn',
    value: function signIn(specialSignInFunction) {
      console.log('❇️ CONTROLLER ❇️ - signIn', specialSignInFunction);
      if (specialSignInFunction) return specialSignInFunction();else return this.Auth.signIn();
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      console.log('❇️ CONTROLLER ❇️ - signOut');
      return this.Auth.signOut();
    }
  }, {
    key: 'toggleSignIn',
    value: function toggleSignIn() {
      console.log('❇️ CONTROLLER ❇️ - toggleSignIn');
      console.log('Replacing toggleSignIn with signIn');
      // return this.Auth.toggleSignIn()
      return this.Auth.signIn();
    }
  }, {
    key: 'startSignIn',
    value: function startSignIn() {
      console.log('❇️ CONTROLLER ❇️ - startSignIn');
      if (!this.Auth.signedIn()) {
        console.log('not yet signed in so toggling');
        return this.Auth.toggleSignIn();
      }
    }
  }, {
    key: 'signedIn',
    value: function signedIn() {
      console.log('❇️ CONTROLLER ❇️ - signedIn');
      return this.Auth.signedIn();
    }
  }, {
    key: 'getUser',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('❇️ CONTROLLER ❇️ - getUser');

                if (!userForcedFromUrl) {
                  _context.next = 7;
                  break;
                }

                console.log('forcing user from url');
                if (!__WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */].searchCards && userForcedFromUrl) __WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */], userForcedFromUrl);
                return _context.abrupt('return', userForcedFromUrl);

              case 7:
                console.log('NOT forcing user');
                _context.next = 10;
                return this.Auth.getUser();

              case 10:
                user = _context.sent;

                if (!__WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */].searchCards && user) __WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */], user); // Bit of hack - shouldn't be using Vue at all!
                return _context.abrupt('return', user);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getUser() {
        return _ref.apply(this, arguments);
      }

      return getUser;
    }()
  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      console.log('❇️ CONTROLLER ❇️ - getAccessToken');
      return userForcedFromUrl ? '' : this.Auth.getAccessToken();
    }
  }, {
    key: 'refreshUserToken',
    value: function refreshUserToken() {
      console.log('❇️ CONTROLLER ❇️ - refreshUserToken');
      return this.Auth.refreshUserToken();
    }
  }, {
    key: 'saveCard',
    value: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(data) {
        var user, idToken, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('❇️ CONTROLLER ❇️ - saveCard', data);
                _context2.next = 3;
                return this.getUser();

              case 3:
                user = _context2.sent;
                _context2.next = 6;
                return this.getAccessToken();

              case 6:
                idToken = _context2.sent;

                data.sender = { uid: user.uid, role: user.data.role, idToken: idToken, organisationID: user.data.organisationID };
                _context2.next = 10;
                return this.Author.saveCard(data);

              case 10:
                result = _context2.sent;
                return _context2.abrupt('return', result);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function saveCard(_x) {
        return _ref2.apply(this, arguments);
      }

      return saveCard;
    }()
  }, {
    key: 'deleteCard',
    value: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(data) {
        var user, idToken, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('❇️ CONTROLLER ❇️ - deleteCard', data);
                _context3.next = 3;
                return this.getUser();

              case 3:
                user = _context3.sent;
                _context3.next = 6;
                return this.getAccessToken();

              case 6:
                idToken = _context3.sent;

                data.sender = { uid: user.uid, role: user.data.role, idToken: idToken, organisationID: user.data.organisationID };
                data.organisationID = user.data.organisationID;
                _context3.next = 11;
                return this.Author.deleteCard(data);

              case 11:
                result = _context3.sent;
                return _context3.abrupt('return', result);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteCard(_x2) {
        return _ref3.apply(this, arguments);
      }

      return deleteCard;
    }()
  }, {
    key: 'verifyCard',
    value: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(data) {
        var user, idToken, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log('❇️ CONTROLLER ❇️ - verifyCard', data);
                _context4.next = 3;
                return this.getUser();

              case 3:
                user = _context4.sent;
                _context4.next = 6;
                return this.getAccessToken();

              case 6:
                idToken = _context4.sent;

                data.sender = { uid: user.uid, role: user.data.role, idToken: idToken, organisationID: user.data.organisationID };
                data.organisationID = user.data.organisationID;
                _context4.next = 11;
                return this.Author.verifyCard(data);

              case 11:
                result = _context4.sent;
                return _context4.abrupt('return', result);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function verifyCard(_x3) {
        return _ref4.apply(this, arguments);
      }

      return verifyCard;
    }()
  }, {
    key: 'searchCards',
    value: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(data) {
        var user, idToken, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log('❇️ CONTROLLER ❇️ - searchCards', data);
                _context5.next = 3;
                return this.getUser();

              case 3:
                user = _context5.sent;
                _context5.next = 6;
                return this.getAccessToken();

              case 6:
                idToken = _context5.sent;

                data.includeNlp = true;
                data.sender = { uid: user.uid, role: user.data.role, idToken: idToken, organisationID: user.data.organisationID };
                data.organisationID = user.data.organisationID;
                console.log('data', data);
                console.log('ExplaainSearch', __WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */]);
                console.log('ExplaainSearch.searchCards', __WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */].searchCards);
                _context5.next = 15;
                return __WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */].searchCards(data.user, data.query, data.numberOfResults, data);

              case 15:
                result = _context5.sent;
                return _context5.abrupt('return', result);

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function searchCards(_x4) {
        return _ref5.apply(this, arguments);
      }

      return searchCards;
    }()
  }, {
    key: 'getCard',
    value: function () {
      var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(data) {
        var user, idToken, result;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('❇️ CONTROLLER ❇️ - getCard', data);
                _context6.next = 3;
                return this.getUser();

              case 3:
                user = _context6.sent;
                _context6.next = 6;
                return this.getAccessToken();

              case 6:
                idToken = _context6.sent;

                data.includeNlp = true;
                data.sender = { uid: user.uid, role: user.data.role, idToken: idToken, organisationID: user.data.organisationID };
                data.organisationID = user.data.organisationID;
                console.log('data', data);
                console.log('ExplaainSearch', __WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */]);
                console.log('ExplaainSearch.getCard', __WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */].getCard);
                _context6.next = 15;
                return __WEBPACK_IMPORTED_MODULE_8__plugins_explaain_search_js__["a" /* default */].getCard(data.objectID, data);

              case 15:
                result = _context6.sent;
                return _context6.abrupt('return', result);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getCard(_x5) {
        return _ref6.apply(this, arguments);
      }

      return getCard;
    }()
  }, {
    key: 'force',
    value: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(toForce) {
        var user;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!toForce.user) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 3;
                return this.Auth.forceUser(toForce.user);

              case 3:
                user = _context7.sent;
                return _context7.abrupt('return', user);

              case 7:
                return _context7.abrupt('return', null);

              case 8:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function force(_x6) {
        return _ref7.apply(this, arguments);
      }

      return force;
    }()
  }]);

  return Controller;
}();

/* harmony default export */ __webpack_exports__["a"] = (Controller);

/***/ }),

/***/ "RWjT":
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),

/***/ "RWnJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.content.imageUrl.value,"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SRt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['topics', 'editing'],
  data: function data() {
    return {
      tempTopics: []
    };
  },
  computed: {
    displayTopics: function displayTopics() {
      return this.editing ? this.tempTopics : this.topics && this.topics.value || [];
    }
  },
  watch: {
    editing: function editing(val) {
      console.log(1);
      if (val) this.tempTopics = this.topics && this.topics.value ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.topics && this.topics.value)) : [];else this.$emit('update', { field: 'topics', value: this.tempTopics });
    }
  },
  methods: {
    add: function add() {
      var name = prompt('Enter your topic name:');
      var topic = name.toLowerCase().split(' ').join('-');
      if (this.editing && topic) {
        console.log('topic:', topic);
        this.tempTopics.push(topic);
      }
    },
    topicClicked: function topicClicked(event) {
      console.log('topicClicked');
      console.log(event);
      if (this.editing) {
        var child = event.target;
        var parent = child.parentNode;
        console.log(parent);
        // The equivalent of parent.children.indexOf(child)
        var index = Array.prototype.indexOf.call(parent.children, child);
        this.tempTopics.splice(index, 1);
      }
    }
  }
});

/***/ }),

/***/ "TbJl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basic_vue__ = __webpack_require__("9pb1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7fe4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basic_vue__ = __webpack_require__("sxkl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_basic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f7fe4c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_basic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tn6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_issue_vue__ = __webpack_require__("MCnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374066d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_issue_vue__ = __webpack_require__("IJP5");
function injectStyle (ssrContext) {
  __webpack_require__("VFzH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_issue_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_374066d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_issue_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U2Li":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__ = __webpack_require__("hrwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e4d230f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__ = __webpack_require__("80oC");
function injectStyle (ssrContext) {
  __webpack_require__("WqJl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e4d230f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UkLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");



var props = {
  env: Object({"NODE_ENV":"production"}).CHROME ? 'testing' : 'development', // Temporary
  plugin: Object({"NODE_ENV":"production"}).CHROME || false,
  // env: 'production',
  // plugin: false,
  sidebar: false,
  mode: 'demo'
  // demo: true // @TODO: Set this back to false when we're not doing demo!
};

console.log('Running Web App');

__WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.config('https://5abb211365ca4cd9a72885762827512f@sentry.io/1187390').install();
try {
  __WEBPACK_IMPORTED_MODULE_0_raven_js___default.a.context(function () {
    var main = new __WEBPACK_IMPORTED_MODULE_1__main_js__["a" /* default */](props);
    console.log('main:', main);
  });
} catch (e) {
  var main = new __WEBPACK_IMPORTED_MODULE_1__main_js__["a" /* default */](props);
  console.log('main (Raven failed):', main);
}

/***/ }),

/***/ "UqXr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VFzH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VrlL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_logrocket__ = __webpack_require__("oeg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);





/* global firebase */
// import Vue from 'vue'
// import * as firebase from 'firebase'



// import VueAxios from 'vue-axios'

// Vue.use(VueAxios, axios)

var Auth = function Auth(stateChangeCallback, config) {
  var _this = this;

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Auth);

  console.log('🔑 Auth 🔑 - Constructed', config);
  var self = this;
  self.Testing = config.testing || false;
  self.firstLoginAttempted = false;
  self.firebase = config.firebaseInstance;
  try {
    if (!self.firebase) self.firebase = firebase;
  } catch (e) {
    console.log('Caught:', e);
  }
  self.firebaseConfig = config.firebaseConfig;
  self.options = {};
  self.organisation = {};
  self.user = {};
  self.stateChangeCallback = stateChangeCallback || function () {
    console.log('🔑 Auth 🔑 - stateChangeCallback');
    console.log('no state change callback defined!');
  };
  self.updateAuthState = function (state) {
    console.log('🔑 Auth 🔑 - self.updateAuthState (auth.js)', state);
    self.authState = state;
    self.stateChangeCallback(state, self.user);
  };
  /**
  * initApp handles setting up UI event listeners and registering Firebase auth listeners:
  *  - firebase.auth().onAuthStateChanged: This listener is called when the user is signed in or
  *    out, and that is where we update the UI.
  *  - firebase.auth().getRedirectResult(): This promise completes when the user gets back from
  *    the auth redirect flow. It is where you can get the OAuth access token from the IDP.
  */
  console.log('🔏⛏  Initialising Auth');
  if (!self.firebase.apps.length) {
    self.firebase.initializeApp(self.firebaseConfig);
  }

  // this.updateAuthState(self.firebase.auth().currentUser ? 'loggedIn' : 'pending') // Is this correct?

  // Result from Redirect auth flow.
  // [START getidptoken]
  self.firebase.auth().getRedirectResult().then(function (result) {
    // if (result.credential) {
    //   // This gives you a Google Access Token. You can use it to access the Google API.
    //   var token = result.credential.accessToken
    // }
    console.log('redirectResult', result);
  }).catch(function (error) {
    // Handle Errors here.
    var errorCode = error.code;
    // var errorMessage = error.message
    // // The email of the user's account used.
    // var email = error.email
    // // The self.firebase.auth.AuthCredential type that was used.
    // var credential = error.credential
    // [START_EXCLUDE]
    if (errorCode === 'auth/account-exists-with-different-credential') alert('You have already signed up with a different auth provider for that email.');
    // If you are using multiple auth providers on your app you should handle linking
    // the user's accounts here.
    else console.error(error);
  });
  // [END getidptoken]

  self.firebase.auth().onAuthStateChanged(function (userAuth) {
    console.log(1);
    self.onFirebaseAuthStateChange(userAuth);
  });

  self.signIn = function () {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('🔑 Auth 🔑 - signIn');
      if (!self.firebase.auth().currentUser) {
        self.updateAuthState('pending');
        var provider = new self.firebase.auth.GoogleAuthProvider();
        // provider.addScope('https://www.googleapis.com/auth/userinfo.email') // Experimenting with Gmail API
        // provider.addScope('https://www.googleapis.com/auth/gmail.readonly')
        if (self.Testing) {
          self.onFirebaseAuthStateChange(testUserAuth);
        } else {
          self.firebase.auth().signInWithRedirect(provider);
        }
        self.firebase.auth().onAuthStateChanged(function (userAuth) {
          self.onFirebaseAuthStateChange(userAuth).then(resolve).catch(reject);
        });
      }
    });
  };

  self.signOut = function () {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('🔑 Auth 🔑 - signOut');
      self.updateAuthState('pending');
      if (self.firebase.auth().currentUser) {
        self.firebase.auth().signOut();
        self.firebase.auth().onAuthStateChanged(function (userAuth) {
          self.onFirebaseAuthStateChange(userAuth).then(resolve).catch(reject);
        });
      }
    });
  };

  self.toggleSignIn = function () {
    console.log('🔑 Auth 🔑 - toggleSignIn');
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // Maybe should separate this into signIn() and signOut() to avoid accidentally double taetc
      console.log('🔐  Toggling Sign in');
      self.updateAuthState('pending');
      if (!self.firebase.auth().currentUser) {
        var provider = new self.firebase.auth.GoogleAuthProvider();
        // provider.addScope('https://www.googleapis.com/auth/userinfo.email') // Experimenting with Gmail API
        // provider.addScope('https://www.googleapis.com/auth/gmail.readonly')
        console.log('provider');
        console.log(provider);
        if (self.Testing) {
          console.log(2);
          self.onFirebaseAuthStateChange(testUserAuth);
        } else {
          self.firebase.auth().signInWithRedirect(provider);
        }
      } else {
        self.firebase.auth().signOut();
      }
      self.firebase.auth().onAuthStateChanged(function (userAuth) {
        console.log(3);
        self.onFirebaseAuthStateChange(userAuth).then(function (user) {
          resolve(user);
        }).catch(function (user) {
          reject(user);
        });
      });
    });
  };
  self.onFirebaseAuthStateChange = function (userAuth) {
    console.log('🔑 Auth 🔑 - onFirebaseAuthStateChange', userAuth);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      if (userAuth && !self.user.auth) self.user = {
        uid: userAuth.uid,
        lastRefreshed: new Date(),
        auth: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(userAuth))
      };
      if (self.user.auth && !self.user.data) self.getUserData(self.user.auth).then(function (userData) {
        console.log('👤  New User data!', userData);
        self.user.data = userData;
        self.updateAuthState('loggedIn');
        resolve(self.user);
      }).catch(function (e) {
        self.updateAuthState('loggedOut'); // Could have another state for this scenario?
        resolve(null);
      });
      if (!self.user.auth) {
        console.log('Calling back but with no user');
        self.updateAuthState('loggedOut');
        if (!self.firstLoginAttempted) {
          self.firstLoginAttempted = true;
          // self.signIn() // @TODO: Once we know this auto-onstart-login is not needed in chrome extension, delete this + firstLoginAttempted
        }
        resolve(null);
      }
    });
  };
  self.authSignIn = function (token) {
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('🔑 Auth 🔑 - authSignIn', token);
      var credential = self.firebase.auth.GoogleAuthProvider.credential(null, token);
      console.log('self.firebase');
      console.log(self.firebase);
      console.log('credential');
      console.log(credential);
      self.firebase.auth().signInWithCredential(credential).then(function (res) {
        // console.log('Auth starting')
        // myAuth.initApp(false, onAuthStateChanged, { firebaseConfig: self.firebaseConfig, organisation: organisation })
        // console.log('Auth done')
        resolve(res);
      }).catch(function (err) {
        console.error('Couldn\'t sign user in (auth.js)', err);
        __WEBPACK_IMPORTED_MODULE_5_logrocket___default.a.captureMessage('Couldn\'t sign user in (auth.js)', {
          extra: {
            err: err,
            data: credential
          }
        });
        __WEBPACK_IMPORTED_MODULE_6_raven_js___default.a.captureMessage('Couldn\'t sign user in (auth.js)', {
          extra: {
            err: err,
            data: credential
          }
        });
        reject(err);
      });
    });
  };
  self.signedIn = function () {
    console.log('🔑 Auth 🔑 - signedIn');
    var signedIn = self.Testing ? self.user.uid : !!self.firebase.auth().currentUser;
    return signedIn;
  };
  self.getAccessToken = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(forceRefresh) {
      var token, _token;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('🔑 Auth 🔑 - getAccessToken', forceRefresh);
              _context.prev = 1;

              if (!(forceRefresh || !self.user.lastRefreshed || new Date().getTime() - new Date(self.user.lastRefreshed).getTime() > 1000 * 60 * 30)) {
                _context.next = 12;
                break;
              }

              _context.next = 5;
              return self.firebase.auth().currentUser.getIdToken( /* forceRefresh */true);

            case 5:
              token = _context.sent;

              if (self.user && self.user.auth && self.user.auth.stsTokenManager) self.user.auth.stsTokenManager.accessToken = token;
              console.log('New User Token!', token.substring(0, 100) + '...');
              self.user.lastRefreshed = new Date();
              return _context.abrupt('return', token);

            case 12:
              _token = self.user.auth.stsTokenManager.accessToken;

              console.log('Existing User Token!', _token.substring(0, 100) + '...');
              return _context.abrupt('return', _token);

            case 15:
              _context.next = 21;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](1);

              console.log(_context.t0);
              return _context.abrupt('return', null);

            case 21:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[1, 17]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
  self.refreshUserToken = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
    var token;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log('🔑 Auth 🔑 - refreshUserToken');
            _context2.next = 3;
            return self.getAccessToken(true);

          case 3:
            token = _context2.sent;
            return _context2.abrupt('return', token);

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));
  self.getUserData = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(userAuth) {
      var idToken, response, dataToSend, errorToReturn;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log('🔑 Auth 🔑 - getUserData', userAuth);
              _context3.next = 3;
              return self.refreshUserToken();

            case 3:
              idToken = _context3.sent;

              console.log('idToken (in getUserData())', idToken.substring(0, 100) + '...');

              if (!self.Testing) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt('return', testUserData);

            case 9:
              if (!idToken) {
                _context3.next = 29;
                break;
              }

              dataToSend = { idToken: idToken };
              _context3.prev = 11;
              _context3.next = 14;
              return __WEBPACK_IMPORTED_MODULE_7_axios___default()({
                method: 'post',
                // url: 'http://localhost:5050/get-user',
                url: 'https://savvy-nlp--staging.herokuapp.com/get-user',
                timeout: 10000,
                data: dataToSend
              });

            case 14:
              response = _context3.sent;

              console.log('📪  The response data!', response.data);
              return _context3.abrupt('return', response.data.results);

            case 19:
              _context3.prev = 19;
              _context3.t0 = _context3['catch'](11);

              console.error('Couldn\'t get user data', _context3.t0);
              __WEBPACK_IMPORTED_MODULE_5_logrocket___default.a.captureMessage('Couldn\'t get user data', {
                extra: {
                  err: _context3.t0,
                  data: dataToSend
                }
              });
              __WEBPACK_IMPORTED_MODULE_6_raven_js___default.a.captureMessage('Couldn\'t get user data', {
                extra: {
                  err: _context3.t0,
                  data: dataToSend
                }
              });
              errorToReturn = {
                err: _context3.t0,
                message: _context3.t0.message
              };

              if (_context3.t0 && _context3.t0.message) {
                if (_context3.t0.message === 'Network Error') errorToReturn.message = 'Network Error - Are you sure you\'re connected to the internet?';
                if (_context3.t0.message === 'Request failed with status code 404') errorToReturn.message = 'Whoops! Something went wrong - we\'re working on fixing it right now!';
              }
              return _context3.abrupt('return', null);

            case 27:
              _context3.next = 31;
              break;

            case 29:
              console.log('📛  Error! Couldn\'t get user data');
              return _context3.abrupt('return', null);

            case 31:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this, [[11, 19]]);
    }));

    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  self.getUser = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(attemptNumber) {
      var randomID, self, user, token, userData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // Trying to migrate TO this!
              randomID = parseInt(Math.random() * 10000);

              if (!attemptNumber) attemptNumber = 0;
              console.log('🔑 Auth 🔑 - self.getUser, attempt: ' + attemptNumber + ' id:', randomID);
              self = _this;
              user = self.user ? JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(self.user)) : null;

              if (user.auth) {
                _context4.next = 12;
                break;
              }

              if (!(self.authState && self.authState === 'pending' && attemptNumber < 2)) {
                _context4.next = 10;
                break;
              }

              console.log('Will wait to attempt #', attemptNumber);
              // const inceptionUser = await new Promise((resolve, reject) => {
              //   setTimeout(() => {
              //     console.log('Now attempting #', attemptNumber)
              //     self.getUser(attemptNumber + 1).then(resolve).catch(reject)
              //   }, 5000)
              // })
              // return inceptionUser
              _context4.next = 12;
              break;

            case 10:
              console.log('🔑 Auth 🔑 -  Don\'t even have user.auth yet! (Previous Attempts: ' + attemptNumber + ') Sending back null.');
              return _context4.abrupt('return', null);

            case 12:
              if (!(!user.data || user.lastRefreshed && new Date() - user.lastRefreshed > 1000 * 60 * 30)) {
                _context4.next = 25;
                break;
              }

              // Refreshes every 30 mins, since auth token expires every 60 mins
              console.log('♻️  Refreshing User Token!');
              _context4.next = 16;
              return self.refreshUserToken();

            case 16:
              token = _context4.sent;

              user.auth.stsTokenManager.accessToken = token;
              user.lastRefreshed = new Date();
              console.log('self.user', self.user);
              _context4.next = 22;
              return self.getUserData(token);

            case 22:
              userData = _context4.sent;

              user.data = userData;
              console.log('self.user1', self.user);

            case 25:
              user.refreshUserToken = self.refreshUserToken; // Need to move away from this as functions can't be passed from event-page to content-script
              user.testingtesting1 = true;
              self.user = user;
              console.log('🔑 Auth 🔑 - sending user back (async):', randomID, user);
              return _context4.abrupt('return', user);

            case 30:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  self.joinOrg = function (organisationID) {
    console.log('🔑 Auth 🔑 - joinOrg', organisationID);
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      console.log('Joining Org!');
      try {
        var dataToSend = {
          organisationID: self.organisation.id,
          verifiedEmails: self.user.auth.emails || [self.user.auth.email] // Only working for Google Auth for now
        };
        self.updateAuthState('pending');
        self.refreshUserToken().then(function (idToken) {
          dataToSend.user = { uid: self.user.auth.uid, idToken: idToken };
          return __WEBPACK_IMPORTED_MODULE_7_axios___default.a.post('https://forget-me-not--staging.herokuapp.com/api/user/add', dataToSend);
        }).then(function (res) {
          console.log(res);
          self.user.data = res.data;
          self.updateAuthState('loggedIn');
          resolve(self.user);
        }).catch(function (err) {
          self.updateAuthState('readyToJoinOrg');
          console.error('Couldn\'t join organisation', err);
          __WEBPACK_IMPORTED_MODULE_5_logrocket___default.a.captureMessage('Couldn\'t join organisation', {
            extra: {
              err: err,
              data: dataToSend
            }
          });
          __WEBPACK_IMPORTED_MODULE_6_raven_js___default.a.captureMessage('Couldn\'t join organisation', {
            extra: {
              err: err,
              data: dataToSend
            }
          });
          var errorToReturn = {
            err: err,
            message: err.message
          };
          if (err && err.message) {
            if (err.message === 'Network Error') errorToReturn.message = 'Network Error - Are you sure you\'re connected to the internet?';
            if (err.message === 'Request failed with status code 404') errorToReturn.message = 'Whoops! Something went wrong - we\'re working on fixing it right now!';
          }
          reject(err); // @TODO: Send data further up???
          // return {
          //   success: false,
          //   error: errorToReturn
          // }
        });
      } catch (e) {
        console.log(e);
      }
    });
  };
  self.forceUser = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(toForce) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              console.log('forceUser', toForce);
              self.user.data.role = toForce;
              console.log('Forced user', self.user);
              self.updateAuthState('loggedIn');
              return _context5.abrupt('return', self.user);

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function (_x4) {
      return _ref5.apply(this, arguments);
    };
  }();
};

/* harmony default export */ __webpack_exports__["a"] = (Auth);

var testUserAuth = {
  apiKey: 'AIzaSyDbf9kOP-Mb5qroUdCkup00DFya0OP5Dls',
  appName: '[DEFAULT]',
  authDomain: 'savvy-96d8b.firebaseapp.com',
  createdAt: '1509293764000',
  displayName: 'Jeremy Evans',
  email: 'jeremy@explaain.com',
  emailVerified: true,
  isAnonymous: false,
  lastLoginAt: '1517500086000',
  photoURL: 'https://lh4.googleusercontent.com/-1K9EhRUQf8c/AAAAAAAAAAI/AAAAAAAAAC0/1fqqBt0FcFw/photo.jpg',
  providerData: [{
    displayName: 'Jeremy Evans',
    email: 'jeremy@explaain.com',
    phoneNumber: null,
    photoURL: 'https://lh4.googleusercontent.com/-1K9EhRUQf8c/AAAAAAAAAAI/AAAAAAAAAC0/1fqqBt0FcFw/photo.jpg',
    providerId: 'google.com',
    uid: '104380110279658920175'
  }],
  redirectEventId: null,
  stsTokenManager: {
    accessToken: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImNhNDYwYWY5NTFhY2NjMmRlNDc0NTAwZjc5NDk4OWE0M2RlNzMwNjMifQ.eyJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vc2F2dnktOTZkOGIiLCJuYW1lIjoiSmVyZW15IEV2YW5zIiwicGljdHVyZSI6Imh0dHBzOi8vbGg0Lmdvb2dsZXVzZXJjb250ZW50LmNvbS8tMUs5RWhSVVFmOGMvQUFBQUFBQUFBQUkvQUFBQUFBQUFBQzAvMWZxcUJ0MEZjRncvcGhvdG8uanBnIiwiYXVkIjoic2F2dnktOTZkOGIiLCJhdXRoX3RpbWUiOjE1MTc1MDAwODYsInVzZXJfaWQiOiJ2WndlQ2FaRVdsWlB4MGdwUW4yYjFCN0RGQVoyIiwic3ViIjoidlp3ZUNhWkVXbFpQeDBncFFuMmIxQjdERkFaMiIsImlhdCI6MT,UxNzUwMDA4NiwiZXhwIjoxNTE3NTAzNjg2LCJlbWFpbCI6ImplcmVteUBleHBsYWFpbi5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJnb29nbGUuY29tIjpbIjEwNDM4MDExMDI3OTY1ODkyMDE3NSJdLCJlbWFpbCI6WyJqZXJlbXlAZXhwbGFhaW4uY29tIl19LCJzaWduX2luX3Byb3ZpZGVyIjoiZ29vZ2xlLmNvbSJ9fQ.fNDOB9ZuvTRN9hxpYQX8BlPSVoXmcV4DrlTVNksKgjloZeCjxXNQqhqDYJ9uc5YHTPOlFI-YPj7B8NZk2bzVDlb3-huLRmciB0QtQz9Siz7RVDGVE8NV9WrSuXAY0jwBNKPIA7o8WnDQOh_wuhMYv0pe6gPDDMZ-bDyvEgHwFY7guONg0RrITifKOJirpWNqBEnSHSOrwbThrvPHZTedDgFmAmJ_dSnRYJ1kLeBniaIDpRS2lOvcdSsakd9dsTWbkM9gUEg_UXs8LOMITtTUVkn562tLYTfoMuL34YtA9o4ed3Eo9tpICz62Y8v22zG1BylsDaEwraf32go8izHAxQ',
    apiKey: 'AIzaSyDbf9kOP-Mb5qroUdCkup00DFya0OP5Dls',
    expirationTime: 1517503685194,
    refreshToken: 'AEoYo8vHrM_cCtIeb9QXC3ani4BxKNv6Hkv4NEDn6sm0cdALXuqqCiv7X8vcFWzosv1spHmuv57amtV4mnPbLSKrJHQ32NnUZQcm3Lz6C3zV_oN2NBGoDD45b9wmnPrj-IzwUImGQU7HYdj_sLnPed86fWBvaz6awDTQaPvnZfCBuPxKjcsSRO739leq3np2XFzCI0ty6NdnOrUfaftD1zsa9XCE3ZMk9aV0hTb0bqwrQxAV5mQF8kjM_Cj74bi9WAaq_Cbl6JlhVfwgXzKbhj5UdhJrlEQhW2ytDK_WpzvFBriNFfxJBqI8d43FsF0yXSRAkWdDduGIgOsklSPsRUvy6pj40BHtsyEgrqou-uocnnLUQHXjFBE'
  },
  uid: 'vZweCaZEWlZPx0gpQn2b1B7DFAZ2'
};

var testUserData = {
  firebase: 'vZweCaZEWlZPx0gpQn2b1B7DFAZ2',
  first: 'Jeremy',
  last: 'Evans',
  objectID: 'vZweCaZEWlZPx0gpQn2b1B7DFAZ2',
  organisationID: 'explaain',
  slack: 'U04NVHJFD'
};

/***/ }),

/***/ "VsSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WI1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('field',{directives:[{name:"show",rawName:"v-show",value:(!_vm.editing),expression:"!editing"}],staticClass:"row-header title",attrs:{"label":"description","content":_vm.content.description,"editing":_vm.editing,"truncate":_vm.full},on:{"update":_vm.update}}),_vm._v(" "),(_vm.content.cells)?_c('list',{attrs:{"listItems":{value: _vm.content.cells.value.map(function (cell, i) { return i; }), state: 'pending'},"listCards":{value: _vm.content.cells.value.map(function (cell, i) { if (!cell.objectID) { cell.objectID = i; } return cell }), state: 'pending'},"full":_vm.full,"allCards":_vm.allCards,"editing":_vm.editing},on:{"update":_vm.update,"cardletClick":_vm.cardletClick}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WqJl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X0Wz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X9NS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard"}},[_c('div',{staticClass:"topBanner"},[_vm._m(0),_vm._v(" "),(_vm.auth.authState == 'loggedIn')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],staticClass:"search",attrs:{"autofocus":"","type":"text","placeholder":"Search for cards..."},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.auth.authState == 'loggedIn')?_c('ibutton',{attrs:{"text":"Search","icon":"search","click":_vm.search}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"spacer"})],1),_vm._v(" "),_c('section',{staticClass:"container"},[_c('div',{staticClass:"sidebar",class:{disabled: !_vm.auth.user || !_vm.auth.user.data},attrs:{"id":"navigation-sidebar"}},[_c('div',{staticClass:"option-profile"},[_c('img',{attrs:{"src":_vm.auth.authState == 'loggedIn' && _vm.auth.user.data.name ? _vm.auth.user.auth.photoURL : '/images/profile.jpg',"alt":""}}),_vm._v(" "),_c('h3',[_vm._v("Hey "+_vm._s(_vm.auth.authState == 'loggedIn' && _vm.auth.user.data.name ? _vm.auth.user.data.name.first : 'there')+"!")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.auth.authState == 'loggedIn' && _vm.auth.user.data.name ? _vm.organisation.id + ' Team' : 'Team Member'))])]),_vm._v(" "),_c('router-link',{staticClass:"option exact",attrs:{"id":"home","to":"/"}},[_vm._v("\n        🏠   Home\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"option",attrs:{"id":"analytics","to":"/analytics"}},[_vm._v("\n        📈   Analytics "),_c('span',{staticStyle:{"color":"#bb6666","font-size":"14px","font-style":"italic"}},[_vm._v("  Coming Soon")])]),_vm._v(" "),_c('router-link',{staticClass:"option",attrs:{"id":"card-manager","to":"/card-manager"}},[_vm._v("\n        🗳   Card Manager "),_c('span',{staticStyle:{"color":"#bb6666","font-size":"14px","font-style":"italic"}},[_vm._v("  Coming Soon")])]),_vm._v(" "),_c('router-link',{staticClass:"option",attrs:{"id":"files","to":"/files"}},[_vm._v("\n        🗂   Files "),_c('span',{staticStyle:{"color":"#bb6666","font-size":"14px","font-style":"italic"}},[_vm._v("  Coming Soon")])]),_vm._v(" "),(_vm.auth.user && _vm.auth.user.auth)?_c('div',{staticClass:"option",attrs:{"disabled":_vm.auth.authState == 'pending'},on:{"click":_vm.toggleSignIn}},[_vm._v("\n        💤   Sign Out\n      ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"routerView"},[_c('router-view',{attrs:{"plugin":false,"organisation":_vm.organisation,"auth":_vm.auth}},[_c('h1',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"emoji"},[_vm._v("🗳")]),_vm._v(" Card Manager")]),_vm._v(" "),_c('h2',{attrs:{"slot":"header"},slot:"header"},[_vm._v("We've made it super easy to view, edit, delete, create and manage all of your company knowledge in one place.")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logoContainer"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("7Otq")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XtJQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YsCb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pci.7818eb9.png";

/***/ }),

/***/ "Zrdd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connect_page_vue__ = __webpack_require__("/GM2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308e3a70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connect_page_vue__ = __webpack_require__("4Wcu");
function injectStyle (ssrContext) {
  __webpack_require__("HyuK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_connect_page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_308e3a70_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_connect_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZwKY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "alVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[(_vm.content || _vm.editing)?_c('editable-markdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.content && _vm.content.value || _vm.editing),expression:"content && content.value || editing"}],staticClass:"field",class:[_vm.label, _vm.content && _vm.content.state],attrs:{"fieldName":_vm.label,"content":_vm._f("truncateValue")(_vm.content,_vm.truncate),"editable":_vm.editing,"placeholder":_vm._f("capitalise")(_vm.label)},on:{"update":_vm.update}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b2/t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aicpa.88d66a1.png";

/***/ }),

/***/ "bGfq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editable_vue__ = __webpack_require__("srgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__editable_markdown_vue__ = __webpack_require__("uE8u");
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['card', 'editing', 'editable'],
  computed: {
    cardletEditable: function cardletEditable() {
      return this.editing && this.editable;
    },
    text: {
      get: function get() {
        var text = this.card.description || '';
        var snippetLength = 60;
        var snippetStart = Math.max(text.indexOf('**') - snippetLength / 2, 0);
        return this.full ? text : text.trunc(snippetStart, snippetLength, true);
      },
      set: function set(val) {
        this.card.description = val;
      }
    },
    greyed: function greyed() {
      return this.text.indexOf('**') === -1;
    }
  },
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_2__ibutton_vue__["a" /* default */],
    editable: __WEBPACK_IMPORTED_MODULE_3__editable_vue__["a" /* default */],
    EditableMarkdown: __WEBPACK_IMPORTED_MODULE_4__editable_markdown_vue__["a" /* default */]
  },
  methods: {
    removeCardlet: function removeCardlet() {
      var self = this;
      self.$emit('remove', self.card);
    },
    cardletClick: function cardletClick() {
      var self = this;
      console.log('cardletClick');
      self.$emit('cardletClick', self.card);
    },
    update: function update(data) {
      if (this.card.label) {
        this.card.value = data.value;
        this.card.content = this.card.label + ': ' + this.card.value;
      }
      console.log('update (cardlet.vue)', this.card);
      this.$emit('update', this.card);
    }
  }
});

String.prototype.trunc = function (start, length, useWordBoundary) {
  if (this.length <= length) return this;
  var subString = this.substr(start, length - 1);
  return (start > 0 ? '...' : '') + (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
};

/***/ }),

/***/ "bOqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['icon', 'image', 'text', 'click', 'clickProps', 'link', 'samePage'],
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  methods: {
    clickEvent: function clickEvent() {
      var self = this;
      if (self.click) {
        if (self.clickProps !== undefined) self.click(self.clickProps);else self.click();
      }
    }
  }
});

/***/ }),

/***/ "bSwa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_panel_vue__ = __webpack_require__("CNux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be2c347_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_panel_vue__ = __webpack_require__("tTyo");
function injectStyle (ssrContext) {
  __webpack_require__("AwYf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_popup_panel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be2c347_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_popup_panel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bvny":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__ = __webpack_require__("w4qd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98b232a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__ = __webpack_require__("WI1u");
function injectStyle (ssrContext) {
  __webpack_require__("QSjX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e98b232a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d62z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardlet",class:{ 'show-more': _vm.card.objectID === -1, 'empty': (!_vm.card.description || !_vm.card.description.length) && (!_vm.card.value || !_vm.card.value.length) && _vm.card.objectID !== -1 },on:{"click":function($event){$event.stopPropagation();_vm.cardletClick($event)}}},[(_vm.card.label && _vm.card.label.length)?_c('editable-markdown',{staticClass:"label",class:{ greyed: _vm.greyed },attrs:{"content":_vm.card.label.replace(':', ''),"editable":false},on:{"update":_vm.update}}):_vm._e(),_vm._v(" "),((_vm.card.value && _vm.card.value.length) || (_vm.editable && _vm.editing))?_c('editable-markdown',{staticClass:"value",class:{ greyed: _vm.greyed },attrs:{"content":_vm.card.value,"editable":_vm.editing && _vm.editable,"fieldName":_vm.card.label.split(' ').join('_')},on:{"update":_vm.update}}):_vm._e(),_vm._v(" "),(_vm.card.description && _vm.card.description.length)?_c('editable-markdown',{class:{ greyed: _vm.greyed },attrs:{"content":_vm.text,"editable":_vm.editing && _vm.editable},on:{"update":_vm.update}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dKPT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__field_vue__ = __webpack_require__("6Pqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list_vue__ = __webpack_require__("qK+6");
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'full', 'allCards', 'position', 'editing'],
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__field_vue__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_1__list_vue__["a" /* default */]
  },
  methods: {
    update: function update(data) {
      this.$emit('update', data);
    },
    cardletClick: function cardletClick(card) {
      console.log('cardletClick (basic.vue)', card);
      this.$emit('cardletClick', card);
    }
  }
});

/***/ }),

/***/ "dUX1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topics_vue__ = __webpack_require__("SRt3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d8466b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topics_vue__ = __webpack_require__("NzvQ");
function injectStyle (ssrContext) {
  __webpack_require__("mfOO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topics_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26d8466b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topics_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.');
            return false;
          }
          return true;
        }
        console.warn('Invalid prop: prop "name" is required.');
        return false;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=["']?([^"')\s]+)/g, function (match, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "eqfd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['submit', 'data'],
  mixins: [__WEBPACK_IMPORTED_MODULE_2_vue_clickaway__["mixin"]],
  components: {
    icon: __WEBPACK_IMPORTED_MODULE_1_vue_awesome_components_Icon_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },
  methods: {
    submitEvent: function submitEvent() {
      this.$emit('close');
      this.$emit('submit', this.data);
    },
    away: function away() {
      this.$emit('close');
    }
  }
});

/***/ }),

/***/ "gCcF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/connect.16b3d32.png";

/***/ }),

/***/ "h2zT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hrwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboards__ = __webpack_require__("Yk46");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_clipboards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_clipboards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button__ = __webpack_require__("nkUn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_es_components_alert_alert__ = __webpack_require__("HDlv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__spinner_vue__ = __webpack_require__("spwi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__cardlet_vue__ = __webpack_require__("t8wU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__editable_vue__ = __webpack_require__("srgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__search_vue__ = __webpack_require__("OFKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__topics_vue__ = __webpack_require__("dUX1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__formats_basic__ = __webpack_require__("TbJl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__formats_media__ = __webpack_require__("MZ5w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__formats_issue__ = __webpack_require__("Tn6p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__formats_row__ = __webpack_require__("bvny");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_clipboards___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['explaain', 'plugin', 'data', 'full', 'allCards', 'auth', 'pendingApproval', 'position', 'highlight', 'userRole', 'userTopics', 'creating', 'highlightResult', 'mode'],
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_6_vue_awesome_components_Icon_vue__["a" /* default */],
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_7_vue_markdown___default.a,
    ibutton: __WEBPACK_IMPORTED_MODULE_12__ibutton_vue__["a" /* default */],
    Cardlet: __WEBPACK_IMPORTED_MODULE_13__cardlet_vue__["a" /* default */],
    Editable: __WEBPACK_IMPORTED_MODULE_14__editable_vue__["a" /* default */],
    Draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a,
    Search: __WEBPACK_IMPORTED_MODULE_15__search_vue__["a" /* default */],
    bAlert: __WEBPACK_IMPORTED_MODULE_10_bootstrap_vue_es_components_alert_alert__["a" /* default */],
    Topics: __WEBPACK_IMPORTED_MODULE_16__topics_vue__["a" /* default */],
    Basic: __WEBPACK_IMPORTED_MODULE_17__formats_basic__["a" /* default */],
    Media: __WEBPACK_IMPORTED_MODULE_18__formats_media__["a" /* default */],
    Issue: __WEBPACK_IMPORTED_MODULE_19__formats_issue__["a" /* default */],
    Row: __WEBPACK_IMPORTED_MODULE_20__formats_row__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_11__spinner_vue__["a" /* default */]
  },
  data: function data() {
    return {
      card: {},
      tempListCards: {},
      editing: false,
      copyIcon: '/static/images/clipboard.svg', // //static//
      showListSearch: false,
      reacted: false,
      showPending: true,
      highlightedContent: {},
      loading: false,
      error: null,
      triedtoEdit: false
    };
  },
  computed: {
    content: function content() {
      var _this = this;

      // @TODO: figure out how listCards fit into this
      // const subLayers = ['pendingContent', 'listCards']
      console.log('THISTHIS');
      console.log(this.card);
      console.log(this.highlightedContent);
      var subLayers = ['pendingContent'];
      var preferHighlight = function preferHighlight(key, initialKey, loop) {
        if (initialKey) {
          if (key) return _this.highlightedContent && _this.highlightedContent[initialKey] && _this.highlightedContent[initialKey][key] ? _this.highlightedContent[initialKey][key].value : _this.card[initialKey][key];else return _this.highlightedContent && _this.highlightedContent[initialKey] && _this.highlightedContent[initialKey].length ? _this.highlightedContent[initialKey].map(function (item) {
            return item.value;
          }) : _this.card[initialKey];
        } else return _this.highlightedContent && _this.highlightedContent[key] ? _this.highlightedContent[key].value : _this.card[key];
      };
      var content = {};
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.card).filter(function (key) {
        return subLayers.indexOf(key) === -1;
      }).forEach(function (key) {
        content[key] = {
          value: key === 'listCards' ? preferHighlight(false, key).map(function (description, i) {
            return {
              objectID: _this.card.listItems.value ? _this.card.listItems.value[i] : _this.card.listItems[i],
              description: description
            };
          }) : preferHighlight(key),
          state: 'verified'
        };
      });
      if (this.card.pendingContent && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.card.pendingContent)) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.card.pendingContent).forEach(function (key) {
          content[key] = {
            value: _this.showPending ? preferHighlight(key, 'pendingContent') : preferHighlight(key),
            state: _this.showPending ? 'pending' : 'reverted'
          };
        });
      }

      // subLayers.forEach(initialKey => {
      //   if (this.card[initialKey] && Object.keys(this.card[initialKey])) {
      //     Object.keys(this.card[initialKey]).forEach(key => {
      //       content[key] = {
      //         value: this.showPending ? preferHighlight(key, initialKey) : preferHighlight(key),
      //         state: this.showPending ? 'pending' : 'reverted'
      //       }
      //     })
      //   }
      // })
      return content;
    },
    format: function format() {
      var service = this.data.cells ? 'gsheets' : this.data.fileType ? {
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'gdocs'
      }[this.data.fileType] || this.data.service : this.data.service;
      // const fileCardServices = [
      //   'gsheets'
      // ]
      if (this.data.imageUrl) return 'media';else if (this.data.type === 'file') {
        switch (service) {
          case 'sifter':
          case 'zoho':
            return 'issue';
          case 'gdocs':
            return 'doc';
          case 'gsheets':
            return 'sheet';
          case 'gslides':
            return 'slide';
          case 'gmail':
            return 'email';
          default:
            return 'basic';
        }
      } else {
        switch (service) {
          case 'gsheets':
            return 'row';
          default:
            return 'basic';
        }
      }
    },
    text: {
      get: function get() {
        var text = this.card.description || '';
        // if (!text || !text.length) console.log(text)
        var snippetLength = 100;
        var snippetStart = Math.max(text.indexOf('**') - snippetLength / 2, 0);
        return this.full ? text : text.trunc(snippetStart, snippetLength, true);
      },
      set: function set(val) {
        this.card.description = val;
      }
    },
    cardIcon: function cardIcon() {
      return {
        doc: '/static/images/icons/formats/doc.png',
        sheet: '/static/images/icons/formats/sheet.png',
        row: '/static/images/icons/formats/row.png',
        issue: '/static/images/icons/formats/bug.png',
        card: '/static/images/icons/formats/card.png',
        email: '/static/images/icons/formats/email.png'
      }[this.format] || {
        webpage: '/static/images/icons/formats/webpage.png',
        file: '/static/images/icons/formats/file.png'
      }[this.data.type] || {
        gmail: '/static/images/icons/formats/email.png',
        gdrive: '/static/images/icons/formats/doc.png',
        gdocs: '/static/images/icons/formats/doc.png',
        gslides: '/static/images/icons/formats/doc.png',
        dropbox: '/static/images/icons/formats/doc.png',
        trello: '/static/images/icons/formats/card.png'
      }[this.data.service] || (this.data.fileID ? '/static/images/icons/formats/file.png' : '/static/images/iconGrey.png');
    },
    fullText: function fullText() {
      return (this.card.title ? this.card.title + '\n\n' : '') + this.text + (this.card.cardList && this.card.cardList.length ? '\n- ' + (this.card.cardList || []).map(function (item) {
        return item.description;
      }).join('\n- ') : '') + (this.card.cells && this.card.cells.length ? '\n- ' + (this.card.cells || []).filter(function (cell) {
        return cell.content.length;
      }).map(function (cell) {
        return cell.content;
      }).join('\n- ') : '');
      //  + this.listCards.map(function(listCard) {
      //   return '\n- ' + listCard.description
      // })
    },
    fontSize: function fontSize() {
      // const self = this
      // return 16 + 2 * Math.floor(Math.min(5, 100 / (self.text.length))) + 'px'
      return 16 + 'px';
    },
    errorMessage: function errorMessage() {
      var self = this;
      return self.error && self.error.message ? self.error.message : (!self.card || !__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(self.card).length) && !self.loading ? 'No card found!' : null;
    },
    warningMessage: function warningMessage() {
      var self = this;
      return self.card.pendingDelete ? 'This card is pending deletion' : this.triedtoEdit ? 'Docs editing is coming soon! Try editing a Google Sheet card.' : null;
    },
    numberOfPendingChanges: function numberOfPendingChanges() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.card.pendingContent).filter(function (key) {
        return _this2.card.pendingContent[key] && _this2.card.pendingContent[key].length && _this2.card.pendingContent[key] !== _this2.card[key];
      }).length;
    },
    lastUpdatedText: function lastUpdatedText() {
      var daysOld = parseInt(Math.floor((new Date() - new Date(this.card.modified * 1000)) / (1000 * 60 * 60 * 24)));
      if (daysOld === 0) return 'Today';else if (daysOld === 1) return '1 Day Ago';else if (daysOld < 7) return daysOld + ' Days Ago';else if (daysOld < 10) return '1 Week Ago';else if (daysOld < 29) return parseInt(Math.round(daysOld / 7)) + ' Weeks Ago';else return new Date(this.card.modified * 1000).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).replace(' 2018', '');
    },
    userIsSavvy: function userIsSavvy() {
      var _this3 = this;

      return !!(this.userRole === 'admin' || this.card && (!this.card.topics || !this.card.topics.length || this.userTopics && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(this.userTopics) === 'object' && this.userTopics.constructor === Array && this.userTopics.filter(function (topic) {
        return _this3.card.topics.indexOf(topic) > -1;
      }).length));
    },
    fileFormat: function fileFormat() {
      return this.data.type === 'file' && ['sifter', 'zoho'].indexOf(this.data.service) === -1 && this.format !== 'media';
    }
  },
  watch: {
    data: {
      handler: function handler(val) {
        if (!this.editing) this.syncData();
      },
      deep: true
    },
    editing: function editing(val) {
      var self = this;
      if (val && self.content.listCards && self.content.listCards.value) self.content.listCards.value.forEach(function (listCard) {
        self.tempListCards[listCard.objectID] = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(listCard));
      });
    }
  },
  created: function created() {
    this.syncData();
    // @NOTE: Temporarily disabling highlightedContent, as it's breaking 'content'
    // this.highlightedContent = this.card._highlightResult || this.highlightResult
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_js_toggle_button___default.a);
    if (this.card.newlyCreated) this.editing = true;
  },
  updated: function updated() {
    // @NOTE: Temporarily disabling highlightedContent, as it's breaking 'content'
    // this.highlightedContent = this.card._highlightResult || this.highlightResult
  },
  methods: {
    update: function update(data) {
      console.log('update (card)', data);
      this.card[data.field] = data.value;
    },
    getService: function getService(card, file) {
      var defaultService = {
        name: '📂 ' + (this && this.user && this.user.data && this.user.data.organisation && this.user.data.organisation.id ? this.user.data.organisation.id : 'Team') + ' Drive'
      };
      var services = {
        gdrive: {
          name: 'Google Drive',
          icon: '/static/images/icons/gdrive.png',
          url: 'https://drive.google.com/'
        },
        gdocs: {
          name: 'Google Drive',
          icon: '/static/images/icons/gdrive.png',
          url: 'https://drive.google.com/'
        },
        gsheets: {
          name: 'Google Drive',
          icon: '/static/images/icons/gdrive.png',
          url: 'https://drive.google.com/'
        },
        gslides: {
          name: 'Google Drive',
          icon: '/static/images/icons/gdrive.png',
          url: 'https://drive.google.com/'
        },
        gmail: {
          name: 'Gmail',
          icon: '/static/images/icons/gmail.png',
          url: 'https://mail.google.com/'
        },
        sifter: {
          name: 'Sifter',
          icon: '/static/images/icons/sifter.png'
        },
        confluence: {
          name: '📂 Confluence'
        },
        zoho: {
          name: 'Zoho',
          icon: '/static/images/icons/zoho.png'
        },
        gsites: {
          name: 'Google Sites',
          icon: '/static/images/icons/gsites.png'
        },
        trello: {
          name: 'Trello',
          icon: '/static/images/icons/trello.png',
          url: 'https://trello.com/'
        },
        dropbox: {
          name: 'Dropbox',
          icon: '/static/images/icons/dropbox.png',
          url: 'https://dropbox.com/'
        }
      };
      var fileTypes = {
        'application/vnd.google-apps.document': 'gdocs',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'gdocs',
        'application/vnd.google-apps.spreadsheet': 'gsheets',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'gsheets',
        'application/vnd.google-apps.presentation': 'gslides',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'gslides'
      };
      if (file && file.folder) return { name: '📂 ' + file.folder + ' Drive'
        // else if (file && file.subService)
        //   return services[file.subService] || defaultService
      };else if (file && file.service) return services[file.service] || defaultService;
      // else if (card && card.subService)
      //   return services[card.subService] || defaultService
      else if (card && card.service) return services[card.service] || defaultService;else if (card && (card.fileType || card.mimeType || file.fileType || file.mimeType)) return services[fileTypes[card.fileType || card.mimeType || file.fileType || file.mimeType]] || defaultService;else return defaultService;
    },

    getFileIcon: function getFileIcon(file) {
      if (!file || !file.mimeType && !file.fileType) return '/static/images/iconGrey.png';
      switch (file.mimeType || file.fileType) {
        case 'application/vnd.google-apps.document':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return '/static/images/icons/gdocs.png';
        case 'application/vnd.google-apps.spreadsheet':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          return '/static/images/icons/gsheets.png';
        case 'application/vnd.google-apps.presentation':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
          return '/static/images/icons/gslides.png';
        case 'application/pdf':
          return 'https://cdn1.iconfinder.com/data/icons/adobe-acrobat-pdf/154/adobe-acrobat-pdf-file-512.png';
        case 'image/png':
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/gif':
          return 'https://cdn3.iconfinder.com/data/icons/faticons/32/picture-01-512.png';
        default:
          return 'https://cdn4.iconfinder.com/data/icons/48-bubbles/48/12.File-512.png';
      }
    },
    getFileTitle: function getFileTitle(file) {
      return this.format === 'issue' ? 'Issue #' + (this.card.integrationFields.key || this.card.integrationFields.number) : file && file.title ? file.title : '';
    },
    syncData: function syncData() {
      this.card = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data));
    },
    linkClick: function linkClick(event) {
      var self = this;
      if (event.srcElement.nodeName === 'A') {
        event.stopPropagation();
        var myRegexp = /\[.*?\]\((.*?)\)/g;
        var match = myRegexp.exec(self.text);
        var toLayerKeys = [];
        while (match != null) {
          toLayerKeys.push(match[1].replace('#', ''));
          match = myRegexp.exec(self.text);
        }
        var data = {
          // type: 'link',
          toURI: event.srcElement.hash.replace('#', ''),
          fromPos: self.position,
          toLayerKeys: toLayerKeys
        };
        data.toPos = [data.fromPos[0] + 1, data.toLayerKeys.indexOf(data.toURI)];
        this.$emit('showCard', data);
      }
    },
    cardMouseover: function cardMouseover() {
      var self = this;
      this.$emit('cardMouseover', self.card);
    },
    cardMouseout: function cardMouseout() {
      var self = this;
      this.$emit('cardMouseout', self.card);
    },
    cardClick: function cardClick() {
      var self = this;
      console.log('cardClick');
      if (!this.editing) this.$emit('cardClick', self.card);

      var data = {
        // type: 'select',
        // toURI: event.srcElement.hash.replace('#', ''),
        fromPos: self.position,
        toPos: self.position
        // fromDOM: getCardDOM(triggerTarget),
        // toLayerKeys: toLayerKeys
      };
      this.$emit('showCard', data);
    },
    cardletClick: function cardletClick(card) {
      console.log('cardletClick (card.vue)', card);
      card.parentCard = this.card;
      if (!this.editing) this.$emit('cardClick', card);
    },
    fileClick: function fileClick(file) {
      this.$emit('fileClick', this.card, file);
    },
    serviceClick: function serviceClick(service) {
      if (service && service.url) this.$emit('serviceClick', this.card, service);
    },
    createCard: function createCard() {
      // Hi
    },
    editCard: function editCard() {
      if (this.card.fileType !== 'application/vnd.google-apps.document') this.editing = true;else this.triedtoEdit = true;
    },
    deleteCard: function deleteCard() {
      var self = this;
      self.loading = true;
      self.$emit('deleteCard', self.card.objectID, function (result) {
        console.log('callback successful', result);
        self.loading = false;
        if (result.error) {
          self.error = result.error;
        }
      }, function (err) {
        console.log('error returned', err);
        self.error = {
          err: err,
          message: 'Whoops! Something went wrong.'
        };
      });
    },
    cancelEdit: function cancelEdit() {
      var self = this;
      self.syncData();
      self.editing = false;
      self.error = null; // @TODO: Brainstorm any situations where this isn't a good idea?
      // self.tempListCards = {} ????
      setTimeout(function () {
        self.syncData(); // Shouldn't be necessary if data were properly being wtached deeply
      }, 10);
    },
    saveEdit: function saveEdit(card) {
      // Can specify the 'card' argument to override what is saved (e.g. in cancelPendingDelete)
      var self = this;
      self.editing = false;
      self.loading = true;
      setTimeout(function () {
        if (self.card.sources && self.card.sources.filter(function (source) {
          return source.name === 'Journalist';
        }).length === 0) self.card.sources.push({
          type: 'author',
          name: 'Journalist'
        });
        self.card.listCards = self.listCards;
        if (self.content.listCards && self.content.listCards.value) self.content.listCards.value.forEach(function (listCard) {
          self.tempListCards[listCard.objectID] = listCard;
        });
        self.$emit('updateCard', card || self.card, function (result) {
          console.log('callback successful', result);
          self.loading = false;
          if (result.error) {
            self.error = result.error;
            self.editing = true;
          }
          self.tempListCards = {};
          // self.syncData() // Shouldn't be necessary if data were properly being wtached deeply
        }, function (err) {
          console.log('error returned', err);
          self.error = {
            err: err,
            message: 'Whoops! Something went wrong.'
          };
          self.editing = true;
          self.tempListCards = {};
        });
        self.card = {};
      }, 5);
    },
    verify: function verify(approve) {
      console.log('verify', approve);
      var self = this;
      var data = {
        objectID: self.card.objectID,
        approve: approve,
        callback: function callback(result) {}
      };
      self.editing = false;
      self.loading = true;
      self.$emit('verifyCard', data, function (result) {
        console.log('callback successful');
        self.loading = false;
        if (result.error) {
          self.error = result.error;
        }
      }, function (e) {
        console.log(e);
        self.tempListCards = {};
      });
    },
    contentUpdate: function contentUpdate(content) {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(content).forEach(function (key) {
        self.data[key] = content[key];
        self.card[key] = content[key];
      });
    },
    cancelPendingDelete: function cancelPendingDelete() {
      var self = this;
      var card = {
        objectID: self.card.objectID,
        pendingDelete: false
      };
      this.saveEdit(card);
    },
    addListItem: function addListItem(card) {
      console.log(card);
      var self = this;
      if (!card) card = {
        objectID: 'TEMP_' + Math.floor(Math.random() * 10000000000),
        intent: 'store',
        description: ''
      };
      self.tempListCards[card.objectID] = card;
      if (!self.card.listItems) __WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(self.card, 'listItems', []);
      self.card.listItems.push(card.objectID);
    },
    removeListItem: function removeListItem(data) {
      var listIndex = this.card.listItems.indexOf(data.objectID); // Doesn't account for same item appearing twice in list
      this.card.listItems.splice(listIndex, 1);
    },
    toggleListSearch: function toggleListSearch() {
      this.showListSearch = !this.showListSearch;
    },
    copy: function copy(e) {
      // The v-clipboard directive has already copied the text from the card - this function just shows the alert
      this.$emit('copy');
    },
    react: function react(reaction) {
      var self = this;
      self.$emit('react', { reaction: reaction, card: self.card });
      self.reacted = true;
    }
  }
});

String.prototype.trunc = function (start, length, useWordBoundary) {
  if (this.length <= length) return this;
  var subString = this.substr(start, length - 1);
  return (start > 0 ? '...' : '') + (useWordBoundary ? subString.substr(0, subString.lastIndexOf(' ')) : subString) + '...';
};

/***/ }),

/***/ "iS8+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{'sidebar-true': _vm.sidebar}},[(_vm.authState === 'loggedOut' || _vm.justClicked)?_c('section',{staticClass:"chooseOrg"},[_c('h3',[_vm._v("Hello! 👋 Please sign in below:")]),_vm._v(" "),_c('button',{staticClass:"login",attrs:{"disabled":_vm.authState === 'pending'},on:{"click":_vm.signIn}},[_vm._v("Sign In")]),_vm._v(" "),(_vm.errorMessage)?_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.authState === 'pending')?_c('spinner',{staticClass:"div-spinner"}):_vm._e(),_vm._v(" "),(_vm.authState === 'loggedIn')?_c('explorer',{attrs:{"plugin":_vm.plugin,"sidebar":_vm.sidebar,"logo":_vm.logo,"Controller":_vm.Controller,"authState":_vm.authState,"user":_vm.user,"local":_vm.local,"organisation":_vm.organisation,"testing":_vm.testing,"mode":_vm.mode},on:{"closeDrawer":_vm.closeDrawer}},[_c('div',{staticClass:"chrome-header",attrs:{"slot":"header"},slot:"header"},[_c('img',{staticClass:"savvy-logo",attrs:{"src":_vm.logo,"alt":""}}),_vm._v(" "),(_vm.mode === 'demo')?_c('ibutton',{staticClass:"demo-info",attrs:{"icon":"question-circle","text":"Demo Info","click":_vm.showDemoInfoPanel}}):_vm._e(),_vm._v(" "),_c('b-dropdown',{staticClass:"profile",attrs:{"id":"user-ddown1","text":"User","variant":"link","size":"lg","no-caret":""}},[_c('template',{slot:"button-content"},[_c('img',{class:_vm.user && _vm.user.data && _vm.user.data.role,attrs:{"src":_vm.profileImage}})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.showConnectPanel = true}}},[_vm._v("🔌 Connect Services")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"href":"https://heysavvy.drift.com/matt","target":"_blank"}},[_vm._v("👋 Contact Us")])],2)],1),_vm._v(" "),_c('div',{staticClass:"greeting",attrs:{"slot":"greeting"},slot:"greeting"},[_c('h3',[(_vm.mode === 'demo')?_c('span',[_vm._v("Hey YC.")]):_c('span',[_vm._v("Hi"+_vm._s(_vm.user && _vm.user.auth && _vm.user.auth.displayName ? ' ' + _vm.user.auth.displayName.split(' ')[0] : '')+".")]),_vm._v(" What are we looking for?")])])]):_vm._e(),_vm._v(" "),(_vm.showConnectPanel)?_c('div',{staticClass:"popup-panel-container",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.showConnectPanel = false}}},[_c('connect',{attrs:{"services":_vm.services,"organisationID":_vm.user.data.organisationID}})],1):_vm._e(),_vm._v(" "),(_vm.demoInfoPanel)?_c('div',{staticClass:"popup-panel-container demo-info",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.demoInfoPanel = false}}},[_c('popup-panel',{attrs:{"title":"👋🏼 Hello Y Combinator"}},[_c('div',[_c('p',{staticStyle:{"margin-top":"30px"}},[_vm._v("We've added a mixture of spreadsheets, docs and images to a fictional Google Drive.")]),_vm._v(" "),_c('ibutton',{attrs:{"text":"You can see the files here","image":"/static/images/icons/gdrive.png","link":"https://drive.google.com/drive/folders/1IImIf4ttNiE3PPnd6K_34qWS8ALpbweE?usp=sharing"}}),_vm._v(" "),_c('p',[_vm._v("On this version of Savvy you can:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("🔍 "),_c('b',[_vm._v("Search")]),_vm._v(" - files, content within files, paragraphs and sentences, records in a spreadsheet")]),_vm._v(" "),_c('li',[_vm._v("🖊 "),_c('b',[_vm._v("Edit")]),_vm._v(" - spreadsheets only on this version but watch how it automatically syncs with the master copy (e.g. "),_c('a',{attrs:{"href":"https://docs.google.com/spreadsheets/d/1v7uDscxKm8aXmbCv13wLB9q1na_zXqA1VxRMTHW1wVg","target":"_blank"}},[_vm._v("here")]),_vm._v(" and "),_c('a',{attrs:{"href":"https://docs.google.com/spreadsheets/d/1YZWZl7y2cmPi33lBgVwejTl61L3EP1G3V8u9kdndxrc/","target":"_blank"}},[_vm._v("here")]),_vm._v(")")]),_vm._v(" "),_c('li',[_vm._v("🗂 "),_c('b',[_vm._v("Create")]),_vm._v(" - a new plain text card and assign tags etc.")])]),_vm._v(" "),_c('ibutton',{staticClass:"primary action",attrs:{"text":"Have a play","icon":"arrow-right","click":_vm.hideDemoInfoPanel}})],1)])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "is4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);





/*! jQuery v3.3.1 | (c) JS Foundation and other contributors | jquery.org/license */
!function (e, t) {
  "use strict";
  "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(module)) && "object" == __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(module.exports) ? module.exports = e.document ? t(e, !0) : function (e) {
    if (!e.document) throw new Error("jQuery requires a window with a document");return t(e);
  } : t(e);
}("undefined" != typeof window ? window : this, function (e, t) {
  "use strict";
  var n = [],
      r = e.document,
      i = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default.a,
      o = n.slice,
      a = n.concat,
      s = n.push,
      u = n.indexOf,
      l = {},
      c = l.toString,
      f = l.hasOwnProperty,
      p = f.toString,
      d = p.call(Object),
      h = {},
      g = function e(t) {
    return "function" == typeof t && "number" != typeof t.nodeType;
  },
      y = function e(t) {
    return null != t && t === t.window;
  },
      v = { type: !0, src: !0, noModule: !0 };function m(e, t, n) {
    var i,
        o = (t = t || r).createElement("script");if (o.text = e, n) for (i in v) {
      n[i] && (o[i] = n[i]);
    }t.head.appendChild(o).parentNode.removeChild(o);
  }function x(e) {
    return null == e ? e + "" : "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e)) || "function" == typeof e ? l[c.call(e)] || "object" : typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e);
  }var b = "3.3.1",
      w = function w(e, t) {
    return new w.fn.init(e, t);
  },
      T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;w.fn = w.prototype = { jquery: "3.3.1", constructor: w, length: 0, toArray: function toArray() {
      return o.call(this);
    }, get: function get(e) {
      return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
    }, pushStack: function pushStack(e) {
      var t = w.merge(this.constructor(), e);return t.prevObject = this, t;
    }, each: function each(e) {
      return w.each(this, e);
    }, map: function map(e) {
      return this.pushStack(w.map(this, function (t, n) {
        return e.call(t, n, t);
      }));
    }, slice: function slice() {
      return this.pushStack(o.apply(this, arguments));
    }, first: function first() {
      return this.eq(0);
    }, last: function last() {
      return this.eq(-1);
    }, eq: function eq(e) {
      var t = this.length,
          n = +e + (e < 0 ? t : 0);return this.pushStack(n >= 0 && n < t ? [this[n]] : []);
    }, end: function end() {
      return this.prevObject || this.constructor();
    }, push: s, sort: n.sort, splice: n.splice }, w.extend = w.fn.extend = function () {
    var e,
        t,
        n,
        r,
        i,
        o,
        a = arguments[0] || {},
        s = 1,
        u = arguments.length,
        l = !1;for ("boolean" == typeof a && (l = a, a = arguments[s] || {}, s++), "object" == (typeof a === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(a)) || g(a) || (a = {}), s === u && (a = this, s--); s < u; s++) {
      if (null != (e = arguments[s])) for (t in e) {
        n = a[t], a !== (r = e[t]) && (l && r && (w.isPlainObject(r) || (i = Array.isArray(r))) ? (i ? (i = !1, o = n && Array.isArray(n) ? n : []) : o = n && w.isPlainObject(n) ? n : {}, a[t] = w.extend(l, o, r)) : void 0 !== r && (a[t] = r));
      }
    }return a;
  }, w.extend({ expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(e) {
      throw new Error(e);
    }, noop: function noop() {}, isPlainObject: function isPlainObject(e) {
      var t, n;return !(!e || "[object Object]" !== c.call(e)) && (!(t = i(e)) || "function" == typeof (n = f.call(t, "constructor") && t.constructor) && p.call(n) === d);
    }, isEmptyObject: function isEmptyObject(e) {
      var t;for (t in e) {
        return !1;
      }return !0;
    }, globalEval: function globalEval(e) {
      m(e);
    }, each: function each(e, t) {
      var n,
          r = 0;if (C(e)) {
        for (n = e.length; r < n; r++) {
          if (!1 === t.call(e[r], r, e[r])) break;
        }
      } else for (r in e) {
        if (!1 === t.call(e[r], r, e[r])) break;
      }return e;
    }, trim: function trim(e) {
      return null == e ? "" : (e + "").replace(T, "");
    }, makeArray: function makeArray(e, t) {
      var n = t || [];return null != e && (C(Object(e)) ? w.merge(n, "string" == typeof e ? [e] : e) : s.call(n, e)), n;
    }, inArray: function inArray(e, t, n) {
      return null == t ? -1 : u.call(t, e, n);
    }, merge: function merge(e, t) {
      for (var n = +t.length, r = 0, i = e.length; r < n; r++) {
        e[i++] = t[r];
      }return e.length = i, e;
    }, grep: function grep(e, t, n) {
      for (var r, i = [], o = 0, a = e.length, s = !n; o < a; o++) {
        (r = !t(e[o], o)) !== s && i.push(e[o]);
      }return i;
    }, map: function map(e, t, n) {
      var r,
          i,
          o = 0,
          s = [];if (C(e)) for (r = e.length; o < r; o++) {
        null != (i = t(e[o], o, n)) && s.push(i);
      } else for (o in e) {
        null != (i = t(e[o], o, n)) && s.push(i);
      }return a.apply([], s);
    }, guid: 1, support: h }), "function" == typeof __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_symbol___default.a && (w.fn[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a] = n[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a]), w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
    l["[object " + t + "]"] = t.toLowerCase();
  });function C(e) {
    var t = !!e && "length" in e && e.length,
        n = x(e);return !g(e) && !y(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
  }var E = function (e) {
    var t,
        n,
        r,
        i,
        o,
        a,
        s,
        u,
        l,
        c,
        f,
        p,
        d,
        h,
        g,
        y,
        v,
        m,
        x,
        b = "sizzle" + 1 * new Date(),
        w = e.document,
        T = 0,
        C = 0,
        E = ae(),
        k = ae(),
        S = ae(),
        D = function D(e, t) {
      return e === t && (f = !0), 0;
    },
        N = {}.hasOwnProperty,
        A = [],
        j = A.pop,
        q = A.push,
        L = A.push,
        H = A.slice,
        O = function O(e, t) {
      for (var n = 0, r = e.length; n < r; n++) {
        if (e[n] === t) return n;
      }return -1;
    },
        P = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
        M = "[\\x20\\t\\r\\n\\f]",
        R = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
        I = "\\[" + M + "*(" + R + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + M + "*\\]",
        W = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + I + ")*)|.*)\\)|)",
        $ = new RegExp(M + "+", "g"),
        B = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"),
        F = new RegExp("^" + M + "*," + M + "*"),
        _ = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"),
        z = new RegExp("=" + M + "*([^\\]'\"]*?)" + M + "*\\]", "g"),
        X = new RegExp(W),
        U = new RegExp("^" + R + "$"),
        V = { ID: new RegExp("^#(" + R + ")"), CLASS: new RegExp("^\\.(" + R + ")"), TAG: new RegExp("^(" + R + "|[*])"), ATTR: new RegExp("^" + I), PSEUDO: new RegExp("^" + W), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"), bool: new RegExp("^(?:" + P + ")$", "i"), needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i") },
        G = /^(?:input|select|textarea|button)$/i,
        Y = /^h\d$/i,
        Q = /^[^{]+\{\s*\[native \w/,
        J = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
        K = /[+~]/,
        Z = new RegExp("\\\\([\\da-f]{1,6}" + M + "?|(" + M + ")|.)", "ig"),
        ee = function ee(e, t, n) {
      var r = "0x" + t - 65536;return r !== r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320);
    },
        te = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
        ne = function ne(e, t) {
      return t ? "\0" === e ? "\uFFFD" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
    },
        re = function re() {
      p();
    },
        ie = me(function (e) {
      return !0 === e.disabled && ("form" in e || "label" in e);
    }, { dir: "parentNode", next: "legend" });try {
      L.apply(A = H.call(w.childNodes), w.childNodes), A[w.childNodes.length].nodeType;
    } catch (e) {
      L = { apply: A.length ? function (e, t) {
          q.apply(e, H.call(t));
        } : function (e, t) {
          var n = e.length,
              r = 0;while (e[n++] = t[r++]) {}e.length = n - 1;
        } };
    }function oe(e, t, r, i) {
      var o,
          s,
          l,
          c,
          f,
          h,
          v,
          m = t && t.ownerDocument,
          T = t ? t.nodeType : 9;if (r = r || [], "string" != typeof e || !e || 1 !== T && 9 !== T && 11 !== T) return r;if (!i && ((t ? t.ownerDocument || t : w) !== d && p(t), t = t || d, g)) {
        if (11 !== T && (f = J.exec(e))) if (o = f[1]) {
          if (9 === T) {
            if (!(l = t.getElementById(o))) return r;if (l.id === o) return r.push(l), r;
          } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o) return r.push(l), r;
        } else {
          if (f[2]) return L.apply(r, t.getElementsByTagName(e)), r;if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName) return L.apply(r, t.getElementsByClassName(o)), r;
        }if (n.qsa && !S[e + " "] && (!y || !y.test(e))) {
          if (1 !== T) m = t, v = e;else if ("object" !== t.nodeName.toLowerCase()) {
            (c = t.getAttribute("id")) ? c = c.replace(te, ne) : t.setAttribute("id", c = b), s = (h = a(e)).length;while (s--) {
              h[s] = "#" + c + " " + ve(h[s]);
            }v = h.join(","), m = K.test(e) && ge(t.parentNode) || t;
          }if (v) try {
            return L.apply(r, m.querySelectorAll(v)), r;
          } catch (e) {} finally {
            c === b && t.removeAttribute("id");
          }
        }
      }return u(e.replace(B, "$1"), t, r, i);
    }function ae() {
      var e = [];function t(n, i) {
        return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i;
      }return t;
    }function se(e) {
      return e[b] = !0, e;
    }function ue(e) {
      var t = d.createElement("fieldset");try {
        return !!e(t);
      } catch (e) {
        return !1;
      } finally {
        t.parentNode && t.parentNode.removeChild(t), t = null;
      }
    }function le(e, t) {
      var n = e.split("|"),
          i = n.length;while (i--) {
        r.attrHandle[n[i]] = t;
      }
    }function ce(e, t) {
      var n = t && e,
          r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;if (r) return r;if (n) while (n = n.nextSibling) {
        if (n === t) return -1;
      }return e ? 1 : -1;
    }function fe(e) {
      return function (t) {
        return "input" === t.nodeName.toLowerCase() && t.type === e;
      };
    }function pe(e) {
      return function (t) {
        var n = t.nodeName.toLowerCase();return ("input" === n || "button" === n) && t.type === e;
      };
    }function de(e) {
      return function (t) {
        return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ie(t) === e : t.disabled === e : "label" in t && t.disabled === e;
      };
    }function he(e) {
      return se(function (t) {
        return t = +t, se(function (n, r) {
          var i,
              o = e([], n.length, t),
              a = o.length;while (a--) {
            n[i = o[a]] && (n[i] = !(r[i] = n[i]));
          }
        });
      });
    }function ge(e) {
      return e && "undefined" != typeof e.getElementsByTagName && e;
    }n = oe.support = {}, o = oe.isXML = function (e) {
      var t = e && (e.ownerDocument || e).documentElement;return !!t && "HTML" !== t.nodeName;
    }, p = oe.setDocument = function (e) {
      var t,
          i,
          a = e ? e.ownerDocument || e : w;return a !== d && 9 === a.nodeType && a.documentElement ? (d = a, h = d.documentElement, g = !o(d), w !== d && (i = d.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", re, !1) : i.attachEvent && i.attachEvent("onunload", re)), n.attributes = ue(function (e) {
        return e.className = "i", !e.getAttribute("className");
      }), n.getElementsByTagName = ue(function (e) {
        return e.appendChild(d.createComment("")), !e.getElementsByTagName("*").length;
      }), n.getElementsByClassName = Q.test(d.getElementsByClassName), n.getById = ue(function (e) {
        return h.appendChild(e).id = b, !d.getElementsByName || !d.getElementsByName(b).length;
      }), n.getById ? (r.filter.ID = function (e) {
        var t = e.replace(Z, ee);return function (e) {
          return e.getAttribute("id") === t;
        };
      }, r.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && g) {
          var n = t.getElementById(e);return n ? [n] : [];
        }
      }) : (r.filter.ID = function (e) {
        var t = e.replace(Z, ee);return function (e) {
          var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");return n && n.value === t;
        };
      }, r.find.ID = function (e, t) {
        if ("undefined" != typeof t.getElementById && g) {
          var n,
              r,
              i,
              o = t.getElementById(e);if (o) {
            if ((n = o.getAttributeNode("id")) && n.value === e) return [o];i = t.getElementsByName(e), r = 0;while (o = i[r++]) {
              if ((n = o.getAttributeNode("id")) && n.value === e) return [o];
            }
          }return [];
        }
      }), r.find.TAG = n.getElementsByTagName ? function (e, t) {
        return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
      } : function (e, t) {
        var n,
            r = [],
            i = 0,
            o = t.getElementsByTagName(e);if ("*" === e) {
          while (n = o[i++]) {
            1 === n.nodeType && r.push(n);
          }return r;
        }return o;
      }, r.find.CLASS = n.getElementsByClassName && function (e, t) {
        if ("undefined" != typeof t.getElementsByClassName && g) return t.getElementsByClassName(e);
      }, v = [], y = [], (n.qsa = Q.test(d.querySelectorAll)) && (ue(function (e) {
        h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && y.push("[*^$]=" + M + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || y.push("\\[" + M + "*(?:value|" + P + ")"), e.querySelectorAll("[id~=" + b + "-]").length || y.push("~="), e.querySelectorAll(":checked").length || y.push(":checked"), e.querySelectorAll("a#" + b + "+*").length || y.push(".#.+[+~]");
      }), ue(function (e) {
        e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t = d.createElement("input");t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && y.push("name" + M + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && y.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && y.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), y.push(",.*:");
      })), (n.matchesSelector = Q.test(m = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && ue(function (e) {
        n.disconnectedMatch = m.call(e, "*"), m.call(e, "[s!='']:x"), v.push("!=", W);
      }), y = y.length && new RegExp(y.join("|")), v = v.length && new RegExp(v.join("|")), t = Q.test(h.compareDocumentPosition), x = t || Q.test(h.contains) ? function (e, t) {
        var n = 9 === e.nodeType ? e.documentElement : e,
            r = t && t.parentNode;return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
      } : function (e, t) {
        if (t) while (t = t.parentNode) {
          if (t === e) return !0;
        }return !1;
      }, D = t ? function (e, t) {
        if (e === t) return f = !0, 0;var r = !e.compareDocumentPosition - !t.compareDocumentPosition;return r || (1 & (r = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e === d || e.ownerDocument === w && x(w, e) ? -1 : t === d || t.ownerDocument === w && x(w, t) ? 1 : c ? O(c, e) - O(c, t) : 0 : 4 & r ? -1 : 1);
      } : function (e, t) {
        if (e === t) return f = !0, 0;var n,
            r = 0,
            i = e.parentNode,
            o = t.parentNode,
            a = [e],
            s = [t];if (!i || !o) return e === d ? -1 : t === d ? 1 : i ? -1 : o ? 1 : c ? O(c, e) - O(c, t) : 0;if (i === o) return ce(e, t);n = e;while (n = n.parentNode) {
          a.unshift(n);
        }n = t;while (n = n.parentNode) {
          s.unshift(n);
        }while (a[r] === s[r]) {
          r++;
        }return r ? ce(a[r], s[r]) : a[r] === w ? -1 : s[r] === w ? 1 : 0;
      }, d) : d;
    }, oe.matches = function (e, t) {
      return oe(e, null, null, t);
    }, oe.matchesSelector = function (e, t) {
      if ((e.ownerDocument || e) !== d && p(e), t = t.replace(z, "='$1']"), n.matchesSelector && g && !S[t + " "] && (!v || !v.test(t)) && (!y || !y.test(t))) try {
        var r = m.call(e, t);if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r;
      } catch (e) {}return oe(t, d, null, [e]).length > 0;
    }, oe.contains = function (e, t) {
      return (e.ownerDocument || e) !== d && p(e), x(e, t);
    }, oe.attr = function (e, t) {
      (e.ownerDocument || e) !== d && p(e);var i = r.attrHandle[t.toLowerCase()],
          o = i && N.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
    }, oe.escape = function (e) {
      return (e + "").replace(te, ne);
    }, oe.error = function (e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }, oe.uniqueSort = function (e) {
      var t,
          r = [],
          i = 0,
          o = 0;if (f = !n.detectDuplicates, c = !n.sortStable && e.slice(0), e.sort(D), f) {
        while (t = e[o++]) {
          t === e[o] && (i = r.push(o));
        }while (i--) {
          e.splice(r[i], 1);
        }
      }return c = null, e;
    }, i = oe.getText = function (e) {
      var t,
          n = "",
          r = 0,
          o = e.nodeType;if (o) {
        if (1 === o || 9 === o || 11 === o) {
          if ("string" == typeof e.textContent) return e.textContent;for (e = e.firstChild; e; e = e.nextSibling) {
            n += i(e);
          }
        } else if (3 === o || 4 === o) return e.nodeValue;
      } else while (t = e[r++]) {
        n += i(t);
      }return n;
    }, (r = oe.selectors = { cacheLength: 50, createPseudo: se, match: V, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(e) {
          return e[1] = e[1].replace(Z, ee), e[3] = (e[3] || e[4] || e[5] || "").replace(Z, ee), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
        }, CHILD: function CHILD(e) {
          return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]), e;
        }, PSEUDO: function PSEUDO(e) {
          var t,
              n = !e[6] && e[2];return V.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
        } }, filter: { TAG: function TAG(e) {
          var t = e.replace(Z, ee).toLowerCase();return "*" === e ? function () {
            return !0;
          } : function (e) {
            return e.nodeName && e.nodeName.toLowerCase() === t;
          };
        }, CLASS: function CLASS(e) {
          var t = E[e + " "];return t || (t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)")) && E(e, function (e) {
            return t.test("string" == typeof e.className && e.className || "undefined" != typeof e.getAttribute && e.getAttribute("class") || "");
          });
        }, ATTR: function ATTR(e, t, n) {
          return function (r) {
            var i = oe.attr(r, e);return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace($, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
          };
        }, CHILD: function CHILD(e, t, n, r, i) {
          var o = "nth" !== e.slice(0, 3),
              a = "last" !== e.slice(-4),
              s = "of-type" === t;return 1 === r && 0 === i ? function (e) {
            return !!e.parentNode;
          } : function (t, n, u) {
            var l,
                c,
                f,
                p,
                d,
                h,
                g = o !== a ? "nextSibling" : "previousSibling",
                y = t.parentNode,
                v = s && t.nodeName.toLowerCase(),
                m = !u && !s,
                x = !1;if (y) {
              if (o) {
                while (g) {
                  p = t;while (p = p[g]) {
                    if (s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                  }h = g = "only" === e && !h && "nextSibling";
                }return !0;
              }if (h = [a ? y.firstChild : y.lastChild], a && m) {
                x = (d = (l = (c = (f = (p = y)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2], p = d && y.childNodes[d];while (p = ++d && p && p[g] || (x = d = 0) || h.pop()) {
                  if (1 === p.nodeType && ++x && p === t) {
                    c[e] = [T, d, x];break;
                  }
                }
              } else if (m && (x = d = (l = (c = (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]), !1 === x) while (p = ++d && p && p[g] || (x = d = 0) || h.pop()) {
                if ((s ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) && ++x && (m && ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] = [T, x]), p === t)) break;
              }return (x -= i) === r || x % r == 0 && x / r >= 0;
            }
          };
        }, PSEUDO: function PSEUDO(e, t) {
          var n,
              i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);return i[b] ? i(t) : i.length > 1 ? (n = [e, e, "", t], r.setFilters.hasOwnProperty(e.toLowerCase()) ? se(function (e, n) {
            var r,
                o = i(e, t),
                a = o.length;while (a--) {
              e[r = O(e, o[a])] = !(n[r] = o[a]);
            }
          }) : function (e) {
            return i(e, 0, n);
          }) : i;
        } }, pseudos: { not: se(function (e) {
          var t = [],
              n = [],
              r = s(e.replace(B, "$1"));return r[b] ? se(function (e, t, n, i) {
            var o,
                a = r(e, null, i, []),
                s = e.length;while (s--) {
              (o = a[s]) && (e[s] = !(t[s] = o));
            }
          }) : function (e, i, o) {
            return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop();
          };
        }), has: se(function (e) {
          return function (t) {
            return oe(e, t).length > 0;
          };
        }), contains: se(function (e) {
          return e = e.replace(Z, ee), function (t) {
            return (t.textContent || t.innerText || i(t)).indexOf(e) > -1;
          };
        }), lang: se(function (e) {
          return U.test(e || "") || oe.error("unsupported lang: " + e), e = e.replace(Z, ee).toLowerCase(), function (t) {
            var n;do {
              if (n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
            } while ((t = t.parentNode) && 1 === t.nodeType);return !1;
          };
        }), target: function target(t) {
          var n = e.location && e.location.hash;return n && n.slice(1) === t.id;
        }, root: function root(e) {
          return e === h;
        }, focus: function focus(e) {
          return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
        }, enabled: de(!1), disabled: de(!0), checked: function checked(e) {
          var t = e.nodeName.toLowerCase();return "input" === t && !!e.checked || "option" === t && !!e.selected;
        }, selected: function selected(e) {
          return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
        }, empty: function empty(e) {
          for (e = e.firstChild; e; e = e.nextSibling) {
            if (e.nodeType < 6) return !1;
          }return !0;
        }, parent: function parent(e) {
          return !r.pseudos.empty(e);
        }, header: function header(e) {
          return Y.test(e.nodeName);
        }, input: function input(e) {
          return G.test(e.nodeName);
        }, button: function button(e) {
          var t = e.nodeName.toLowerCase();return "input" === t && "button" === e.type || "button" === t;
        }, text: function text(e) {
          var t;return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
        }, first: he(function () {
          return [0];
        }), last: he(function (e, t) {
          return [t - 1];
        }), eq: he(function (e, t, n) {
          return [n < 0 ? n + t : n];
        }), even: he(function (e, t) {
          for (var n = 0; n < t; n += 2) {
            e.push(n);
          }return e;
        }), odd: he(function (e, t) {
          for (var n = 1; n < t; n += 2) {
            e.push(n);
          }return e;
        }), lt: he(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; --r >= 0;) {
            e.push(r);
          }return e;
        }), gt: he(function (e, t, n) {
          for (var r = n < 0 ? n + t : n; ++r < t;) {
            e.push(r);
          }return e;
        }) } }).pseudos.nth = r.pseudos.eq;for (t in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) {
      r.pseudos[t] = fe(t);
    }for (t in { submit: !0, reset: !0 }) {
      r.pseudos[t] = pe(t);
    }function ye() {}ye.prototype = r.filters = r.pseudos, r.setFilters = new ye(), a = oe.tokenize = function (e, t) {
      var n,
          i,
          o,
          a,
          s,
          u,
          l,
          c = k[e + " "];if (c) return t ? 0 : c.slice(0);s = e, u = [], l = r.preFilter;while (s) {
        n && !(i = F.exec(s)) || (i && (s = s.slice(i[0].length) || s), u.push(o = [])), n = !1, (i = _.exec(s)) && (n = i.shift(), o.push({ value: n, type: i[0].replace(B, " ") }), s = s.slice(n.length));for (a in r.filter) {
          !(i = V[a].exec(s)) || l[a] && !(i = l[a](i)) || (n = i.shift(), o.push({ value: n, type: a, matches: i }), s = s.slice(n.length));
        }if (!n) break;
      }return t ? s.length : s ? oe.error(e) : k(e, u).slice(0);
    };function ve(e) {
      for (var t = 0, n = e.length, r = ""; t < n; t++) {
        r += e[t].value;
      }return r;
    }function me(e, t, n) {
      var r = t.dir,
          i = t.next,
          o = i || r,
          a = n && "parentNode" === o,
          s = C++;return t.first ? function (t, n, i) {
        while (t = t[r]) {
          if (1 === t.nodeType || a) return e(t, n, i);
        }return !1;
      } : function (t, n, u) {
        var l,
            c,
            f,
            p = [T, s];if (u) {
          while (t = t[r]) {
            if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
          }
        } else while (t = t[r]) {
          if (1 === t.nodeType || a) if (f = t[b] || (t[b] = {}), c = f[t.uniqueID] || (f[t.uniqueID] = {}), i && i === t.nodeName.toLowerCase()) t = t[r] || t;else {
            if ((l = c[o]) && l[0] === T && l[1] === s) return p[2] = l[2];if (c[o] = p, p[2] = e(t, n, u)) return !0;
          }
        }return !1;
      };
    }function xe(e) {
      return e.length > 1 ? function (t, n, r) {
        var i = e.length;while (i--) {
          if (!e[i](t, n, r)) return !1;
        }return !0;
      } : e[0];
    }function be(e, t, n) {
      for (var r = 0, i = t.length; r < i; r++) {
        oe(e, t[r], n);
      }return n;
    }function we(e, t, n, r, i) {
      for (var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++) {
        (o = e[s]) && (n && !n(o, r, i) || (a.push(o), l && t.push(s)));
      }return a;
    }function Te(e, t, n, r, i, o) {
      return r && !r[b] && (r = Te(r)), i && !i[b] && (i = Te(i, o)), se(function (o, a, s, u) {
        var l,
            c,
            f,
            p = [],
            d = [],
            h = a.length,
            g = o || be(t || "*", s.nodeType ? [s] : s, []),
            y = !e || !o && t ? g : we(g, p, e, s, u),
            v = n ? i || (o ? e : h || r) ? [] : a : y;if (n && n(y, v, s, u), r) {
          l = we(v, d), r(l, [], s, u), c = l.length;while (c--) {
            (f = l[c]) && (v[d[c]] = !(y[d[c]] = f));
          }
        }if (o) {
          if (i || e) {
            if (i) {
              l = [], c = v.length;while (c--) {
                (f = v[c]) && l.push(y[c] = f);
              }i(null, v = [], l, u);
            }c = v.length;while (c--) {
              (f = v[c]) && (l = i ? O(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f));
            }
          }
        } else v = we(v === a ? v.splice(h, v.length) : v), i ? i(null, a, v, u) : L.apply(a, v);
      });
    }function Ce(e) {
      for (var t, n, i, o = e.length, a = r.relative[e[0].type], s = a || r.relative[" "], u = a ? 1 : 0, c = me(function (e) {
        return e === t;
      }, s, !0), f = me(function (e) {
        return O(t, e) > -1;
      }, s, !0), p = [function (e, n, r) {
        var i = !a && (r || n !== l) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));return t = null, i;
      }]; u < o; u++) {
        if (n = r.relative[e[u].type]) p = [me(xe(p), n)];else {
          if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
            for (i = ++u; i < o; i++) {
              if (r.relative[e[i].type]) break;
            }return Te(u > 1 && xe(p), u > 1 && ve(e.slice(0, u - 1).concat({ value: " " === e[u - 2].type ? "*" : "" })).replace(B, "$1"), n, u < i && Ce(e.slice(u, i)), i < o && Ce(e = e.slice(i)), i < o && ve(e));
          }p.push(n);
        }
      }return xe(p);
    }function Ee(e, t) {
      var n = t.length > 0,
          i = e.length > 0,
          o = function o(_o, a, s, u, c) {
        var f,
            h,
            y,
            v = 0,
            m = "0",
            x = _o && [],
            b = [],
            w = l,
            C = _o || i && r.find.TAG("*", c),
            E = T += null == w ? 1 : Math.random() || .1,
            k = C.length;for (c && (l = a === d || a || c); m !== k && null != (f = C[m]); m++) {
          if (i && f) {
            h = 0, a || f.ownerDocument === d || (p(f), s = !g);while (y = e[h++]) {
              if (y(f, a || d, s)) {
                u.push(f);break;
              }
            }c && (T = E);
          }n && ((f = !y && f) && v--, _o && x.push(f));
        }if (v += m, n && m !== v) {
          h = 0;while (y = t[h++]) {
            y(x, b, a, s);
          }if (_o) {
            if (v > 0) while (m--) {
              x[m] || b[m] || (b[m] = j.call(u));
            }b = we(b);
          }L.apply(u, b), c && !_o && b.length > 0 && v + t.length > 1 && oe.uniqueSort(u);
        }return c && (T = E, l = w), x;
      };return n ? se(o) : o;
    }return s = oe.compile = function (e, t) {
      var n,
          r = [],
          i = [],
          o = S[e + " "];if (!o) {
        t || (t = a(e)), n = t.length;while (n--) {
          (o = Ce(t[n]))[b] ? r.push(o) : i.push(o);
        }(o = S(e, Ee(i, r))).selector = e;
      }return o;
    }, u = oe.select = function (e, t, n, i) {
      var o,
          u,
          l,
          c,
          f,
          p = "function" == typeof e && e,
          d = !i && a(e = p.selector || e);if (n = n || [], 1 === d.length) {
        if ((u = d[0] = d[0].slice(0)).length > 2 && "ID" === (l = u[0]).type && 9 === t.nodeType && g && r.relative[u[1].type]) {
          if (!(t = (r.find.ID(l.matches[0].replace(Z, ee), t) || [])[0])) return n;p && (t = t.parentNode), e = e.slice(u.shift().value.length);
        }o = V.needsContext.test(e) ? 0 : u.length;while (o--) {
          if (l = u[o], r.relative[c = l.type]) break;if ((f = r.find[c]) && (i = f(l.matches[0].replace(Z, ee), K.test(u[0].type) && ge(t.parentNode) || t))) {
            if (u.splice(o, 1), !(e = i.length && ve(u))) return L.apply(n, i), n;break;
          }
        }
      }return (p || s(e, d))(i, t, !g, n, !t || K.test(e) && ge(t.parentNode) || t), n;
    }, n.sortStable = b.split("").sort(D).join("") === b, n.detectDuplicates = !!f, p(), n.sortDetached = ue(function (e) {
      return 1 & e.compareDocumentPosition(d.createElement("fieldset"));
    }), ue(function (e) {
      return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
    }) || le("type|href|height|width", function (e, t, n) {
      if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
    }), n.attributes && ue(function (e) {
      return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
    }) || le("value", function (e, t, n) {
      if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
    }), ue(function (e) {
      return null == e.getAttribute("disabled");
    }) || le(P, function (e, t, n) {
      var r;if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
    }), oe;
  }(e);w.find = E, w.expr = E.selectors, w.expr[":"] = w.expr.pseudos, w.uniqueSort = w.unique = E.uniqueSort, w.text = E.getText, w.isXMLDoc = E.isXML, w.contains = E.contains, w.escapeSelector = E.escape;var k = function k(e, t, n) {
    var r = [],
        i = void 0 !== n;while ((e = e[t]) && 9 !== e.nodeType) {
      if (1 === e.nodeType) {
        if (i && w(e).is(n)) break;r.push(e);
      }
    }return r;
  },
      S = function S(e, t) {
    for (var n = []; e; e = e.nextSibling) {
      1 === e.nodeType && e !== t && n.push(e);
    }return n;
  },
      D = w.expr.match.needsContext;function N(e, t) {
    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
  }var A = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e, t, n) {
    return g(t) ? w.grep(e, function (e, r) {
      return !!t.call(e, r, e) !== n;
    }) : t.nodeType ? w.grep(e, function (e) {
      return e === t !== n;
    }) : "string" != typeof t ? w.grep(e, function (e) {
      return u.call(t, e) > -1 !== n;
    }) : w.filter(t, e, n);
  }w.filter = function (e, t, n) {
    var r = t[0];return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? w.find.matchesSelector(r, e) ? [r] : [] : w.find.matches(e, w.grep(t, function (e) {
      return 1 === e.nodeType;
    }));
  }, w.fn.extend({ find: function find(e) {
      var t,
          n,
          r = this.length,
          i = this;if ("string" != typeof e) return this.pushStack(w(e).filter(function () {
        for (t = 0; t < r; t++) {
          if (w.contains(i[t], this)) return !0;
        }
      }));for (n = this.pushStack([]), t = 0; t < r; t++) {
        w.find(e, i[t], n);
      }return r > 1 ? w.uniqueSort(n) : n;
    }, filter: function filter(e) {
      return this.pushStack(j(this, e || [], !1));
    }, not: function not(e) {
      return this.pushStack(j(this, e || [], !0));
    }, is: function is(e) {
      return !!j(this, "string" == typeof e && D.test(e) ? w(e) : e || [], !1).length;
    } });var q,
      L = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(w.fn.init = function (e, t, n) {
    var i, o;if (!e) return this;if (n = n || q, "string" == typeof e) {
      if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : L.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);if (i[1]) {
        if (t = t instanceof w ? t[0] : t, w.merge(this, w.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : r, !0)), A.test(i[1]) && w.isPlainObject(t)) for (i in t) {
          g(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
        }return this;
      }return (o = r.getElementById(i[2])) && (this[0] = o, this.length = 1), this;
    }return e.nodeType ? (this[0] = e, this.length = 1, this) : g(e) ? void 0 !== n.ready ? n.ready(e) : e(w) : w.makeArray(e, this);
  }).prototype = w.fn, q = w(r);var H = /^(?:parents|prev(?:Until|All))/,
      O = { children: !0, contents: !0, next: !0, prev: !0 };w.fn.extend({ has: function has(e) {
      var t = w(e, this),
          n = t.length;return this.filter(function () {
        for (var e = 0; e < n; e++) {
          if (w.contains(this, t[e])) return !0;
        }
      });
    }, closest: function closest(e, t) {
      var n,
          r = 0,
          i = this.length,
          o = [],
          a = "string" != typeof e && w(e);if (!D.test(e)) for (; r < i; r++) {
        for (n = this[r]; n && n !== t; n = n.parentNode) {
          if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))) {
            o.push(n);break;
          }
        }
      }return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
    }, index: function index(e) {
      return e ? "string" == typeof e ? u.call(w(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function add(e, t) {
      return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
    }, addBack: function addBack(e) {
      return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
    } });function P(e, t) {
    while ((e = e[t]) && 1 !== e.nodeType) {}return e;
  }w.each({ parent: function parent(e) {
      var t = e.parentNode;return t && 11 !== t.nodeType ? t : null;
    }, parents: function parents(e) {
      return k(e, "parentNode");
    }, parentsUntil: function parentsUntil(e, t, n) {
      return k(e, "parentNode", n);
    }, next: function next(e) {
      return P(e, "nextSibling");
    }, prev: function prev(e) {
      return P(e, "previousSibling");
    }, nextAll: function nextAll(e) {
      return k(e, "nextSibling");
    }, prevAll: function prevAll(e) {
      return k(e, "previousSibling");
    }, nextUntil: function nextUntil(e, t, n) {
      return k(e, "nextSibling", n);
    }, prevUntil: function prevUntil(e, t, n) {
      return k(e, "previousSibling", n);
    }, siblings: function siblings(e) {
      return S((e.parentNode || {}).firstChild, e);
    }, children: function children(e) {
      return S(e.firstChild);
    }, contents: function contents(e) {
      return N(e, "iframe") ? e.contentDocument : (N(e, "template") && (e = e.content || e), w.merge([], e.childNodes));
    } }, function (e, t) {
    w.fn[e] = function (n, r) {
      var i = w.map(this, t, n);return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = w.filter(r, i)), this.length > 1 && (O[e] || w.uniqueSort(i), H.test(e) && i.reverse()), this.pushStack(i);
    };
  });var M = /[^\x20\t\r\n\f]+/g;function R(e) {
    var t = {};return w.each(e.match(M) || [], function (e, n) {
      t[n] = !0;
    }), t;
  }w.Callbacks = function (e) {
    e = "string" == typeof e ? R(e) : w.extend({}, e);var t,
        n,
        r,
        i,
        o = [],
        a = [],
        s = -1,
        u = function u() {
      for (i = i || e.once, r = t = !0; a.length; s = -1) {
        n = a.shift();while (++s < o.length) {
          !1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length, n = !1);
        }
      }e.memory || (n = !1), t = !1, i && (o = n ? [] : "");
    },
        l = { add: function add() {
        return o && (n && !t && (s = o.length - 1, a.push(n)), function t(n) {
          w.each(n, function (n, r) {
            g(r) ? e.unique && l.has(r) || o.push(r) : r && r.length && "string" !== x(r) && t(r);
          });
        }(arguments), n && !t && u()), this;
      }, remove: function remove() {
        return w.each(arguments, function (e, t) {
          var n;while ((n = w.inArray(t, o, n)) > -1) {
            o.splice(n, 1), n <= s && s--;
          }
        }), this;
      }, has: function has(e) {
        return e ? w.inArray(e, o) > -1 : o.length > 0;
      }, empty: function empty() {
        return o && (o = []), this;
      }, disable: function disable() {
        return i = a = [], o = n = "", this;
      }, disabled: function disabled() {
        return !o;
      }, lock: function lock() {
        return i = a = [], n || t || (o = n = ""), this;
      }, locked: function locked() {
        return !!i;
      }, fireWith: function fireWith(e, n) {
        return i || (n = [e, (n = n || []).slice ? n.slice() : n], a.push(n), t || u()), this;
      }, fire: function fire() {
        return l.fireWith(this, arguments), this;
      }, fired: function fired() {
        return !!r;
      } };return l;
  };function I(e) {
    return e;
  }function W(e) {
    throw e;
  }function $(e, t, n, r) {
    var i;try {
      e && g(i = e.promise) ? i.call(e).done(t).fail(n) : e && g(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [e].slice(r));
    } catch (e) {
      n.apply(void 0, [e]);
    }
  }w.extend({ Deferred: function Deferred(t) {
      var n = [["notify", "progress", w.Callbacks("memory"), w.Callbacks("memory"), 2], ["resolve", "done", w.Callbacks("once memory"), w.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", w.Callbacks("once memory"), w.Callbacks("once memory"), 1, "rejected"]],
          r = "pending",
          i = { state: function state() {
          return r;
        }, always: function always() {
          return o.done(arguments).fail(arguments), this;
        }, "catch": function _catch(e) {
          return i.then(null, e);
        }, pipe: function pipe() {
          var e = arguments;return w.Deferred(function (t) {
            w.each(n, function (n, r) {
              var i = g(e[r[4]]) && e[r[4]];o[r[1]](function () {
                var e = i && i.apply(this, arguments);e && g(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[r[0] + "With"](this, i ? [e] : arguments);
              });
            }), e = null;
          }).promise();
        }, then: function then(t, r, i) {
          var o = 0;function a(t, n, r, i) {
            return function () {
              var s = this,
                  u = arguments,
                  l = function l() {
                var e, l;if (!(t < o)) {
                  if ((e = r.apply(s, u)) === n.promise()) throw new TypeError("Thenable self-resolution");l = e && ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e)) || "function" == typeof e) && e.then, g(l) ? i ? l.call(e, a(o, n, I, i), a(o, n, W, i)) : (o++, l.call(e, a(o, n, I, i), a(o, n, W, i), a(o, n, I, n.notifyWith))) : (r !== I && (s = void 0, u = [e]), (i || n.resolveWith)(s, u));
                }
              },
                  c = i ? l : function () {
                try {
                  l();
                } catch (e) {
                  w.Deferred.exceptionHook && w.Deferred.exceptionHook(e, c.stackTrace), t + 1 >= o && (r !== W && (s = void 0, u = [e]), n.rejectWith(s, u));
                }
              };t ? c() : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()), e.setTimeout(c));
            };
          }return w.Deferred(function (e) {
            n[0][3].add(a(0, e, g(i) ? i : I, e.notifyWith)), n[1][3].add(a(0, e, g(t) ? t : I)), n[2][3].add(a(0, e, g(r) ? r : W));
          }).promise();
        }, promise: function promise(e) {
          return null != e ? w.extend(e, i) : i;
        } },
          o = {};return w.each(n, function (e, t) {
        var a = t[2],
            s = t[5];i[t[1]] = a.add, s && a.add(function () {
          r = s;
        }, n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock), a.add(t[3].fire), o[t[0]] = function () {
          return o[t[0] + "With"](this === o ? void 0 : this, arguments), this;
        }, o[t[0] + "With"] = a.fireWith;
      }), i.promise(o), t && t.call(o, o), o;
    }, when: function when(e) {
      var t = arguments.length,
          n = t,
          r = Array(n),
          i = o.call(arguments),
          a = w.Deferred(),
          s = function s(e) {
        return function (n) {
          r[e] = this, i[e] = arguments.length > 1 ? o.call(arguments) : n, --t || a.resolveWith(r, i);
        };
      };if (t <= 1 && ($(e, a.done(s(n)).resolve, a.reject, !t), "pending" === a.state() || g(i[n] && i[n].then))) return a.then();while (n--) {
        $(i[n], s(n), a.reject);
      }return a.promise();
    } });var B = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;w.Deferred.exceptionHook = function (t, n) {
    e.console && e.console.warn && t && B.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
  }, w.readyException = function (t) {
    e.setTimeout(function () {
      throw t;
    });
  };var F = w.Deferred();w.fn.ready = function (e) {
    return F.then(e)["catch"](function (e) {
      w.readyException(e);
    }), this;
  }, w.extend({ isReady: !1, readyWait: 1, ready: function ready(e) {
      (!0 === e ? --w.readyWait : w.isReady) || (w.isReady = !0, !0 !== e && --w.readyWait > 0 || F.resolveWith(r, [w]));
    } }), w.ready.then = F.then;function _() {
    r.removeEventListener("DOMContentLoaded", _), e.removeEventListener("load", _), w.ready();
  }"complete" === r.readyState || "loading" !== r.readyState && !r.documentElement.doScroll ? e.setTimeout(w.ready) : (r.addEventListener("DOMContentLoaded", _), e.addEventListener("load", _));var z = function z(e, t, n, r, i, o, a) {
    var s = 0,
        u = e.length,
        l = null == n;if ("object" === x(n)) {
      i = !0;for (s in n) {
        z(e, t, s, n[s], !0, o, a);
      }
    } else if (void 0 !== r && (i = !0, g(r) || (a = !0), l && (a ? (t.call(e, r), t = null) : (l = t, t = function t(e, _t2, n) {
      return l.call(w(e), n);
    })), t)) for (; s < u; s++) {
      t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
    }return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
  },
      X = /^-ms-/,
      U = /-([a-z])/g;function V(e, t) {
    return t.toUpperCase();
  }function G(e) {
    return e.replace(X, "ms-").replace(U, V);
  }var Y = function Y(e) {
    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
  };function Q() {
    this.expando = w.expando + Q.uid++;
  }Q.uid = 1, Q.prototype = { cache: function cache(e) {
      var t = e[this.expando];return t || (t = {}, Y(e) && (e.nodeType ? e[this.expando] = t : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(e, this.expando, { value: t, configurable: !0 }))), t;
    }, set: function set(e, t, n) {
      var r,
          i = this.cache(e);if ("string" == typeof t) i[G(t)] = n;else for (r in t) {
        i[G(r)] = t[r];
      }return i;
    }, get: function get(e, t) {
      return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][G(t)];
    }, access: function access(e, t, n) {
      return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
    }, remove: function remove(e, t) {
      var n,
          r = e[this.expando];if (void 0 !== r) {
        if (void 0 !== t) {
          n = (t = Array.isArray(t) ? t.map(G) : (t = G(t)) in r ? [t] : t.match(M) || []).length;while (n--) {
            delete r[t[n]];
          }
        }(void 0 === t || w.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
      }
    }, hasData: function hasData(e) {
      var t = e[this.expando];return void 0 !== t && !w.isEmptyObject(t);
    } };var J = new Q(),
      K = new Q(),
      Z = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
      ee = /[A-Z]/g;function te(e) {
    return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : Z.test(e) ? JSON.parse(e) : e);
  }function ne(e, t, n) {
    var r;if (void 0 === n && 1 === e.nodeType) if (r = "data-" + t.replace(ee, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
      try {
        n = te(n);
      } catch (e) {}K.set(e, t, n);
    } else n = void 0;return n;
  }w.extend({ hasData: function hasData(e) {
      return K.hasData(e) || J.hasData(e);
    }, data: function data(e, t, n) {
      return K.access(e, t, n);
    }, removeData: function removeData(e, t) {
      K.remove(e, t);
    }, _data: function _data(e, t, n) {
      return J.access(e, t, n);
    }, _removeData: function _removeData(e, t) {
      J.remove(e, t);
    } }), w.fn.extend({ data: function data(e, t) {
      var n,
          r,
          i,
          o = this[0],
          a = o && o.attributes;if (void 0 === e) {
        if (this.length && (i = K.get(o), 1 === o.nodeType && !J.get(o, "hasDataAttrs"))) {
          n = a.length;while (n--) {
            a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = G(r.slice(5)), ne(o, r, i[r]));
          }J.set(o, "hasDataAttrs", !0);
        }return i;
      }return "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e)) ? this.each(function () {
        K.set(this, e);
      }) : z(this, function (t) {
        var n;if (o && void 0 === t) {
          if (void 0 !== (n = K.get(o, e))) return n;if (void 0 !== (n = ne(o, e))) return n;
        } else this.each(function () {
          K.set(this, e, t);
        });
      }, null, t, arguments.length > 1, null, !0);
    }, removeData: function removeData(e) {
      return this.each(function () {
        K.remove(this, e);
      });
    } }), w.extend({ queue: function queue(e, t, n) {
      var r;if (e) return t = (t || "fx") + "queue", r = J.get(e, t), n && (!r || Array.isArray(n) ? r = J.access(e, t, w.makeArray(n)) : r.push(n)), r || [];
    }, dequeue: function dequeue(e, t) {
      t = t || "fx";var n = w.queue(e, t),
          r = n.length,
          i = n.shift(),
          o = w._queueHooks(e, t),
          a = function a() {
        w.dequeue(e, t);
      };"inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, a, o)), !r && o && o.empty.fire();
    }, _queueHooks: function _queueHooks(e, t) {
      var n = t + "queueHooks";return J.get(e, n) || J.access(e, n, { empty: w.Callbacks("once memory").add(function () {
          J.remove(e, [t + "queue", n]);
        }) });
    } }), w.fn.extend({ queue: function queue(e, t) {
      var n = 2;return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? w.queue(this[0], e) : void 0 === t ? this : this.each(function () {
        var n = w.queue(this, e, t);w._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e);
      });
    }, dequeue: function dequeue(e) {
      return this.each(function () {
        w.dequeue(this, e);
      });
    }, clearQueue: function clearQueue(e) {
      return this.queue(e || "fx", []);
    }, promise: function promise(e, t) {
      var n,
          r = 1,
          i = w.Deferred(),
          o = this,
          a = this.length,
          s = function s() {
        --r || i.resolveWith(o, [o]);
      };"string" != typeof e && (t = e, e = void 0), e = e || "fx";while (a--) {
        (n = J.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
      }return s(), i.promise(t);
    } });var re = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      ie = new RegExp("^(?:([+-])=|)(" + re + ")([a-z%]*)$", "i"),
      oe = ["Top", "Right", "Bottom", "Left"],
      ae = function ae(e, t) {
    return "none" === (e = t || e).style.display || "" === e.style.display && w.contains(e.ownerDocument, e) && "none" === w.css(e, "display");
  },
      se = function se(e, t, n, r) {
    var i,
        o,
        a = {};for (o in t) {
      a[o] = e.style[o], e.style[o] = t[o];
    }i = n.apply(e, r || []);for (o in t) {
      e.style[o] = a[o];
    }return i;
  };function ue(e, t, n, r) {
    var i,
        o,
        a = 20,
        s = r ? function () {
      return r.cur();
    } : function () {
      return w.css(e, t, "");
    },
        u = s(),
        l = n && n[3] || (w.cssNumber[t] ? "" : "px"),
        c = (w.cssNumber[t] || "px" !== l && +u) && ie.exec(w.css(e, t));if (c && c[3] !== l) {
      u /= 2, l = l || c[3], c = +u || 1;while (a--) {
        w.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0), c /= o;
      }c *= 2, w.style(e, t, c + l), n = n || [];
    }return n && (c = +c || +u || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i;
  }var le = {};function ce(e) {
    var t,
        n = e.ownerDocument,
        r = e.nodeName,
        i = le[r];return i || (t = n.body.appendChild(n.createElement(r)), i = w.css(t, "display"), t.parentNode.removeChild(t), "none" === i && (i = "block"), le[r] = i, i);
  }function fe(e, t) {
    for (var n, r, i = [], o = 0, a = e.length; o < a; o++) {
      (r = e[o]).style && (n = r.style.display, t ? ("none" === n && (i[o] = J.get(r, "display") || null, i[o] || (r.style.display = "")), "" === r.style.display && ae(r) && (i[o] = ce(r))) : "none" !== n && (i[o] = "none", J.set(r, "display", n)));
    }for (o = 0; o < a; o++) {
      null != i[o] && (e[o].style.display = i[o]);
    }return e;
  }w.fn.extend({ show: function show() {
      return fe(this, !0);
    }, hide: function hide() {
      return fe(this);
    }, toggle: function toggle(e) {
      return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function () {
        ae(this) ? w(this).show() : w(this).hide();
      });
    } });var pe = /^(?:checkbox|radio)$/i,
      de = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
      he = /^$|^module$|\/(?:java|ecma)script/i,
      ge = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };ge.optgroup = ge.option, ge.tbody = ge.tfoot = ge.colgroup = ge.caption = ge.thead, ge.th = ge.td;function ye(e, t) {
    var n;return n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && N(e, t) ? w.merge([e], n) : n;
  }function ve(e, t) {
    for (var n = 0, r = e.length; n < r; n++) {
      J.set(e[n], "globalEval", !t || J.get(t[n], "globalEval"));
    }
  }var me = /<|&#?\w+;/;function xe(e, t, n, r, i) {
    for (var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++) {
      if ((o = e[d]) || 0 === o) if ("object" === x(o)) w.merge(p, o.nodeType ? [o] : o);else if (me.test(o)) {
        a = a || f.appendChild(t.createElement("div")), s = (de.exec(o) || ["", ""])[1].toLowerCase(), u = ge[s] || ge._default, a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2], c = u[0];while (c--) {
          a = a.lastChild;
        }w.merge(p, a.childNodes), (a = f.firstChild).textContent = "";
      } else p.push(t.createTextNode(o));
    }f.textContent = "", d = 0;while (o = p[d++]) {
      if (r && w.inArray(o, r) > -1) i && i.push(o);else if (l = w.contains(o.ownerDocument, o), a = ye(f.appendChild(o), "script"), l && ve(a), n) {
        c = 0;while (o = a[c++]) {
          he.test(o.type || "") && n.push(o);
        }
      }
    }return f;
  }!function () {
    var e = r.createDocumentFragment().appendChild(r.createElement("div")),
        t = r.createElement("input");t.setAttribute("type", "radio"), t.setAttribute("checked", "checked"), t.setAttribute("name", "t"), e.appendChild(t), h.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", h.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue;
  }();var be = r.documentElement,
      we = /^key/,
      Te = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
      Ce = /^([^.]*)(?:\.(.+)|)/;function Ee() {
    return !0;
  }function ke() {
    return !1;
  }function Se() {
    try {
      return r.activeElement;
    } catch (e) {}
  }function De(e, t, n, r, i, o) {
    var a, s;if ("object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(t))) {
      "string" != typeof n && (r = r || n, n = void 0);for (s in t) {
        De(e, s, n, r, t[s], o);
      }return e;
    }if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = ke;else if (!i) return e;return 1 === o && (a = i, (i = function i(e) {
      return w().off(e), a.apply(this, arguments);
    }).guid = a.guid || (a.guid = w.guid++)), e.each(function () {
      w.event.add(this, t, i, r, n);
    });
  }w.event = { global: {}, add: function add(e, t, n, r, i) {
      var o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          y = J.get(e);if (y) {
        n.handler && (n = (o = n).handler, i = o.selector), i && w.find.matchesSelector(be, i), n.guid || (n.guid = w.guid++), (u = y.events) || (u = y.events = {}), (a = y.handle) || (a = y.handle = function (t) {
          return "undefined" != typeof w && w.event.triggered !== t.type ? w.event.dispatch.apply(e, arguments) : void 0;
        }), l = (t = (t || "").match(M) || [""]).length;while (l--) {
          d = g = (s = Ce.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d && (f = w.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = w.event.special[d] || {}, c = w.extend({ type: d, origType: g, data: r, handler: n, guid: n.guid, selector: i, needsContext: i && w.expr.match.needsContext.test(i), namespace: h.join(".") }, o), (p = u[d]) || ((p = u[d] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(d, a)), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), w.event.global[d] = !0);
        }
      }
    }, remove: function remove(e, t, n, r, i) {
      var o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h,
          g,
          y = J.hasData(e) && J.get(e);if (y && (u = y.events)) {
        l = (t = (t || "").match(M) || [""]).length;while (l--) {
          if (s = Ce.exec(t[l]) || [], d = g = s[1], h = (s[2] || "").split(".").sort(), d) {
            f = w.event.special[d] || {}, p = u[d = (r ? f.delegateType : f.bindType) || d] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length;while (o--) {
              c = p[o], !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
            }a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, y.handle) || w.removeEvent(e, d, y.handle), delete u[d]);
          } else for (d in u) {
            w.event.remove(e, d + t[l], n, r, !0);
          }
        }w.isEmptyObject(u) && J.remove(e, "handle events");
      }
    }, dispatch: function dispatch(e) {
      var t = w.event.fix(e),
          n,
          r,
          i,
          o,
          a,
          s,
          u = new Array(arguments.length),
          l = (J.get(this, "events") || {})[t.type] || [],
          c = w.event.special[t.type] || {};for (u[0] = t, n = 1; n < arguments.length; n++) {
        u[n] = arguments[n];
      }if (t.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, t)) {
        s = w.event.handlers.call(this, t, l), n = 0;while ((o = s[n++]) && !t.isPropagationStopped()) {
          t.currentTarget = o.elem, r = 0;while ((a = o.handlers[r++]) && !t.isImmediatePropagationStopped()) {
            t.rnamespace && !t.rnamespace.test(a.namespace) || (t.handleObj = a, t.data = a.data, void 0 !== (i = ((w.event.special[a.origType] || {}).handle || a.handler).apply(o.elem, u)) && !1 === (t.result = i) && (t.preventDefault(), t.stopPropagation()));
          }
        }return c.postDispatch && c.postDispatch.call(this, t), t.result;
      }
    }, handlers: function handlers(e, t) {
      var n,
          r,
          i,
          o,
          a,
          s = [],
          u = t.delegateCount,
          l = e.target;if (u && l.nodeType && !("click" === e.type && e.button >= 1)) for (; l !== this; l = l.parentNode || this) {
        if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
          for (o = [], a = {}, n = 0; n < u; n++) {
            void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? w(i, this).index(l) > -1 : w.find(i, this, null, [l]).length), a[i] && o.push(r);
          }o.length && s.push({ elem: l, handlers: o });
        }
      }return l = this, u < t.length && s.push({ elem: l, handlers: t.slice(u) }), s;
    }, addProp: function addProp(e, t) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(w.Event.prototype, e, { enumerable: !0, configurable: !0, get: g(t) ? function () {
          if (this.originalEvent) return t(this.originalEvent);
        } : function () {
          if (this.originalEvent) return this.originalEvent[e];
        }, set: function set(t) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
        } });
    }, fix: function fix(e) {
      return e[w.expando] ? e : new w.Event(e);
    }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
          if (this !== Se() && this.focus) return this.focus(), !1;
        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
          if (this === Se() && this.blur) return this.blur(), !1;
        }, delegateType: "focusout" }, click: { trigger: function trigger() {
          if ("checkbox" === this.type && this.click && N(this, "input")) return this.click(), !1;
        }, _default: function _default(e) {
          return N(e.target, "a");
        } }, beforeunload: { postDispatch: function postDispatch(e) {
          void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
        } } } }, w.removeEvent = function (e, t, n) {
    e.removeEventListener && e.removeEventListener(t, n);
  }, w.Event = function (e, t) {
    if (!(this instanceof w.Event)) return new w.Event(e, t);e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ee : ke, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && w.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[w.expando] = !0;
  }, w.Event.prototype = { constructor: w.Event, isDefaultPrevented: ke, isPropagationStopped: ke, isImmediatePropagationStopped: ke, isSimulated: !1, preventDefault: function preventDefault() {
      var e = this.originalEvent;this.isDefaultPrevented = Ee, e && !this.isSimulated && e.preventDefault();
    }, stopPropagation: function stopPropagation() {
      var e = this.originalEvent;this.isPropagationStopped = Ee, e && !this.isSimulated && e.stopPropagation();
    }, stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;this.isImmediatePropagationStopped = Ee, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
    } }, w.each({ altKey: !0, bubbles: !0, cancelable: !0, changedTouches: !0, ctrlKey: !0, detail: !0, eventPhase: !0, metaKey: !0, pageX: !0, pageY: !0, shiftKey: !0, view: !0, "char": !0, charCode: !0, key: !0, keyCode: !0, button: !0, buttons: !0, clientX: !0, clientY: !0, offsetX: !0, offsetY: !0, pointerId: !0, pointerType: !0, screenX: !0, screenY: !0, targetTouches: !0, toElement: !0, touches: !0, which: function which(e) {
      var t = e.button;return null == e.which && we.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && Te.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which;
    } }, w.event.addProp), w.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
    w.event.special[e] = { delegateType: t, bindType: t, handle: function handle(e) {
        var n,
            r = this,
            i = e.relatedTarget,
            o = e.handleObj;return i && (i === r || w.contains(r, i)) || (e.type = o.origType, n = o.handler.apply(this, arguments), e.type = t), n;
      } };
  }), w.fn.extend({ on: function on(e, t, n, r) {
      return De(this, e, t, n, r);
    }, one: function one(e, t, n, r) {
      return De(this, e, t, n, r, 1);
    }, off: function off(e, t, n) {
      var r, i;if (e && e.preventDefault && e.handleObj) return r = e.handleObj, w(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;if ("object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e))) {
        for (i in e) {
          this.off(i, t, e[i]);
        }return this;
      }return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = ke), this.each(function () {
        w.event.remove(this, e, n, t);
      });
    } });var Ne = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
      Ae = /<script|<style|<link/i,
      je = /checked\s*(?:[^=]|=\s*.checked.)/i,
      qe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Le(e, t) {
    return N(e, "table") && N(11 !== t.nodeType ? t : t.firstChild, "tr") ? w(e).children("tbody")[0] || e : e;
  }function He(e) {
    return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
  }function Oe(e) {
    return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
  }function Pe(e, t) {
    var n, r, i, o, a, s, u, l;if (1 === t.nodeType) {
      if (J.hasData(e) && (o = J.access(e), a = J.set(t, o), l = o.events)) {
        delete a.handle, a.events = {};for (i in l) {
          for (n = 0, r = l[i].length; n < r; n++) {
            w.event.add(t, i, l[i][n]);
          }
        }
      }K.hasData(e) && (s = K.access(e), u = w.extend({}, s), K.set(t, u));
    }
  }function Me(e, t) {
    var n = t.nodeName.toLowerCase();"input" === n && pe.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue);
  }function Re(e, t, n, r) {
    t = a.apply([], t);var i,
        o,
        s,
        u,
        l,
        c,
        f = 0,
        p = e.length,
        d = p - 1,
        y = t[0],
        v = g(y);if (v || p > 1 && "string" == typeof y && !h.checkClone && je.test(y)) return e.each(function (i) {
      var o = e.eq(i);v && (t[0] = y.call(this, i, o.html())), Re(o, t, n, r);
    });if (p && (i = xe(t, e[0].ownerDocument, !1, e, r), o = i.firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
      for (u = (s = w.map(ye(i, "script"), He)).length; f < p; f++) {
        l = i, f !== d && (l = w.clone(l, !0, !0), u && w.merge(s, ye(l, "script"))), n.call(e[f], l, f);
      }if (u) for (c = s[s.length - 1].ownerDocument, w.map(s, Oe), f = 0; f < u; f++) {
        l = s[f], he.test(l.type || "") && !J.access(l, "globalEval") && w.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? w._evalUrl && w._evalUrl(l.src) : m(l.textContent.replace(qe, ""), c, l));
      }
    }return e;
  }function Ie(e, t, n) {
    for (var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++) {
      n || 1 !== r.nodeType || w.cleanData(ye(r)), r.parentNode && (n && w.contains(r.ownerDocument, r) && ve(ye(r, "script")), r.parentNode.removeChild(r));
    }return e;
  }w.extend({ htmlPrefilter: function htmlPrefilter(e) {
      return e.replace(Ne, "<$1></$2>");
    }, clone: function clone(e, t, n) {
      var r,
          i,
          o,
          a,
          s = e.cloneNode(!0),
          u = w.contains(e.ownerDocument, e);if (!(h.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || w.isXMLDoc(e))) for (a = ye(s), r = 0, i = (o = ye(e)).length; r < i; r++) {
        Me(o[r], a[r]);
      }if (t) if (n) for (o = o || ye(e), a = a || ye(s), r = 0, i = o.length; r < i; r++) {
        Pe(o[r], a[r]);
      } else Pe(e, s);return (a = ye(s, "script")).length > 0 && ve(a, !u && ye(e, "script")), s;
    }, cleanData: function cleanData(e) {
      for (var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++) {
        if (Y(n)) {
          if (t = n[J.expando]) {
            if (t.events) for (r in t.events) {
              i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
            }n[J.expando] = void 0;
          }n[K.expando] && (n[K.expando] = void 0);
        }
      }
    } }), w.fn.extend({ detach: function detach(e) {
      return Ie(this, e, !0);
    }, remove: function remove(e) {
      return Ie(this, e);
    }, text: function text(e) {
      return z(this, function (e) {
        return void 0 === e ? w.text(this) : this.empty().each(function () {
          1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
        });
      }, null, e, arguments.length);
    }, append: function append() {
      return Re(this, arguments, function (e) {
        1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Le(this, e).appendChild(e);
      });
    }, prepend: function prepend() {
      return Re(this, arguments, function (e) {
        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
          var t = Le(this, e);t.insertBefore(e, t.firstChild);
        }
      });
    }, before: function before() {
      return Re(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this);
      });
    }, after: function after() {
      return Re(this, arguments, function (e) {
        this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
      });
    }, empty: function empty() {
      for (var e, t = 0; null != (e = this[t]); t++) {
        1 === e.nodeType && (w.cleanData(ye(e, !1)), e.textContent = "");
      }return this;
    }, clone: function clone(e, t) {
      return e = null != e && e, t = null == t ? e : t, this.map(function () {
        return w.clone(this, e, t);
      });
    }, html: function html(e) {
      return z(this, function (e) {
        var t = this[0] || {},
            n = 0,
            r = this.length;if (void 0 === e && 1 === t.nodeType) return t.innerHTML;if ("string" == typeof e && !Ae.test(e) && !ge[(de.exec(e) || ["", ""])[1].toLowerCase()]) {
          e = w.htmlPrefilter(e);try {
            for (; n < r; n++) {
              1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)), t.innerHTML = e);
            }t = 0;
          } catch (e) {}
        }t && this.empty().append(e);
      }, null, e, arguments.length);
    }, replaceWith: function replaceWith() {
      var e = [];return Re(this, arguments, function (t) {
        var n = this.parentNode;w.inArray(this, e) < 0 && (w.cleanData(ye(this)), n && n.replaceChild(t, this));
      }, e);
    } }), w.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
    w.fn[e] = function (e) {
      for (var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++) {
        n = a === o ? this : this.clone(!0), w(i[a])[t](n), s.apply(r, n.get());
      }return this.pushStack(r);
    };
  });var We = new RegExp("^(" + re + ")(?!px)[a-z%]+$", "i"),
      $e = function $e(t) {
    var n = t.ownerDocument.defaultView;return n && n.opener || (n = e), n.getComputedStyle(t);
  },
      Be = new RegExp(oe.join("|"), "i");!function () {
    function t() {
      if (c) {
        l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", be.appendChild(l).appendChild(c);var t = e.getComputedStyle(c);i = "1%" !== t.top, u = 12 === n(t.marginLeft), c.style.right = "60%", s = 36 === n(t.right), o = 36 === n(t.width), c.style.position = "absolute", a = 36 === c.offsetWidth || "absolute", be.removeChild(l), c = null;
      }
    }function n(e) {
      return Math.round(parseFloat(e));
    }var i,
        o,
        a,
        s,
        u,
        l = r.createElement("div"),
        c = r.createElement("div");c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", h.clearCloneStyle = "content-box" === c.style.backgroundClip, w.extend(h, { boxSizingReliable: function boxSizingReliable() {
        return t(), o;
      }, pixelBoxStyles: function pixelBoxStyles() {
        return t(), s;
      }, pixelPosition: function pixelPosition() {
        return t(), i;
      }, reliableMarginLeft: function reliableMarginLeft() {
        return t(), u;
      }, scrollboxSize: function scrollboxSize() {
        return t(), a;
      } }));
  }();function Fe(e, t, n) {
    var r,
        i,
        o,
        a,
        s = e.style;return (n = n || $e(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || w.contains(e.ownerDocument, e) || (a = w.style(e, t)), !h.pixelBoxStyles() && We.test(a) && Be.test(t) && (r = s.width, i = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = i, s.maxWidth = o)), void 0 !== a ? a + "" : a;
  }function _e(e, t) {
    return { get: function get() {
        if (!e()) return (this.get = t).apply(this, arguments);delete this.get;
      } };
  }var ze = /^(none|table(?!-c[ea]).+)/,
      Xe = /^--/,
      Ue = { position: "absolute", visibility: "hidden", display: "block" },
      Ve = { letterSpacing: "0", fontWeight: "400" },
      Ge = ["Webkit", "Moz", "ms"],
      Ye = r.createElement("div").style;function Qe(e) {
    if (e in Ye) return e;var t = e[0].toUpperCase() + e.slice(1),
        n = Ge.length;while (n--) {
      if ((e = Ge[n] + t) in Ye) return e;
    }
  }function Je(e) {
    var t = w.cssProps[e];return t || (t = w.cssProps[e] = Qe(e) || e), t;
  }function Ke(e, t, n) {
    var r = ie.exec(t);return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
  }function Ze(e, t, n, r, i, o) {
    var a = "width" === t ? 1 : 0,
        s = 0,
        u = 0;if (n === (r ? "border" : "content")) return 0;for (; a < 4; a += 2) {
      "margin" === n && (u += w.css(e, n + oe[a], !0, i)), r ? ("content" === n && (u -= w.css(e, "padding" + oe[a], !0, i)), "margin" !== n && (u -= w.css(e, "border" + oe[a] + "Width", !0, i))) : (u += w.css(e, "padding" + oe[a], !0, i), "padding" !== n ? u += w.css(e, "border" + oe[a] + "Width", !0, i) : s += w.css(e, "border" + oe[a] + "Width", !0, i));
    }return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5))), u;
  }function et(e, t, n) {
    var r = $e(e),
        i = Fe(e, t, r),
        o = "border-box" === w.css(e, "boxSizing", !1, r),
        a = o;if (We.test(i)) {
      if (!n) return i;i = "auto";
    }return a = a && (h.boxSizingReliable() || i === e.style[t]), ("auto" === i || !parseFloat(i) && "inline" === w.css(e, "display", !1, r)) && (i = e["offset" + t[0].toUpperCase() + t.slice(1)], a = !0), (i = parseFloat(i) || 0) + Ze(e, t, n || (o ? "border" : "content"), a, r, i) + "px";
  }w.extend({ cssHooks: { opacity: { get: function get(e, t) {
          if (t) {
            var n = Fe(e, "opacity");return "" === n ? "1" : n;
          }
        } } }, cssNumber: { animationIterationCount: !0, columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: {}, style: function style(e, t, n, r) {
      if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
        var i,
            o,
            a,
            s = G(t),
            u = Xe.test(t),
            l = e.style;if (u || (t = Je(s)), a = w.cssHooks[t] || w.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];"string" == (o = typeof n === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(n)) && (i = ie.exec(n)) && i[1] && (n = ue(e, t, i), o = "number"), null != n && n === n && ("number" === o && (n += i && i[3] || (w.cssNumber[s] ? "" : "px")), h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n));
      }
    }, css: function css(e, t, n, r) {
      var i,
          o,
          a,
          s = G(t);return Xe.test(t) || (t = Je(s)), (a = w.cssHooks[t] || w.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = Fe(e, t, r)), "normal" === i && t in Ve && (i = Ve[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
    } }), w.each(["height", "width"], function (e, t) {
    w.cssHooks[t] = { get: function get(e, n, r) {
        if (n) return !ze.test(w.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? et(e, t, r) : se(e, Ue, function () {
          return et(e, t, r);
        });
      }, set: function set(e, n, r) {
        var i,
            o = $e(e),
            a = "border-box" === w.css(e, "boxSizing", !1, o),
            s = r && Ze(e, t, r, a, o);return a && h.scrollboxSize() === o.position && (s -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Ze(e, t, "border", !1, o) - .5)), s && (i = ie.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = w.css(e, t)), Ke(e, n, s);
      } };
  }), w.cssHooks.marginLeft = _e(h.reliableMarginLeft, function (e, t) {
    if (t) return (parseFloat(Fe(e, "marginLeft")) || e.getBoundingClientRect().left - se(e, { marginLeft: 0 }, function () {
      return e.getBoundingClientRect().left;
    })) + "px";
  }), w.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
    w.cssHooks[e + t] = { expand: function expand(n) {
        for (var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [n]; r < 4; r++) {
          i[e + oe[r] + t] = o[r] || o[r - 2] || o[0];
        }return i;
      } }, "margin" !== e && (w.cssHooks[e + t].set = Ke);
  }), w.fn.extend({ css: function css(e, t) {
      return z(this, function (e, t, n) {
        var r,
            i,
            o = {},
            a = 0;if (Array.isArray(t)) {
          for (r = $e(e), i = t.length; a < i; a++) {
            o[t[a]] = w.css(e, t[a], !1, r);
          }return o;
        }return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
      }, e, t, arguments.length > 1);
    } });function tt(e, t, n, r, i) {
    return new tt.prototype.init(e, t, n, r, i);
  }w.Tween = tt, tt.prototype = { constructor: tt, init: function init(e, t, n, r, i, o) {
      this.elem = e, this.prop = n, this.easing = i || w.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (w.cssNumber[n] ? "" : "px");
    }, cur: function cur() {
      var e = tt.propHooks[this.prop];return e && e.get ? e.get(this) : tt.propHooks._default.get(this);
    }, run: function run(e) {
      var t,
          n = tt.propHooks[this.prop];return this.options.duration ? this.pos = t = w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : tt.propHooks._default.set(this), this;
    } }, tt.prototype.init.prototype = tt.prototype, tt.propHooks = { _default: { get: function get(e) {
        var t;return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = w.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
      }, set: function set(e) {
        w.fx.step[e.prop] ? w.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[w.cssProps[e.prop]] && !w.cssHooks[e.prop] ? e.elem[e.prop] = e.now : w.style(e.elem, e.prop, e.now + e.unit);
      } } }, tt.propHooks.scrollTop = tt.propHooks.scrollLeft = { set: function set(e) {
      e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
    } }, w.easing = { linear: function linear(e) {
      return e;
    }, swing: function swing(e) {
      return .5 - Math.cos(e * Math.PI) / 2;
    }, _default: "swing" }, w.fx = tt.prototype.init, w.fx.step = {};var nt,
      rt,
      it = /^(?:toggle|show|hide)$/,
      ot = /queueHooks$/;function at() {
    rt && (!1 === r.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(at) : e.setTimeout(at, w.fx.interval), w.fx.tick());
  }function st() {
    return e.setTimeout(function () {
      nt = void 0;
    }), nt = Date.now();
  }function ut(e, t) {
    var n,
        r = 0,
        i = { height: e };for (t = t ? 1 : 0; r < 4; r += 2 - t) {
      i["margin" + (n = oe[r])] = i["padding" + n] = e;
    }return t && (i.opacity = i.width = e), i;
  }function lt(e, t, n) {
    for (var r, i = (pt.tweeners[t] || []).concat(pt.tweeners["*"]), o = 0, a = i.length; o < a; o++) {
      if (r = i[o].call(n, t, e)) return r;
    }
  }function ct(e, t, n) {
    var r,
        i,
        o,
        a,
        s,
        u,
        l,
        c,
        f = "width" in t || "height" in t,
        p = this,
        d = {},
        h = e.style,
        g = e.nodeType && ae(e),
        y = J.get(e, "fxshow");n.queue || (null == (a = w._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function () {
      a.unqueued || s();
    }), a.unqueued++, p.always(function () {
      p.always(function () {
        a.unqueued--, w.queue(e, "fx").length || a.empty.fire();
      });
    }));for (r in t) {
      if (i = t[r], it.test(i)) {
        if (delete t[r], o = o || "toggle" === i, i === (g ? "hide" : "show")) {
          if ("show" !== i || !y || void 0 === y[r]) continue;g = !0;
        }d[r] = y && y[r] || w.style(e, r);
      }
    }if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) {
      f && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (l = y && y.display) && (l = J.get(e, "display")), "none" === (c = w.css(e, "display")) && (l ? c = l : (fe([e], !0), l = e.style.display || l, c = w.css(e, "display"), fe([e]))), ("inline" === c || "inline-block" === c && null != l) && "none" === w.css(e, "float") && (u || (p.done(function () {
        h.display = l;
      }), null == l && (c = h.display, l = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function () {
        h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
      })), u = !1;for (r in d) {
        u || (y ? "hidden" in y && (g = y.hidden) : y = J.access(e, "fxshow", { display: l }), o && (y.hidden = !g), g && fe([e], !0), p.done(function () {
          g || fe([e]), J.remove(e, "fxshow");for (r in d) {
            w.style(e, r, d[r]);
          }
        })), u = lt(g ? y[r] : 0, r, p), r in y || (y[r] = u.start, g && (u.end = u.start, u.start = 0));
      }
    }
  }function ft(e, t) {
    var n, r, i, o, a;for (n in e) {
      if (r = G(n), i = t[r], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = w.cssHooks[r]) && "expand" in a) {
        o = a.expand(o), delete e[r];for (n in o) {
          n in e || (e[n] = o[n], t[n] = i);
        }
      } else t[r] = i;
    }
  }function pt(e, t, n) {
    var r,
        i,
        o = 0,
        a = pt.prefilters.length,
        s = w.Deferred().always(function () {
      delete u.elem;
    }),
        u = function u() {
      if (i) return !1;for (var t = nt || st(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, a = l.tweens.length; o < a; o++) {
        l.tweens[o].run(r);
      }return s.notifyWith(e, [l, r, n]), r < 1 && a ? n : (a || s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l]), !1);
    },
        l = s.promise({ elem: e, props: w.extend({}, t), opts: w.extend(!0, { specialEasing: {}, easing: w.easing._default }, n), originalProperties: t, originalOptions: n, startTime: nt || st(), duration: n.duration, tweens: [], createTween: function createTween(t, n) {
        var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);return l.tweens.push(r), r;
      }, stop: function stop(t) {
        var n = 0,
            r = t ? l.tweens.length : 0;if (i) return this;for (i = !0; n < r; n++) {
          l.tweens[n].run(1);
        }return t ? (s.notifyWith(e, [l, 1, 0]), s.resolveWith(e, [l, t])) : s.rejectWith(e, [l, t]), this;
      } }),
        c = l.props;for (ft(c, l.opts.specialEasing); o < a; o++) {
      if (r = pt.prefilters[o].call(l, e, c, l.opts)) return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r;
    }return w.map(c, lt, l), g(l.opts.start) && l.opts.start.call(e, l), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always), w.fx.timer(w.extend(u, { elem: e, anim: l, queue: l.opts.queue })), l;
  }w.Animation = w.extend(pt, { tweeners: { "*": [function (e, t) {
        var n = this.createTween(e, t);return ue(n.elem, e, ie.exec(t), n), n;
      }] }, tweener: function tweener(e, t) {
      g(e) ? (t = e, e = ["*"]) : e = e.match(M);for (var n, r = 0, i = e.length; r < i; r++) {
        n = e[r], pt.tweeners[n] = pt.tweeners[n] || [], pt.tweeners[n].unshift(t);
      }
    }, prefilters: [ct], prefilter: function prefilter(e, t) {
      t ? pt.prefilters.unshift(e) : pt.prefilters.push(e);
    } }), w.speed = function (e, t, n) {
    var r = e && "object" == (typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e)) ? w.extend({}, e) : { complete: n || !n && t || g(e) && e, duration: e, easing: n && t || t && !g(t) && t };return w.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in w.fx.speeds ? r.duration = w.fx.speeds[r.duration] : r.duration = w.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function () {
      g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue);
    }, r;
  }, w.fn.extend({ fadeTo: function fadeTo(e, t, n, r) {
      return this.filter(ae).css("opacity", 0).show().end().animate({ opacity: t }, e, n, r);
    }, animate: function animate(e, t, n, r) {
      var i = w.isEmptyObject(e),
          o = w.speed(t, n, r),
          a = function a() {
        var t = pt(this, w.extend({}, e), o);(i || J.get(this, "finish")) && t.stop(!0);
      };return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
    }, stop: function stop(e, t, n) {
      var r = function r(e) {
        var t = e.stop;delete e.stop, t(n);
      };return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function () {
        var t = !0,
            i = null != e && e + "queueHooks",
            o = w.timers,
            a = J.get(this);if (i) a[i] && a[i].stop && r(a[i]);else for (i in a) {
          a[i] && a[i].stop && ot.test(i) && r(a[i]);
        }for (i = o.length; i--;) {
          o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
        }!t && n || w.dequeue(this, e);
      });
    }, finish: function finish(e) {
      return !1 !== e && (e = e || "fx"), this.each(function () {
        var t,
            n = J.get(this),
            r = n[e + "queue"],
            i = n[e + "queueHooks"],
            o = w.timers,
            a = r ? r.length : 0;for (n.finish = !0, w.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;) {
          o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
        }for (t = 0; t < a; t++) {
          r[t] && r[t].finish && r[t].finish.call(this);
        }delete n.finish;
      });
    } }), w.each(["toggle", "show", "hide"], function (e, t) {
    var n = w.fn[t];w.fn[t] = function (e, r, i) {
      return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(ut(t, !0), e, r, i);
    };
  }), w.each({ slideDown: ut("show"), slideUp: ut("hide"), slideToggle: ut("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
    w.fn[e] = function (e, n, r) {
      return this.animate(t, e, n, r);
    };
  }), w.timers = [], w.fx.tick = function () {
    var e,
        t = 0,
        n = w.timers;for (nt = Date.now(); t < n.length; t++) {
      (e = n[t])() || n[t] !== e || n.splice(t--, 1);
    }n.length || w.fx.stop(), nt = void 0;
  }, w.fx.timer = function (e) {
    w.timers.push(e), w.fx.start();
  }, w.fx.interval = 13, w.fx.start = function () {
    rt || (rt = !0, at());
  }, w.fx.stop = function () {
    rt = null;
  }, w.fx.speeds = { slow: 600, fast: 200, _default: 400 }, w.fn.delay = function (t, n) {
    return t = w.fx ? w.fx.speeds[t] || t : t, n = n || "fx", this.queue(n, function (n, r) {
      var i = e.setTimeout(n, t);r.stop = function () {
        e.clearTimeout(i);
      };
    });
  }, function () {
    var e = r.createElement("input"),
        t = r.createElement("select").appendChild(r.createElement("option"));e.type = "checkbox", h.checkOn = "" !== e.value, h.optSelected = t.selected, (e = r.createElement("input")).value = "t", e.type = "radio", h.radioValue = "t" === e.value;
  }();var dt,
      ht = w.expr.attrHandle;w.fn.extend({ attr: function attr(e, t) {
      return z(this, w.attr, e, t, arguments.length > 1);
    }, removeAttr: function removeAttr(e) {
      return this.each(function () {
        w.removeAttr(this, e);
      });
    } }), w.extend({ attr: function attr(e, t, n) {
      var r,
          i,
          o = e.nodeType;if (3 !== o && 8 !== o && 2 !== o) return "undefined" == typeof e.getAttribute ? w.prop(e, t, n) : (1 === o && w.isXMLDoc(e) || (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? dt : void 0)), void 0 !== n ? null === n ? void w.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = w.find.attr(e, t)) ? void 0 : r);
    }, attrHooks: { type: { set: function set(e, t) {
          if (!h.radioValue && "radio" === t && N(e, "input")) {
            var n = e.value;return e.setAttribute("type", t), n && (e.value = n), t;
          }
        } } }, removeAttr: function removeAttr(e, t) {
      var n,
          r = 0,
          i = t && t.match(M);if (i && 1 === e.nodeType) while (n = i[r++]) {
        e.removeAttribute(n);
      }
    } }), dt = { set: function set(e, t, n) {
      return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
    } }, w.each(w.expr.match.bool.source.match(/\w+/g), function (e, t) {
    var n = ht[t] || w.find.attr;ht[t] = function (e, t, r) {
      var i,
          o,
          a = t.toLowerCase();return r || (o = ht[a], ht[a] = i, i = null != n(e, t, r) ? a : null, ht[a] = o), i;
    };
  });var gt = /^(?:input|select|textarea|button)$/i,
      yt = /^(?:a|area)$/i;w.fn.extend({ prop: function prop(e, t) {
      return z(this, w.prop, e, t, arguments.length > 1);
    }, removeProp: function removeProp(e) {
      return this.each(function () {
        delete this[w.propFix[e] || e];
      });
    } }), w.extend({ prop: function prop(e, t, n) {
      var r,
          i,
          o = e.nodeType;if (3 !== o && 8 !== o && 2 !== o) return 1 === o && w.isXMLDoc(e) || (t = w.propFix[t] || t, i = w.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
    }, propHooks: { tabIndex: { get: function get(e) {
          var t = w.find.attr(e, "tabindex");return t ? parseInt(t, 10) : gt.test(e.nodeName) || yt.test(e.nodeName) && e.href ? 0 : -1;
        } } }, propFix: { "for": "htmlFor", "class": "className" } }), h.optSelected || (w.propHooks.selected = { get: function get(e) {
      var t = e.parentNode;return t && t.parentNode && t.parentNode.selectedIndex, null;
    }, set: function set(e) {
      var t = e.parentNode;t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
    } }), w.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    w.propFix[this.toLowerCase()] = this;
  });function vt(e) {
    return (e.match(M) || []).join(" ");
  }function mt(e) {
    return e.getAttribute && e.getAttribute("class") || "";
  }function xt(e) {
    return Array.isArray(e) ? e : "string" == typeof e ? e.match(M) || [] : [];
  }w.fn.extend({ addClass: function addClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;if (g(e)) return this.each(function (t) {
        w(this).addClass(e.call(this, t, mt(this)));
      });if ((t = xt(e)).length) while (n = this[u++]) {
        if (i = mt(n), r = 1 === n.nodeType && " " + vt(i) + " ") {
          a = 0;while (o = t[a++]) {
            r.indexOf(" " + o + " ") < 0 && (r += o + " ");
          }i !== (s = vt(r)) && n.setAttribute("class", s);
        }
      }return this;
    }, removeClass: function removeClass(e) {
      var t,
          n,
          r,
          i,
          o,
          a,
          s,
          u = 0;if (g(e)) return this.each(function (t) {
        w(this).removeClass(e.call(this, t, mt(this)));
      });if (!arguments.length) return this.attr("class", "");if ((t = xt(e)).length) while (n = this[u++]) {
        if (i = mt(n), r = 1 === n.nodeType && " " + vt(i) + " ") {
          a = 0;while (o = t[a++]) {
            while (r.indexOf(" " + o + " ") > -1) {
              r = r.replace(" " + o + " ", " ");
            }
          }i !== (s = vt(r)) && n.setAttribute("class", s);
        }
      }return this;
    }, toggleClass: function toggleClass(e, t) {
      var n = typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(e),
          r = "string" === n || Array.isArray(e);return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : g(e) ? this.each(function (n) {
        w(this).toggleClass(e.call(this, n, mt(this), t), t);
      }) : this.each(function () {
        var t, i, o, a;if (r) {
          i = 0, o = w(this), a = xt(e);while (t = a[i++]) {
            o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
          }
        } else void 0 !== e && "boolean" !== n || ((t = mt(this)) && J.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : J.get(this, "__className__") || ""));
      });
    }, hasClass: function hasClass(e) {
      var t,
          n,
          r = 0;t = " " + e + " ";while (n = this[r++]) {
        if (1 === n.nodeType && (" " + vt(mt(n)) + " ").indexOf(t) > -1) return !0;
      }return !1;
    } });var bt = /\r/g;w.fn.extend({ val: function val(e) {
      var t,
          n,
          r,
          i = this[0];{
        if (arguments.length) return r = g(e), this.each(function (n) {
          var i;1 === this.nodeType && (null == (i = r ? e.call(this, n, w(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = w.map(i, function (e) {
            return null == e ? "" : e + "";
          })), (t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i));
        });if (i) return (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(bt, "") : null == n ? "" : n;
      }
    } }), w.extend({ valHooks: { option: { get: function get(e) {
          var t = w.find.attr(e, "value");return null != t ? t : vt(w.text(e));
        } }, select: { get: function get(e) {
          var t,
              n,
              r,
              i = e.options,
              o = e.selectedIndex,
              a = "select-one" === e.type,
              s = a ? null : [],
              u = a ? o + 1 : i.length;for (r = o < 0 ? u : a ? o : 0; r < u; r++) {
            if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !N(n.parentNode, "optgroup"))) {
              if (t = w(n).val(), a) return t;s.push(t);
            }
          }return s;
        }, set: function set(e, t) {
          var n,
              r,
              i = e.options,
              o = w.makeArray(t),
              a = i.length;while (a--) {
            ((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
          }return n || (e.selectedIndex = -1), o;
        } } } }), w.each(["radio", "checkbox"], function () {
    w.valHooks[this] = { set: function set(e, t) {
        if (Array.isArray(t)) return e.checked = w.inArray(w(e).val(), t) > -1;
      } }, h.checkOn || (w.valHooks[this].get = function (e) {
      return null === e.getAttribute("value") ? "on" : e.value;
    });
  }), h.focusin = "onfocusin" in e;var wt = /^(?:focusinfocus|focusoutblur)$/,
      Tt = function Tt(e) {
    e.stopPropagation();
  };w.extend(w.event, { trigger: function trigger(t, n, i, o) {
      var a,
          s,
          u,
          l,
          c,
          p,
          d,
          h,
          v = [i || r],
          m = f.call(t, "type") ? t.type : t,
          x = f.call(t, "namespace") ? t.namespace.split(".") : [];if (s = h = u = i = i || r, 3 !== i.nodeType && 8 !== i.nodeType && !wt.test(m + w.event.triggered) && (m.indexOf(".") > -1 && (m = (x = m.split(".")).shift(), x.sort()), c = m.indexOf(":") < 0 && "on" + m, t = t[w.expando] ? t : new w.Event(m, "object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(t)) && t), t.isTrigger = o ? 2 : 3, t.namespace = x.join("."), t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, t.result = void 0, t.target || (t.target = i), n = null == n ? [t] : w.makeArray(n, [t]), d = w.event.special[m] || {}, o || !d.trigger || !1 !== d.trigger.apply(i, n))) {
        if (!o && !d.noBubble && !y(i)) {
          for (l = d.delegateType || m, wt.test(l + m) || (s = s.parentNode); s; s = s.parentNode) {
            v.push(s), u = s;
          }u === (i.ownerDocument || r) && v.push(u.defaultView || u.parentWindow || e);
        }a = 0;while ((s = v[a++]) && !t.isPropagationStopped()) {
          h = s, t.type = a > 1 ? l : d.bindType || m, (p = (J.get(s, "events") || {})[t.type] && J.get(s, "handle")) && p.apply(s, n), (p = c && s[c]) && p.apply && Y(s) && (t.result = p.apply(s, n), !1 === t.result && t.preventDefault());
        }return t.type = m, o || t.isDefaultPrevented() || d._default && !1 !== d._default.apply(v.pop(), n) || !Y(i) || c && g(i[m]) && !y(i) && ((u = i[c]) && (i[c] = null), w.event.triggered = m, t.isPropagationStopped() && h.addEventListener(m, Tt), i[m](), t.isPropagationStopped() && h.removeEventListener(m, Tt), w.event.triggered = void 0, u && (i[c] = u)), t.result;
      }
    }, simulate: function simulate(e, t, n) {
      var r = w.extend(new w.Event(), n, { type: e, isSimulated: !0 });w.event.trigger(r, null, t);
    } }), w.fn.extend({ trigger: function trigger(e, t) {
      return this.each(function () {
        w.event.trigger(e, t, this);
      });
    }, triggerHandler: function triggerHandler(e, t) {
      var n = this[0];if (n) return w.event.trigger(e, t, n, !0);
    } }), h.focusin || w.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
    var n = function n(e) {
      w.event.simulate(t, e.target, w.event.fix(e));
    };w.event.special[t] = { setup: function setup() {
        var r = this.ownerDocument || this,
            i = J.access(r, t);i || r.addEventListener(e, n, !0), J.access(r, t, (i || 0) + 1);
      }, teardown: function teardown() {
        var r = this.ownerDocument || this,
            i = J.access(r, t) - 1;i ? J.access(r, t, i) : (r.removeEventListener(e, n, !0), J.remove(r, t));
      } };
  });var Ct = e.location,
      Et = Date.now(),
      kt = /\?/;w.parseXML = function (t) {
    var n;if (!t || "string" != typeof t) return null;try {
      n = new e.DOMParser().parseFromString(t, "text/xml");
    } catch (e) {
      n = void 0;
    }return n && !n.getElementsByTagName("parsererror").length || w.error("Invalid XML: " + t), n;
  };var St = /\[\]$/,
      Dt = /\r?\n/g,
      Nt = /^(?:submit|button|image|reset|file)$/i,
      At = /^(?:input|select|textarea|keygen)/i;function jt(e, t, n, r) {
    var i;if (Array.isArray(t)) w.each(t, function (t, i) {
      n || St.test(e) ? r(e, i) : jt(e + "[" + ("object" == (typeof i === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(i)) && null != i ? t : "") + "]", i, n, r);
    });else if (n || "object" !== x(t)) r(e, t);else for (i in t) {
      jt(e + "[" + i + "]", t[i], n, r);
    }
  }w.param = function (e, t) {
    var n,
        r = [],
        i = function i(e, t) {
      var n = g(t) ? t() : t;r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
    };if (Array.isArray(e) || e.jquery && !w.isPlainObject(e)) w.each(e, function () {
      i(this.name, this.value);
    });else for (n in e) {
      jt(n, e[n], t, i);
    }return r.join("&");
  }, w.fn.extend({ serialize: function serialize() {
      return w.param(this.serializeArray());
    }, serializeArray: function serializeArray() {
      return this.map(function () {
        var e = w.prop(this, "elements");return e ? w.makeArray(e) : this;
      }).filter(function () {
        var e = this.type;return this.name && !w(this).is(":disabled") && At.test(this.nodeName) && !Nt.test(e) && (this.checked || !pe.test(e));
      }).map(function (e, t) {
        var n = w(this).val();return null == n ? null : Array.isArray(n) ? w.map(n, function (e) {
          return { name: t.name, value: e.replace(Dt, "\r\n") };
        }) : { name: t.name, value: n.replace(Dt, "\r\n") };
      }).get();
    } });var qt = /%20/g,
      Lt = /#.*$/,
      Ht = /([?&])_=[^&]*/,
      Ot = /^(.*?):[ \t]*([^\r\n]*)$/gm,
      Pt = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
      Mt = /^(?:GET|HEAD)$/,
      Rt = /^\/\//,
      It = {},
      Wt = {},
      $t = "*/".concat("*"),
      Bt = r.createElement("a");Bt.href = Ct.href;function Ft(e) {
    return function (t, n) {
      "string" != typeof t && (n = t, t = "*");var r,
          i = 0,
          o = t.toLowerCase().match(M) || [];if (g(n)) while (r = o[i++]) {
        "+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
      }
    };
  }function _t(e, t, n, r) {
    var i = {},
        o = e === Wt;function a(s) {
      var u;return i[s] = !0, w.each(e[s] || [], function (e, s) {
        var l = s(t, n, r);return "string" != typeof l || o || i[l] ? o ? !(u = l) : void 0 : (t.dataTypes.unshift(l), a(l), !1);
      }), u;
    }return a(t.dataTypes[0]) || !i["*"] && a("*");
  }function zt(e, t) {
    var n,
        r,
        i = w.ajaxSettings.flatOptions || {};for (n in t) {
      void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
    }return r && w.extend(!0, e, r), e;
  }function Xt(e, t, n) {
    var r,
        i,
        o,
        a,
        s = e.contents,
        u = e.dataTypes;while ("*" === u[0]) {
      u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
    }if (r) for (i in s) {
      if (s[i] && s[i].test(r)) {
        u.unshift(i);break;
      }
    }if (u[0] in n) o = u[0];else {
      for (i in n) {
        if (!u[0] || e.converters[i + " " + u[0]]) {
          o = i;break;
        }a || (a = i);
      }o = o || a;
    }if (o) return o !== u[0] && u.unshift(o), n[o];
  }function Ut(e, t, n, r) {
    var i,
        o,
        a,
        s,
        u,
        l = {},
        c = e.dataTypes.slice();if (c[1]) for (a in e.converters) {
      l[a.toLowerCase()] = e.converters[a];
    }o = c.shift();while (o) {
      if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = c.shift()) if ("*" === o) o = u;else if ("*" !== u && u !== o) {
        if (!(a = l[u + " " + o] || l["* " + o])) for (i in l) {
          if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
            !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0], c.unshift(s[1]));break;
          }
        }if (!0 !== a) if (a && e["throws"]) t = a(t);else try {
          t = a(t);
        } catch (e) {
          return { state: "parsererror", error: a ? e : "No conversion from " + u + " to " + o };
        }
      }
    }return { state: "success", data: t };
  }w.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: Ct.href, type: "GET", isLocal: Pt.test(Ct.protocol), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": $t, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": w.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(e, t) {
      return t ? zt(zt(e, w.ajaxSettings), t) : zt(w.ajaxSettings, e);
    }, ajaxPrefilter: Ft(It), ajaxTransport: Ft(Wt), ajax: function ajax(t, n) {
      "object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(t)) && (n = t, t = void 0), n = n || {};var i,
          o,
          a,
          s,
          u,
          l,
          c,
          f,
          p,
          d,
          h = w.ajaxSetup({}, n),
          g = h.context || h,
          y = h.context && (g.nodeType || g.jquery) ? w(g) : w.event,
          v = w.Deferred(),
          m = w.Callbacks("once memory"),
          x = h.statusCode || {},
          b = {},
          T = {},
          C = "canceled",
          E = { readyState: 0, getResponseHeader: function getResponseHeader(e) {
          var t;if (c) {
            if (!s) {
              s = {};while (t = Ot.exec(a)) {
                s[t[1].toLowerCase()] = t[2];
              }
            }t = s[e.toLowerCase()];
          }return null == t ? null : t;
        }, getAllResponseHeaders: function getAllResponseHeaders() {
          return c ? a : null;
        }, setRequestHeader: function setRequestHeader(e, t) {
          return null == c && (e = T[e.toLowerCase()] = T[e.toLowerCase()] || e, b[e] = t), this;
        }, overrideMimeType: function overrideMimeType(e) {
          return null == c && (h.mimeType = e), this;
        }, statusCode: function statusCode(e) {
          var t;if (e) if (c) E.always(e[E.status]);else for (t in e) {
            x[t] = [x[t], e[t]];
          }return this;
        }, abort: function abort(e) {
          var t = e || C;return i && i.abort(t), k(0, t), this;
        } };if (v.promise(E), h.url = ((t || h.url || Ct.href) + "").replace(Rt, Ct.protocol + "//"), h.type = n.method || n.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(M) || [""], null == h.crossDomain) {
        l = r.createElement("a");try {
          l.href = h.url, l.href = l.href, h.crossDomain = Bt.protocol + "//" + Bt.host != l.protocol + "//" + l.host;
        } catch (e) {
          h.crossDomain = !0;
        }
      }if (h.data && h.processData && "string" != typeof h.data && (h.data = w.param(h.data, h.traditional)), _t(It, h, n, E), c) return E;(f = w.event && h.global) && 0 == w.active++ && w.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !Mt.test(h.type), o = h.url.replace(Lt, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(qt, "+")) : (d = h.url.slice(o.length), h.data && (h.processData || "string" == typeof h.data) && (o += (kt.test(o) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (o = o.replace(Ht, "$1"), d = (kt.test(o) ? "&" : "?") + "_=" + Et++ + d), h.url = o + d), h.ifModified && (w.lastModified[o] && E.setRequestHeader("If-Modified-Since", w.lastModified[o]), w.etag[o] && E.setRequestHeader("If-None-Match", w.etag[o])), (h.data && h.hasContent && !1 !== h.contentType || n.contentType) && E.setRequestHeader("Content-Type", h.contentType), E.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + $t + "; q=0.01" : "") : h.accepts["*"]);for (p in h.headers) {
        E.setRequestHeader(p, h.headers[p]);
      }if (h.beforeSend && (!1 === h.beforeSend.call(g, E, h) || c)) return E.abort();if (C = "abort", m.add(h.complete), E.done(h.success), E.fail(h.error), i = _t(Wt, h, n, E)) {
        if (E.readyState = 1, f && y.trigger("ajaxSend", [E, h]), c) return E;h.async && h.timeout > 0 && (u = e.setTimeout(function () {
          E.abort("timeout");
        }, h.timeout));try {
          c = !1, i.send(b, k);
        } catch (e) {
          if (c) throw e;k(-1, e);
        }
      } else k(-1, "No Transport");function k(t, n, r, s) {
        var l,
            p,
            d,
            b,
            T,
            C = n;c || (c = !0, u && e.clearTimeout(u), i = void 0, a = s || "", E.readyState = t > 0 ? 4 : 0, l = t >= 200 && t < 300 || 304 === t, r && (b = Xt(h, E, r)), b = Ut(h, b, E, l), l ? (h.ifModified && ((T = E.getResponseHeader("Last-Modified")) && (w.lastModified[o] = T), (T = E.getResponseHeader("etag")) && (w.etag[o] = T)), 204 === t || "HEAD" === h.type ? C = "nocontent" : 304 === t ? C = "notmodified" : (C = b.state, p = b.data, l = !(d = b.error))) : (d = C, !t && C || (C = "error", t < 0 && (t = 0))), E.status = t, E.statusText = (n || C) + "", l ? v.resolveWith(g, [p, C, E]) : v.rejectWith(g, [E, C, d]), E.statusCode(x), x = void 0, f && y.trigger(l ? "ajaxSuccess" : "ajaxError", [E, h, l ? p : d]), m.fireWith(g, [E, C]), f && (y.trigger("ajaxComplete", [E, h]), --w.active || w.event.trigger("ajaxStop")));
      }return E;
    }, getJSON: function getJSON(e, t, n) {
      return w.get(e, t, n, "json");
    }, getScript: function getScript(e, t) {
      return w.get(e, void 0, t, "script");
    } }), w.each(["get", "post"], function (e, t) {
    w[t] = function (e, n, r, i) {
      return g(n) && (i = i || r, r = n, n = void 0), w.ajax(w.extend({ url: e, type: t, dataType: i, data: n, success: r }, w.isPlainObject(e) && e));
    };
  }), w._evalUrl = function (e) {
    return w.ajax({ url: e, type: "GET", dataType: "script", cache: !0, async: !1, global: !1, "throws": !0 });
  }, w.fn.extend({ wrapAll: function wrapAll(e) {
      var t;return this[0] && (g(e) && (e = e.call(this[0])), t = w(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function () {
        var e = this;while (e.firstElementChild) {
          e = e.firstElementChild;
        }return e;
      }).append(this)), this;
    }, wrapInner: function wrapInner(e) {
      return g(e) ? this.each(function (t) {
        w(this).wrapInner(e.call(this, t));
      }) : this.each(function () {
        var t = w(this),
            n = t.contents();n.length ? n.wrapAll(e) : t.append(e);
      });
    }, wrap: function wrap(e) {
      var t = g(e);return this.each(function (n) {
        w(this).wrapAll(t ? e.call(this, n) : e);
      });
    }, unwrap: function unwrap(e) {
      return this.parent(e).not("body").each(function () {
        w(this).replaceWith(this.childNodes);
      }), this;
    } }), w.expr.pseudos.hidden = function (e) {
    return !w.expr.pseudos.visible(e);
  }, w.expr.pseudos.visible = function (e) {
    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
  }, w.ajaxSettings.xhr = function () {
    try {
      return new e.XMLHttpRequest();
    } catch (e) {}
  };var Vt = { 0: 200, 1223: 204 },
      Gt = w.ajaxSettings.xhr();h.cors = !!Gt && "withCredentials" in Gt, h.ajax = Gt = !!Gt, w.ajaxTransport(function (t) {
    var _n, r;if (h.cors || Gt && !t.crossDomain) return { send: function send(i, o) {
        var a,
            s = t.xhr();if (s.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields) for (a in t.xhrFields) {
          s[a] = t.xhrFields[a];
        }t.mimeType && s.overrideMimeType && s.overrideMimeType(t.mimeType), t.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest");for (a in i) {
          s.setRequestHeader(a, i[a]);
        }_n = function n(e) {
          return function () {
            _n && (_n = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Vt[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? { binary: s.response } : { text: s.responseText }, s.getAllResponseHeaders()));
          };
        }, s.onload = _n(), r = s.onerror = s.ontimeout = _n("error"), void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function () {
          4 === s.readyState && e.setTimeout(function () {
            _n && r();
          });
        }, _n = _n("abort");try {
          s.send(t.hasContent && t.data || null);
        } catch (e) {
          if (_n) throw e;
        }
      }, abort: function abort() {
        _n && _n();
      } };
  }), w.ajaxPrefilter(function (e) {
    e.crossDomain && (e.contents.script = !1);
  }), w.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /\b(?:java|ecma)script\b/ }, converters: { "text script": function textScript(e) {
        return w.globalEval(e), e;
      } } }), w.ajaxPrefilter("script", function (e) {
    void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
  }), w.ajaxTransport("script", function (e) {
    if (e.crossDomain) {
      var t, _n2;return { send: function send(i, o) {
          t = w("<script>").prop({ charset: e.scriptCharset, src: e.url }).on("load error", _n2 = function n(e) {
            t.remove(), _n2 = null, e && o("error" === e.type ? 404 : 200, e.type);
          }), r.head.appendChild(t[0]);
        }, abort: function abort() {
          _n2 && _n2();
        } };
    }
  });var Yt = [],
      Qt = /(=)\?(?=&|$)|\?\?/;w.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
      var e = Yt.pop() || w.expando + "_" + Et++;return this[e] = !0, e;
    } }), w.ajaxPrefilter("json jsonp", function (t, n, r) {
    var i,
        o,
        a,
        s = !1 !== t.jsonp && (Qt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Qt.test(t.data) && "data");if (s || "jsonp" === t.dataTypes[0]) return i = t.jsonpCallback = g(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback, s ? t[s] = t[s].replace(Qt, "$1" + i) : !1 !== t.jsonp && (t.url += (kt.test(t.url) ? "&" : "?") + t.jsonp + "=" + i), t.converters["script json"] = function () {
      return a || w.error(i + " was not called"), a[0];
    }, t.dataTypes[0] = "json", o = e[i], e[i] = function () {
      a = arguments;
    }, r.always(function () {
      void 0 === o ? w(e).removeProp(i) : e[i] = o, t[i] && (t.jsonpCallback = n.jsonpCallback, Yt.push(i)), a && g(o) && o(a[0]), a = o = void 0;
    }), "script";
  }), h.createHTMLDocument = function () {
    var e = r.implementation.createHTMLDocument("").body;return e.innerHTML = "<form></form><form></form>", 2 === e.childNodes.length;
  }(), w.parseHTML = function (e, t, n) {
    if ("string" != typeof e) return [];"boolean" == typeof t && (n = t, t = !1);var i, o, a;return t || (h.createHTMLDocument ? ((i = (t = r.implementation.createHTMLDocument("")).createElement("base")).href = r.location.href, t.head.appendChild(i)) : t = r), o = A.exec(e), a = !n && [], o ? [t.createElement(o[1])] : (o = xe([e], t, a), a && a.length && w(a).remove(), w.merge([], o.childNodes));
  }, w.fn.load = function (e, t, n) {
    var r,
        i,
        o,
        a = this,
        s = e.indexOf(" ");return s > -1 && (r = vt(e.slice(s)), e = e.slice(0, s)), g(t) ? (n = t, t = void 0) : t && "object" == (typeof t === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(t)) && (i = "POST"), a.length > 0 && w.ajax({ url: e, type: i || "GET", dataType: "html", data: t }).done(function (e) {
      o = arguments, a.html(r ? w("<div>").append(w.parseHTML(e)).find(r) : e);
    }).always(n && function (e, t) {
      a.each(function () {
        n.apply(this, o || [e.responseText, t, e]);
      });
    }), this;
  }, w.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
    w.fn[t] = function (e) {
      return this.on(t, e);
    };
  }), w.expr.pseudos.animated = function (e) {
    return w.grep(w.timers, function (t) {
      return e === t.elem;
    }).length;
  }, w.offset = { setOffset: function setOffset(e, t, n) {
      var r,
          i,
          o,
          a,
          s,
          u,
          l,
          c = w.css(e, "position"),
          f = w(e),
          p = {};"static" === c && (e.style.position = "relative"), s = f.offset(), o = w.css(e, "top"), u = w.css(e, "left"), (l = ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1) ? (a = (r = f.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), g(t) && (t = t.call(e, n, w.extend({}, s))), null != t.top && (p.top = t.top - s.top + a), null != t.left && (p.left = t.left - s.left + i), "using" in t ? t.using.call(e, p) : f.css(p);
    } }, w.fn.extend({ offset: function offset(e) {
      if (arguments.length) return void 0 === e ? this : this.each(function (t) {
        w.offset.setOffset(this, e, t);
      });var t,
          n,
          r = this[0];if (r) return r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 };
    }, position: function position() {
      if (this[0]) {
        var e,
            t,
            n,
            r = this[0],
            i = { top: 0, left: 0 };if ("fixed" === w.css(r, "position")) t = r.getBoundingClientRect();else {
          t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement;while (e && (e === n.body || e === n.documentElement) && "static" === w.css(e, "position")) {
            e = e.parentNode;
          }e && e !== r && 1 === e.nodeType && ((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0), i.left += w.css(e, "borderLeftWidth", !0));
        }return { top: t.top - i.top - w.css(r, "marginTop", !0), left: t.left - i.left - w.css(r, "marginLeft", !0) };
      }
    }, offsetParent: function offsetParent() {
      return this.map(function () {
        var e = this.offsetParent;while (e && "static" === w.css(e, "position")) {
          e = e.offsetParent;
        }return e || be;
      });
    } }), w.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
    var n = "pageYOffset" === t;w.fn[e] = function (r) {
      return z(this, function (e, r, i) {
        var o;if (y(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[r];o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i;
      }, e, r, arguments.length);
    };
  }), w.each(["top", "left"], function (e, t) {
    w.cssHooks[t] = _e(h.pixelPosition, function (e, n) {
      if (n) return n = Fe(e, t), We.test(n) ? w(e).position()[t] + "px" : n;
    });
  }), w.each({ Height: "height", Width: "width" }, function (e, t) {
    w.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, r) {
      w.fn[r] = function (i, o) {
        var a = arguments.length && (n || "boolean" != typeof i),
            s = n || (!0 === i || !0 === o ? "margin" : "border");return z(this, function (t, n, i) {
          var o;return y(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? w.css(t, n, s) : w.style(t, n, i, s);
        }, t, a ? i : void 0, a);
      };
    });
  }), w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
    w.fn[t] = function (e, n) {
      return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
    };
  }), w.fn.extend({ hover: function hover(e, t) {
      return this.mouseenter(e).mouseleave(t || e);
    } }), w.fn.extend({ bind: function bind(e, t, n) {
      return this.on(e, null, t, n);
    }, unbind: function unbind(e, t) {
      return this.off(e, null, t);
    }, delegate: function delegate(e, t, n, r) {
      return this.on(t, e, n, r);
    }, undelegate: function undelegate(e, t, n) {
      return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
    } }), w.proxy = function (e, t) {
    var n, r, i;if ("string" == typeof t && (n = e[t], t = e, e = n), g(e)) return r = o.call(arguments, 2), i = function i() {
      return e.apply(t || this, r.concat(o.call(arguments)));
    }, i.guid = e.guid = e.guid || w.guid++, i;
  }, w.holdReady = function (e) {
    e ? w.readyWait++ : w.ready(!0);
  }, w.isArray = Array.isArray, w.parseJSON = JSON.parse, w.nodeName = N, w.isFunction = g, w.isWindow = y, w.camelCase = G, w.type = x, w.now = Date.now, w.isNumeric = function (e) {
    var t = w.type(e);return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
  }, "function" == typeof define && __webpack_require__("nErl") && define("jquery", [], function () {
    return w;
  });var Jt = e.jQuery,
      Kt = e.$;return w.noConflict = function (t) {
    return e.$ === w && (e.$ = Kt), t && e.jQuery === w && (e.jQuery = Jt), w;
  }, t || (e.jQuery = e.$ = w), w;
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "j4tA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loglevel__ = __webpack_require__("BvyM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_logrocket__ = __webpack_require__("oeg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser__ = __webpack_require__("j9k2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mixpanel_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_airship_js__ = __webpack_require__("cMp/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_masonry__ = __webpack_require__("w/U7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__spinner_vue__ = __webpack_require__("spwi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__card_vue__ = __webpack_require__("U2Li");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ibutton_vue__ = __webpack_require__("r+yu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modal_vue__ = __webpack_require__("ybKc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__alert_vue__ = __webpack_require__("olKB");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















// import SavvyImport from '../../plugins/savvy-import.js'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_15__card_vue__["a" /* default */],
    Icon: __WEBPACK_IMPORTED_MODULE_11_vue_awesome_components_Icon_vue__["a" /* default */],
    ibutton: __WEBPACK_IMPORTED_MODULE_16__ibutton_vue__["a" /* default */],
    BootstrapVue: __WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_17__modal_vue__["a" /* default */],
    Alert: __WEBPACK_IMPORTED_MODULE_18__alert_vue__["a" /* default */],
    Draggable: __WEBPACK_IMPORTED_MODULE_9_vuedraggable___default.a,
    Spinner: __WEBPACK_IMPORTED_MODULE_14__spinner_vue__["a" /* default */]
  },
  props: ['plugin', 'user', 'logo', 'Controller', 'authState', 'sidebar', 'local', 'testing', 'mode'],
  data: function data() {
    return {
      allCards: {},
      mainCardList: [],
      pingCards: [],
      popupCardList: [],
      popupClicked: false,
      popupShowTimeout: null,
      popupCloseTimeout: null,
      overMain: false,
      loading: false,
      loader: -1,
      loaderCards: 0,
      popupLoading: false,
      query: '',
      lastQuery: '',
      modal: {
        show: false,
        text: ''
      },
      alertData: {
        show: false,
        type: '',
        title: ''
      },
      noCardMessage: '', // 'Type above to search for cards'
      errorMessage: null,
      hint: ['press Shift+Enter to search Google instead', 'press the TAB key once to move the cursor to this search box', 'to see recent updated cards, don\'t type anything, just press Enter'][Math.floor(Math.random() * 1)], // Update this number with the number of hints!
      searchStrategy: 'algolia',
      searchStrategyOptions: [{ text: 'Algolia', value: 'algolia' }, { text: 'ElasticSearch', value: 'elasticsearch' }],
      allowSearchStrategy: false
    };
  },

  computed: {
    cards: function cards() {
      var self = this;
      var watchThis = self.allCards; // This does nothing other than force this function to watch for changes in self.allCards
      console.log('watchThis', watchThis);
      return self.mainCardList ? self.mainCardList.map(function (objectID) {
        return self.allCards[objectID] || { description: 'Card Not Found' };
      }) : [];
    },
    popupCards: function popupCards() {
      var self = this;
      var watchThis = self.allCards; // This does nothing other than force this function to watch for changes in self.allCards
      console.log('watchThis', watchThis);
      return self.popupCardList ? self.popupCardList.map(function (objectID) {
        var card = self.allCards[objectID] || { description: 'Card Not Found' };
        if (card._highlightResult) delete card._highlightResult;
        return card;
      }) : [];
    },
    searchPlaceholder: function searchPlaceholder() {
      // return document.documentElement.clientWidth > 850 ? 'Find anything (like holiday pay, product specs and brand colours)' : 'Find anything...'
      return 'Find anything...';
    }
  },
  watch: {
    searchStrategy: function searchStrategy(val) {
      console.log(111222);
      console.log(this.query);
      if (this.query) this.search();
    }
  },
  created: function created() {
    console.log('Starting Explorer');
    var self = this;
    if (!__WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$route) __WEBPACK_IMPORTED_MODULE_7_vue__["default"].prototype.$route = null;
    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_masonry__["a" /* VueMasonryPlugin */]);
    __WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_bootstrap_vue__["a" /* default */]);

    // Vue.use(SavvyImport)
    self.modal.sender = self.user.uid;
    self.modal.callback = self.modalCallback;
    self.$parent.$on('updateCards', self.updateCards);
    self.$parent.$on('getCard', self.getCard);
    self.$parent.$on('setLoading', self.setLoading);
    self.$parent.$on('closingDrawer', function () {
      self.closePopup(true);
    });
    self.$parent.$on('search', function (query) {
      self.search(self.$route && self.$route.query && self.$route.query.q || null);
    });

    // Load Airship Stuff
    var airship = new __WEBPACK_IMPORTED_MODULE_8_airship_js__["a" /* default */]({ webApiKey: 'yqfb07697ad5lak33tu75docb2duty5f', envKey: 'ky4t3nn8vp56n169' });
    airship.identify({
      type: 'User',
      id: this.user.uid,
      displayName: this.user.auth.emails ? this.user.auth.emails[0] : this.user.auth.email,
      attributes: {
        organisationID: this.user.data ? this.user.data.organisationID : '0'
      },
      group: {
        type: 'Organisation',
        id: this.user.data ? this.user.data.organisationID : '0'
      }
    }).then(function () {
      self.allowSearchStrategy = airship.isEnabled('choose-search-strategy');
      console.log('airship.isEnabled(\'choose-search-strategy\')');
      console.log(airship.isEnabled('choose-search-strategy'));
    });

    // SavvyImport.beginImport()
    __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser___default.a.init('e3b4939c1ae819d65712679199dfce7e', { api_host: 'https://api.mixpanel.com' });
    setTimeout(function () {
      if (self.$route && self.$route.query && self.$route.query.q) self.search(self.$route.query.q);
    }, 200);
  },
  updated: function updated() {
    var self = this;
    this.$nextTick(function () {
      // Could this slow things down?
      self.$redrawVueMasonry();
    });
  },
  methods: {
    convertFileToCards: function convertFileToCards(body, file) {
      var cards = [];
      body.split(/(\r\n\r\n\r\n|\n\n\n|\r\r\r)/gm).forEach(function (chunk) {
        chunk = chunk.trim();
        if (chunk.length) {
          cards.push({
            description: chunk,
            extractedFrom: {
              title: file.name,
              url: file.webViewLink // Not yet working maybe?
            }
          });
        }
      });
      return cards;
    },
    fetchCard: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(objectID) {
        var self, _highlightResult, card;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('fetchCard1', objectID);
                self = this;
                _highlightResult = self.allCards[objectID] && self.query === self.lastQuery ? self.allCards[objectID]._highlightResult : null; // So that when a search is still active, popup cards etc don't lose their highlights

                _context.next = 5;
                return self.Controller.getCard({
                  objectID: objectID,
                  params: {
                    searchStrategy: self.searchStrategy
                  }
                });

              case 5:
                card = _context.sent;

                if (!card._highlightResult) card._highlightResult = _highlightResult;
                __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(self.allCards, objectID, card); // Forces this to be watched @TODO: Find out whether Vue.set() is still necessary! In this place at least it seems to work without
                return _context.abrupt('return', card);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchCard(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchCard;
    }(),
    getCard: function getCard(objectID) {
      var self = this;
      var card = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.allCards[objectID] || null));
      return card;
    },
    setCard: function setCard(objectID, card) {
      console.log('setCard', objectID, card);
      var self = this;
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(self.allCards, objectID, card); // Forces this to be watched
      this.$nextTick(function () {
        self.$redrawVueMasonry();
      });
    },
    setCardProperty: function setCardProperty(objectID, property, value) {
      var self = this;
      var card = self.allCards[objectID];
      card[property] = value;
      __WEBPACK_IMPORTED_MODULE_7_vue__["default"].set(self.allCards, objectID, card); // Forces this to be watched - not yet working, at least with 'updating'
    },
    cardMouseoverFromPopup: function cardMouseoverFromPopup(card) {
      clearTimeout(this.popupCloseTimeout);
      clearTimeout(this.popupShowTimeout);
    },
    cardMouseover: function cardMouseover(card) {
      var self = this;
      if (self.sidebar) {
        clearTimeout(self.popupCloseTimeout);
        clearTimeout(self.popupShowTimeout);
        if (self.popupClicked) self.popupShowTimeout = setTimeout(function () {
          self.popupClicked = false;
          self.openPopup(card);
        }, 1000);else self.openPopup(card);
      }
    },
    cardMouseout: function cardMouseout() {
      if (this.sidebar) {
        this.closePopup();
      }
    },
    cardClickFromPopup: function cardClickFromPopup(card) {
      this.cardClick(card, true);
    },
    cardClick: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(card, fromPopup) {
        var self, openedCard;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = this;

                console.log('cardClick', card, fromPopup);
                self.popupClicked = true;
                _context2.next = 5;
                return self.openPopup(card, fromPopup);

              case 5:
                openedCard = _context2.sent;

                if (openedCard) {
                  _context2.next = 12;
                  break;
                }

                console.log('Caught cardlet failing to open - opening parent card instead');

                if (!(card.parentCard && card.parentCard.objectID)) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 11;
                return self.openPopup(card.parentCard, fromPopup);

              case 11:
                openedCard = _context2.sent;

              case 12:
                __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser___default.a.track('Card Clicked', {
                  organisationID: self.user.data.organisationID,
                  userID: self.user.uid,
                  cardID: openedCard.objectID,
                  description: openedCard.description,
                  title: openedCard.title,
                  listItems: openedCard.listItems
                });

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function cardClick(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return cardClick;
    }(),
    fileClick: function fileClick(card, file) {
      console.log('File Clicked', file);
      if (file && file.url) {
        console.log('Opening File', file);
        __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser___default.a.track('File Opened', {
          organisationID: this.user.data.organisationID,
          userID: this.user.uid,
          cardID: card.objectID,
          description: card.description,
          title: card.title,
          listItems: card.listItems,
          fileTitle: card.fileTitle,
          fileUrl: card.fileUrl,
          fileType: card.fileType,
          fileFormat: card.fileFormat
        });
        window.open(file.url, '_blank');
      }
    },
    serviceClick: function serviceClick(card, service) {
      console.log('Service Clicked', card, service);
      if (service && service.url) {
        console.log('Opening Service', service);
        __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser___default.a.track('File Opened', {
          organisationID: this.user.data.organisationID,
          userID: this.user.uid,
          cardID: card.objectID,
          description: card.description,
          title: card.title,
          listItems: card.listItems,
          fileTitle: card.fileTitle,
          fileUrl: card.fileUrl,
          fileType: card.fileType,
          fileFormat: card.fileFormat
        });
        window.open(service.url, '_blank');
      }
    },
    popupBack: function popupBack() {
      this.popupCardList.pop();
    },
    popupClickaway: function popupClickaway(event) {
      console.log('popupClickaway', event);
      var self = this;
      if (!this.sidebar) {
        self.closePopup();
      }
    },
    popupFrameClick: function popupFrameClick() {
      console.log('popupFrameClick');
      var self = this;
      if (this.sidebar) {
        self.closePopup(true);
        self.$emit('closeDrawer');
      } else {
        self.closePopup();
      }
    },
    openPopup: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(c, append) {
        var card;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('openPopup', c, append);
                clearTimeout(this.popupCloseTimeout);
                card = null;
                _context3.prev = 3;
                _context3.next = 6;
                return this.fetchCard(c.objectID);

              case 6:
                card = _context3.sent;
                _context3.next = 12;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](3);

                console.log(_context3.t0);

              case 12:
                // if (card.file) card.files = [card.file] // @TODO: Sort this out! Currently just a hack

                // if (c._highlightResult) {
                //   Object.keys(c._highlightResult).forEach(key => {
                //     console.log(key)
                //     if (key === 'fileTitle' && card.files && card.files.length)
                //       card.files[0].title = c._highlightResult[key].value
                //     else if (key === 'pendingContent')
                //       Object.keys(card.pendingContent).forEach(pcKey => {
                //         if (c._highlightResult.pendingContent[pcKey])
                //           card.pendingContent[pcKey] = c._highlightResult.pendingContent[pcKey].value
                //       })
                //     else if (key !== 'service')
                //       card[key === 'content' ? 'description' : key] = c._highlightResult[key].value
                //   })
                // }
                console.log('card', card);
                if (card) {
                  if (append) {
                    if (!this.popupCardList.length || this.popupCardList[this.popupCardList.length - 1] !== c.objectID) this.popupCardList.push(card.objectID);
                  } else this.popupCardList = [card.objectID];
                }
                return _context3.abrupt('return', card);

              case 15:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 9]]);
      }));

      function openPopup(_x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return openPopup;
    }(),
    closePopup: function closePopup(instantly) {
      console.log('closePopup');
      var self = this;
      self.editing = false; // This should be for every card so currently does nothing
      clearTimeout(self.popupCloseTimeout);
      if (this.sidebar && !instantly) {
        self.popupCloseTimeout = setTimeout(function () {
          self.popupClicked = false;
          self.popupCardList = [];
        }, 1000);
      } else {
        self.popupClicked = false;
        this.popupCardList = [];
      }
    },
    updateCards: function updateCards(data) {
      var self = this;
      self.loading = false;
      if (data && data.cards) {
        self.pingCards = data.cards.pings ? data.cards.pings.map(function (card) {
          return card.card;
        }) : [];
        __WEBPACK_IMPORTED_MODULE_3_loglevel___default.a.debug(1, self.pingCards);
        // self.cards = data.cards.memories
        self.mainCardList = data.cards.memories ? data.cards.memories.map(function (card) {
          return card.card.objectID;
        }) : [];
        __WEBPACK_IMPORTED_MODULE_3_loglevel___default.a.debug(2, self.mainCardList);
        // Need to add to allCards?
        if (data.cards.memories) data.cards.memories.forEach(function (card) {
          self.allCards[card.card.objectID] = card.card;
        });
        if (data.cards.hits) data.cards.hits.forEach(function (card) {
          self.allCards[card.card.objectID] = card.card;
        });
        __WEBPACK_IMPORTED_MODULE_3_loglevel___default.a.debug(3, self.allCards);
        self.noCardMessage = data.noCardMessage;
      }
    },
    setLoading: function setLoading() {
      console.log('setLoading');
      this.loading = true;
      this.pingCards = [];
      this.mainCardList = [];
    },
    closeSearch: function closeSearch() {
      console.log('closing search!');
      this.query = '';
      this.lastQuery = '';
      this.mainCardList = [];
      this.popupCardList = [];
    },
    search: function search(optionalQuery) {
      console.log('SEARCHSEARCHSEARCH');
      var self = this;
      self.errorMessage = null;
      self.setLoading();
      if (optionalQuery && typeof optionalQuery === 'string') self.query = optionalQuery;
      self.lastQuery = self.query;
      var query = self.query;
      var searchParams = {
        user: self.user,
        query: self.query,
        numberOfResults: 12,
        searchStrategy: self.searchStrategy
      };
      self.Controller.searchCards(searchParams).then(function (hits) {
        console.log('hits');
        console.log(hits);
        __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser___default.a.track('Searched', {
          organisationID: self.user.data.organisationID,
          userID: self.user.uid,
          searchQuery: query,
          noOfResults: hits.length,
          results: hits.map(function (hit) {
            return { objectID: hit.objectID, description: hit.description };
          })
        });
        self.loading = false;
        self.pingCards = [];
        // self.cards = hits
        self.mainCardList = hits.filter(function (card) {
          return card.fetched !== true;
        }).map(function (card) {
          return card.objectID;
        });
        self.noCardMessage = 'No cards found';
        hits.forEach(function (hit) {
          self.setCard(hit.objectID, hit);
        });
      }).catch(function (err) {
        console.error('Error Searching for Cards', err);
        __WEBPACK_IMPORTED_MODULE_4_logrocket___default.a.captureMessage('Error Searching for Cards', {
          extra: {
            err: err,
            data: searchParams
          }
        });
        __WEBPACK_IMPORTED_MODULE_5_raven_js___default.a.captureMessage('Error Searching for Cards', {
          extra: {
            err: err,
            data: searchParams
          }
        });
        self.errorMessage = 'Something went wrong - we couldn\'t connect to the database.';
        self.loading = false;
      });
    },
    searchGoogle: function searchGoogle(optionalQuery) {
      var query = optionalQuery && typeof optionalQuery === 'string' ? optionalQuery : this.query;
      window.open('https://www.google.com/search?q=' + query, '_parent');
    },
    createCard: function createCard(service) {
      var card = {
        objectID: 'TEMP_' + Math.floor(Math.random() * 10000000000),
        intent: 'store',
        service: service || null,
        temporary: true,
        newlyCreated: true
        // Currently have to do this so that card properties are registered when the card format vue component is created - otherwise the editable-markdown doesn't update the content properties!
      };switch (card.service) {
        case null:
          card.title = '';
          card.description = '';
          break;
        case 'sifter':
          card.title = '';
          card.description = '';
          card.integrationFields = {};
          break;
      }
      this.allCards[card.objectID] = card;
      this.popupCardList = [card.objectID];
    },
    deleteCard: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(objectID, callback) {
        var self, data, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = this;

                if (!confirm('Are you sure you want to delete this card?')) {
                  _context4.next = 13;
                  break;
                }

                data = {
                  sender: this.user.uid,
                  organisationID: self.user.data.organisationID,
                  objectID: objectID
                };

                console.log('data', data);
                _context4.next = 6;
                return self.Controller.deleteCard(data);

              case 6:
                result = _context4.sent;

                console.log(result);
                if (result.success) {
                  if (result.card) {
                    self.allCards[objectID] = result.card;
                  } else {
                    self.mainCardList = self.mainCardList.filter(function (cardID) {
                      return cardID !== objectID;
                    });
                    self.popupCardList = self.popupCardList.filter(function (cardID) {
                      return cardID !== objectID;
                    });
                    self.pingCards = self.pingCards.filter(function (card) {
                      return card.objectID !== objectID;
                    });
                  }
                }
                callback(result);
                return _context4.abrupt('return', result);

              case 13:
                console.log('Decided against deleting!');
                callback(null);
                return _context4.abrupt('return', null);

              case 16:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function deleteCard(_x6, _x7) {
        return _ref4.apply(this, arguments);
      }

      return deleteCard;
    }(),
    updateCard: function () {
      var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(data, callback, errorCallback) {
        var _this = this;

        var self, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log('updateCard', data, callback, errorCallback);
                self = this;

                if (data && data.listCards && data.listCards.length) {
                  data.listCards.forEach(function () {
                    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(listCard, index) {
                      var savedListCard;
                      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              if (!listCard.objectID || listCard.objectID.indexOf('TEMP') === 0) {
                                if (listCard.objectID) delete listCard.objectID;
                                listCard.intent = 'store';
                                listCard.sender = self.user.uid;
                              }
                              console.log('hi');
                              savedListCard = self.saveCard(listCard);

                              data.listItems[index] = savedListCard.objectID; // In case it was a new listCard. This also relies on the index still being correct after the asynchronous delay

                            case 4:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, _this);
                    }));

                    return function (_x11, _x12) {
                      return _ref6.apply(this, arguments);
                    };
                  }());
                }
                _context6.prev = 3;
                _context6.next = 6;
                return self.saveCard(data);

              case 6:
                result = _context6.sent;

                callback(result);
                return _context6.abrupt('return', result);

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](3);

                console.log('e');
                console.log(_context6.t0);
                errorCallback(_context6.t0);
                return _context6.abrupt('return', null);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 11]]);
      }));

      function updateCard(_x8, _x9, _x10) {
        return _ref5.apply(this, arguments);
      }

      return updateCard;
    }(),
    saveCard: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(data) {
        var self, objectID, result, returnedCard;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                self = this;

                if (data && data.listCards) delete data.listCards;
                objectID = data.objectID;

                if (data.temporary) {
                  delete data.objectID;
                  delete data.temporary;
                }
                if (data._highlightResult) delete data._highlightResult;
                console.log('data to send with saveCard()', data);
                _context7.prev = 6;
                _context7.next = 9;
                return self.Controller.saveCard(data);

              case 9:
                result = _context7.sent;

                if (result.success) {
                  returnedCard = result.card;

                  console.log('returnedCard', returnedCard);
                  data.objectID = returnedCard.objectID;
                  self.setCard(returnedCard.objectID, returnedCard);
                  self.popupCardList = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.popupCardList));
                  self.popupCardList = self.popupCardList.map(function (id) {
                    return id === objectID ? returnedCard.objectID : id;
                  });
                  // // @TODO: Delete the next line
                  // if (self.popupCardList.length === 1) self.popupCardList = [returnedCard.objectID] // @TODO: This is a hack because popupCardList isn't synced with allCards!
                } else {
                  console.log(result.error && result.error.message);
                  if (result.error && result.error.message === 'Network Error') {
                    // @TODO: ??
                  }
                }
                return _context7.abrupt('return', result);

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7['catch'](6);

                console.error(_context7.t0);
                return _context7.abrupt('return', null);

              case 18:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[6, 14]]);
      }));

      function saveCard(_x13) {
        return _ref7.apply(this, arguments);
      }

      return saveCard;
    }(),
    verifyCard: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(data, callback, errorCallback) {
        var self, objectID, result, returnedCard;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('data to send with saveCard()', data);
                self = this;
                objectID = data.objectID;
                _context8.prev = 3;
                _context8.next = 6;
                return self.Controller.verifyCard(data);

              case 6:
                result = _context8.sent;

                if (result.success) {
                  returnedCard = result.card;

                  console.log('returnedCard', returnedCard);
                  self.setCard(returnedCard.objectID, returnedCard);
                  self.popupCardList = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.popupCardList));
                  self.popupCardList = self.popupCardList.map(function (id) {
                    return id === objectID ? returnedCard.objectID : id;
                  });
                  callback(result);
                  // // @TODO: Delete the next line
                  // if (self.popupCardList.length === 1) self.popupCardList = [returnedCard.objectID] // @TODO: This is a hack because popupCardList isn't synced with allCards!
                } else {
                  console.log(result.error && result.error.message);
                  if (result.error && result.error.message === 'Network Error') {
                    // @TODO: ??
                  }
                  errorCallback(result);
                }
                return _context8.abrupt('return', result);

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8['catch'](3);

                console.error(_context8.t0);
                return _context8.abrupt('return', null);

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[3, 11]]);
      }));

      function verifyCard(_x14, _x15, _x16) {
        return _ref8.apply(this, arguments);
      }

      return verifyCard;
    }(),
    modalCallback: function modalCallback(message) {
      var self = this;
      this.showAlert('success', 2000, message || 'Success! Update made.');
      var query = this.lastQuery;
      setTimeout(function () {
        self.query = query;
        self.search();
      }, 1000);
    },
    copyAlert: function copyAlert() {
      this.showAlert('success', 2000, 'Copied to clipboard!');
    },
    showAlert: function showAlert(type, duration, title) {
      self.alertData = {
        show: true,
        type: type,
        title: title
      };
      setTimeout(function () {
        self.alertData.show = false;
      }, duration);
    },
    reaction: function reaction(data) {
      console.log('Reacting!');
      var self = this;
      __WEBPACK_IMPORTED_MODULE_6_mixpanel_browser___default.a.track('User Reacted to Card', {
        organisationID: self.user.data.organisationID,
        userID: self.user.uid,
        reaction: data.reaction,
        cardID: data.card.objectID,
        description: data.card.description,
        listItems: data.card.listItems,
        files: data.card.files.map(function (file) {
          return { id: file.objectID, title: file.title };
        }),
        searchQuery: self.query
      });
    }
  }
});

/***/ }),

/***/ "j9Xp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__ = __webpack_require__("Me1o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce5dbba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_vue__ = __webpack_require__("X9NS");
function injectStyle (ssrContext) {
  __webpack_require__("ZwKY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce5dbba_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jecr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_logrocket__ = __webpack_require__("oeg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_awesome_icons__ = __webpack_require__("D/PP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon_vue__ = __webpack_require__("D4uH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scripts_jquery_js__ = __webpack_require__("is4b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scripts_google_js__ = __webpack_require__("2MVu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scripts_kloudless_authenticator_js__ = __webpack_require__("BEaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scripts_trello_js__ = __webpack_require__("8KUl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__spinner_vue__ = __webpack_require__("spwi");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global Kloudless, window, gapi */
// /* global Kloudless, window */










// require('log-suppress').init(console)

var googleAuth2 = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['services', 'organisationID', 'autoService'],
  data: function data() {
    return {
      loading: false,
      message: null,
      authPopup: null,
      googleAuth2: null
    };
  },
  components: {
    Icon: __WEBPACK_IMPORTED_MODULE_4_vue_awesome_components_Icon_vue__["a" /* default */],
    Spinner: __WEBPACK_IMPORTED_MODULE_9__spinner_vue__["a" /* default */]
  },
  created: function created() {
    console.log('gapi');
    console.log(gapi);
    console.log('gapi.load');
    console.log(gapi.load);
    gapi.load('auth2', function () {
      console.log('gapi.auth2');
      console.log(gapi.auth2);
      console.log('gapi.auth2.init');
      console.log(gapi.auth2.init);
      googleAuth2 = gapi.auth2.init({ // eslint-disable-line
        client_id: '704974264220-lmbsg98tj0f3q09lv4tk6ha46flit4f0.apps.googleusercontent.com'
        // Scopes to request in addition to 'profile' and 'email'
        // scope: 'https://www.googleapis.com/auth/gmail.readonly'
      });
      console.log('googleAuth2');
      console.log(googleAuth2);
    });
  },
  methods: {
    connectSource: function connectSource(service) {
      console.log('service');
      console.log(service);
      if (service.comingSoon) return;
      switch (service.id) {
        case 'gdrive':
        case 'dropbox':
          var params = {
            'client_id': '245u1N7lejDTHB0VtkNReEIpUItQLEs67I20xL0XD5DN0QDj',
            'scope': service.id + ':normal.storage'
          };
          var auth = Kloudless.authenticator(null, params, this.fromKloudless);
          auth.launch();
          break;
        case 'trello':
          window.addEventListener('message', this.useTokenFromPopup, { once: true });
          console.log('added event listener');
          this.authPopup = window.open('https://trello.com/1/authorize?expiration=never&name=Savvy&scope=read,write&response_type=token&key=40bf04080255c5fe6b5e9643a9b9011b&return_url=' + encodeURIComponent(window.location.href) + '%2F&callback_method=postMessage', '_blank');
          // Trello.authorize({ type: 'popup', name: 'Savvy', scope: { read: true, write: true, account: false }, expiration: 'never', success: this.addSource1, error: this.errorAddingSource })
          break;
        case 'gmail':
          if (googleAuth2) googleAuth2.grantOfflineAccess({ scope: 'https://www.googleapis.com/auth/gmail.readonly' }).then(this.receiveGmailCode);else window.open('https://connect.heysavvy.com/?org=' + this.organisationID + '&service=gmail');
          break;
        case 'asana':
          // window.addEventListener('message', this.useTokenFromPopup, { once: true })
          // console.log('added event listener')
          this.authPopup = window.open('https://app.asana.com/-/oauth_authorize?client_id=615384312271855&redirect_uri=https%3A%2F%2Fconnect.heysavvy.com%2F&response_type=token&state="123=456"', '_blank');
          // Trello.authorize({ type: 'popup', name: 'Savvy', scope: { read: true, write: true, account: false }, expiration: 'never', success: this.addSource1, error: this.errorAddingSource })
          break;
        default:
          break;
      }
    },
    repeatTokenCollection: function repeatTokenCollection(serviceName, tokenName, counter) {
      var _this = this;

      if (!counter) counter = 0;
      setTimeout(function () {
        try {
          var popupHref = _this.authPopup.location.href;
          console.log('tokenName', tokenName);
          console.log('popupHref', popupHref);
          var token = getParameterByName(tokenName, popupHref);
          console.log('token', token);
          var result = {
            origin: serviceName
          };
          result[tokenName] = token;
          // this.useTokenFromPopup(result)
        } catch (e) {
          if (counter < 30) _this.repeatTokenCollection(serviceName, tokenName, counter + 1);
        }
      }, 1000);
    },
    receiveGmailCode: function receiveGmailCode(result) {
      result.origin = 'gmail';
      this.useTokenFromPopup(result);
    },
    useTokenFromPopup: function useTokenFromPopup(result) {
      console.log('result11');
      console.log(result);
      if (this.authPopup) this.authPopup.close();
      var source = {
        organisationID: this.organisationID === 'connect' ? getParameterByName('org') : this.organisationID
      };
      switch (result.origin) {
        case 'kloudless':
          source.superService = 'kloudless';
          source.service = result.account.service;
          source.accountID = result.account.id;
          source.access_token = result.access_token;
          source.raw_source = result.account;
          source.scope = result.scope;
          source.addedBy = result.account.account;
          break;
        case 'https://trello.com':
          source.service = 'trello';
          source.token = result.data;
          break;
        case 'gmail':
          source.superService = 'google';
          source.service = 'gmail';
          source.scopes = ['https://www.googleapis.com/auth/gmail.readonly'];
          source.code = result.code;
          break;
      }
      if (source.service || source.superService) {
        source.title = this.services.find(function (service) {
          return service.id === source.service;
        }).title;
        this.addSource(source);
      }
    },
    fromKloudless: function fromKloudless(result) {
      console.log('fromKloudless');
      result.origin = 'kloudless';
      this.useTokenFromPopup(result);
    },
    addSource: function addSource(source) {
      console.log('source');
      console.log(source);
      var self = this;
      self.message = null;
      if (!self.loading) {
        self.loading = true;
        setTimeout(function () {
          console.log('5 second timeout');
          if (self.loading) {
            console.log('hi');
            self.loading = false;
            self.message = {
              text: 'Thanks for connecting up your ' + source.title + ' account! We\'re indexing your content right now and it\'ll be ready for you within a few minutes. ☕️'
            };
          }
        }, 5000);
        __WEBPACK_IMPORTED_MODULE_2_axios___default()({
          method: 'post',
          // url: 'http://localhost:5050/add-source',
          url: 'https://savvy-nlp--staging.herokuapp.com/add-source',
          // timeout: 10000,
          data: source
        }).then(function (res) {
          console.log('res');
          console.log(res);
          if (!res.data || !res.data.success) {
            throw res.data && res.data.error || 'error';
          }
          self.loading = false;
          self.message = {
            text: 'Great news - your files are now indexed and ready to search!'
          };
        }).catch(function (err) {
          self.loading = false;
          console.error('Error Adding Source', err);
          __WEBPACK_IMPORTED_MODULE_0_logrocket___default.a.captureMessage('Error Adding Source', {
            extra: {
              err: err,
              data: source
            }
          });
          __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.captureMessage('Error Adding Source', {
            extra: {
              err: err,
              data: source
            }
          });
          self.message = {
            text: 'Something went wrong indexing your files!',
            type: 'error'
          };
        });
      }
    },
    errorAddingSource: function errorAddingSource(error) {
      console.log('error');
      console.log(error);
    }
  }
});

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

/***/ }),

/***/ "l3bJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



/* global chrome */

var stateChangeListeners = [];

/* Gets called when the auth state changes, and proceeds to call every listenerFunction */
var stateChanged = function stateChanged(state, user) {
  console.log('stateChangeCallback (chrome-controller-interface.js)', state, user);
  console.log('stateChangeListeners to call (chrome-controller-interface.js):', stateChangeListeners);
  stateChangeListeners.forEach(function (listenerFunction) {
    listenerFunction(state, user);
  });
};

var ChromeControllerInterface = function () {
  function ChromeControllerInterface() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ChromeControllerInterface);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ChromeControllerInterface, [{
    key: 'signIn',
    value: function signIn() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        chrome.runtime.sendMessage({ action: 'signIn' }, resolve);
      });
    }
  }, {
    key: 'signOut',
    value: function signOut() {
      console.log('No sign out option in Chrome extension yet!');
    }
  }, {
    key: 'addStateChangeListener',
    value: function addStateChangeListener(listenerFunction) {
      console.log('AAAA addStateChangeListener', listenerFunction);
      stateChangeListeners.push(listenerFunction);
    }
  }, {
    key: 'getUser',
    value: function getUser() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('getUser (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'getUser' }, resolve);
      });
    }
  }, {
    key: 'getAccessToken',
    value: function getAccessToken() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('getAccessToken (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'getAccessToken' }, resolve);
      });
    }
  }, {
    key: 'refreshUserToken',
    value: function refreshUserToken() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('refreshUserToken (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'refreshUserToken' }, resolve);
      });
    }
  }, {
    key: 'saveCard',
    value: function saveCard(data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('saveCard (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'saveCard', data: data }, resolve);
      });
    }
  }, {
    key: 'deleteCard',
    value: function deleteCard(data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('deleteCard (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'deleteCard', data: data }, resolve);
      });
    }
  }, {
    key: 'verifyCard',
    value: function verifyCard(data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('verifyCard (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'verifyCard', data: data }, resolve);
      });
    }
  }, {
    key: 'searchCards',
    value: function searchCards(data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('searchCards (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'searchCards', data: data }, resolve);
      });
    }
  }, {
    key: 'getCard',
    value: function getCard(data) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        console.log('getCard (chrome-controller-interface.js)');
        chrome.runtime.sendMessage({ action: 'getCard', data: data }, resolve);
      });
    }
  }, {
    key: 'force',
    value: function force(toForce) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        chrome.runtime.sendMessage({ action: 'force', data: toForce }, resolve);
      });
    }
  }]);

  return ChromeControllerInterface;
}();

window.addEventListener('message', function (event) {
  switch (event.data.action) {
    case 'stateChanged':
      console.log('stateChanged (chrome-controller-interface.js)', event.data);
      console.log('should we use this...', event.data.state, event.data.user);
      console.log('...or this?', event.data.data.state, event.data.data.user);
      stateChanged(event.data.state, event.data.user);
      break;
  }
}, false);

/* harmony default export */ __webpack_exports__["a"] = (ChromeControllerInterface);

/***/ }),

/***/ "lEdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chrome_vue__ = __webpack_require__("6a8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047dbf3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chrome_vue__ = __webpack_require__("iS8+");
function injectStyle (ssrContext) {
  __webpack_require__("UqXr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_chrome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047dbf3d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_chrome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lJO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






var Rest = function () {
  function Rest(url) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Rest);

    console.log('Registering REST url', url);
    this.url = url;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Rest, [{
    key: 'post',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(endpoint, data) {
        var self, url, r, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('REST post request', data);
                self = this;
                url = endpoint ? isURL(endpoint) ? endpoint : self.url + endpoint : self.url;

                if (url) {
                  _context.next = 6;
                  break;
                }

                console.log('No url defined!');
                return _context.abrupt('return', new Error('No url defined!'));

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, data);

              case 9:
                r = _context.sent;
                response = r.data;

                if (!response.success) {
                  _context.next = 16;
                  break;
                }

                console.log('REST Success!', response);
                return _context.abrupt('return', response);

              case 16:
                console.log('REST Failure!', response);
                return _context.abrupt('return', new Error(response.error));

              case 18:
                _context.next = 24;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](6);

                console.log('REST Failure!', _context.t0);
                return _context.abrupt('return', new Error(_context.t0));

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 20]]);
      }));

      function post(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return post;
    }()
  }]);

  return Rest;
}();

function isURL(str) {
  var pattern = new RegExp('^(https?://)');
  return pattern.test(str);
}

/* harmony default export */ __webpack_exports__["a"] = (Rest);

/***/ }),

/***/ "lfcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_markdown__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'editable', 'placeholder', 'fieldName'],
  data: function data() {
    return {
      myContent: this.content || '',
      myClass: String(Math.floor(Math.random() * 10000000000))
    };
  },
  computed: {
    component: function component() {
      var cv = this.editable ? 'div' : 'vue-markdown';
      return cv;
    }
  },
  components: {
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_0_vue_markdown___default.a
  },
  watch: {
    editable: function editable(val) {
      var self = this;
      // self.myClass = String(Math.floor(Math.random() * 10000000000))
      var innerText = document.getElementsByClassName(self.myClass)[0].innerText.replace(/^\s+|\s+$/g, '').trim(); // Removes newlines and whitespaces from start/end of string
      // console.log('self.fieldName')
      // console.log(self.fieldName)
      // console.log('self.myClass')
      // console.log(self.myClass)
      // console.log('innerText')
      // console.log(innerText)
      // console.log('element')
      // console.log(document.getElementsByClassName(self.myClass)[0])
      // We need to use something like "this.$nextTick": https://vuejs.org/v2/guide/reactivity.html
      if (self.editable) {
        setTimeout(function () {
          document.getElementsByClassName(self.myClass)[0].innerText = innerText;
        }, 1);
      } else {
        // self.myContent = ''
        // // this.$emit('update', innerText)
        setTimeout(function () {
          self.myContent = self.content;
        }, 1);
      }
    },
    content: function content(val) {
      if (!this.editable) this.myContent = this.content;
    }
  },
  methods: {
    update: function update(event) {
      var self = this;
      var innerText = document.getElementsByClassName(self.myClass)[0].innerText.replace(/^\s+|\s+$/g, '').trim(); // Removes newlines and whitespaces from start/end of string
      console.log('update (editable-markdown.vue)', innerText);
      this.$emit('update', { field: this.fieldName, value: innerText });
      // this.$emit('finishEdit', event.target.innerText)
    }
  }
});

/***/ }),

/***/ "mRJL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_logrocket__ = __webpack_require__("oeg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_logrocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_logrocket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js__ = __webpack_require__("/Hyb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rest__ = __webpack_require__("lJO4");






 // @TODO: user this for everything and remove axios!

var Author = function () {
  function Author(options) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Author);

    console.log('Registering Author options', options);
    this.options = options;
    this.rest = new __WEBPACK_IMPORTED_MODULE_6__rest__["a" /* default */](options.url);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Author, [{
    key: 'importFromDrive',
    value: function importFromDrive(user) {
      console.log('importFromDrive', user);
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(self.options.importUrl, user).then(function (response) {
          resolve(response);
        }).catch(function (e) {
          console.log(e);
          reject(e);
        });
      });
    }
  }, {
    key: 'saveCard',
    value: function saveCard(data) {
      console.log('saveCard', data);
      var self = this;
      console.log(self.options.url);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!self.options.url) reject(new Error('No url defined!'));
        if (data.content) delete data.content;
        if (data.temporary) delete data.temporary;
        if (data.newlyCreated) delete data.newlyCreated;
        // @TODO: Move this error logic to a new library called Connect
        __WEBPACK_IMPORTED_MODULE_5_axios___default()({
          method: 'post',
          // url: 'http://localhost:5000/api/memories/',
          url: self.options.url,
          timeout: 10000,
          data: data
        }).then(function (response) {
          console.log('Card Saved!', response);
          resolve({
            success: true,
            card: response.data.card
          });
        }).catch(function (err) {
          console.error('Error Saving Card', err);
          __WEBPACK_IMPORTED_MODULE_3_logrocket___default.a.captureMessage('Error Saving Card', {
            extra: {
              err: err,
              data: data
            }
          });
          __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureMessage('Error Saving Card', {
            extra: {
              err: err,
              data: data
            }
          });
          var errorToReturn = {
            err: err,
            message: err.message
          };
          if (err && err.message) {
            if (err.message === 'Network Error') errorToReturn.message = 'Network Error - Are you sure you\'re connected to the internet?';
            if (err.message === 'Request failed with status code 404') errorToReturn.message = 'Whoops! Something went wrong - we\'re working on fixing it right now!';
          }
          resolve({
            success: false,
            error: errorToReturn
          });
        });
      });
    }
  }, {
    key: 'deleteCard',
    value: function deleteCard(data) {
      console.log('deleteCard', data);
      var self = this;
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!self.options.url) {
          console.log('No url defined!');
          reject(new Error('No url defined!'));
        }
        __WEBPACK_IMPORTED_MODULE_5_axios___default()({
          method: 'delete',
          // url: 'http://localhost:5000/api/memories/',
          url: self.options.url,
          timeout: 10000,
          params: data
        }).then(function (response) {
          console.log('Card Deleted!', response);
          resolve(response.data);
        }).catch(function (err) {
          console.error('Error Deleting Card', err);
          __WEBPACK_IMPORTED_MODULE_3_logrocket___default.a.captureMessage('Error Deleting Card', {
            extra: {
              err: err,
              data: data
            }
          });
          __WEBPACK_IMPORTED_MODULE_4_raven_js___default.a.captureMessage('Error Deleting Card', {
            extra: {
              err: err,
              data: data
            }
          });
          var errorToReturn = {
            err: err,
            message: err.message
          };
          if (err && err.message) {
            if (err.message === 'Network Error') errorToReturn.message = 'Network Error - Are you sure you\'re connected to the internet?';
            if (err.message === 'Request failed with status code 404') errorToReturn.message = 'Whoops! Something went wrong - we\'re working on fixing it right now!';
          }
          resolve({
            success: false,
            error: errorToReturn
          });
        });
      });
    }
  }, {
    key: 'verifyCard',
    value: function verifyCard(data) {
      console.log('verifyCard', data);
      // return this.rest.post('http://localhost:5000/api/verify', data)
      return this.rest.post('https://savvy-api--live.herokuapp.com/api/verify', data);
    }
  }]);

  return Author;
}();

/* harmony default export */ __webpack_exports__["a"] = (Author);

/***/ }),

/***/ "mfOO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mxtX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"alert"}},[(_vm.show)?_c('div',{staticClass:"alert",attrs:{"placement":"top","type":_vm.type,"width":"400px"}},[_c('strong',[_c('icon',{attrs:{"name":"check"}}),_vm._v(_vm._s(_vm.title))],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "olKB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__ = __webpack_require__("69NR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656c8952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__ = __webpack_require__("mxtX");
function injectStyle (ssrContext) {
  __webpack_require__("CGSI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_656c8952_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qK+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__ = __webpack_require__("HUDD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb41b14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__ = __webpack_require__("JAo3");
function injectStyle (ssrContext) {
  __webpack_require__("VsSb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb41b14_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qkup":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r+yu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ibutton_vue__ = __webpack_require__("bOqg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2c1c6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ibutton_vue__ = __webpack_require__("DlG0");
function injectStyle (ssrContext) {
  __webpack_require__("FdW5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ibutton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e2c1c6f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ibutton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "spwi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__ = __webpack_require__("3bC4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2021fd40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__ = __webpack_require__("OfUd");
function injectStyle (ssrContext) {
  __webpack_require__("/Rww")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spinner_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2021fd40_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "srgI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_vue__ = __webpack_require__("xAg5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cfbacb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_vue__ = __webpack_require__("LkkW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34cfbacb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sxkl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('field',{attrs:{"label":"title","content":_vm.content.title,"editing":_vm.editing},on:{"update":_vm.update}}),_vm._v(" "),_c('field',{attrs:{"label":"description","content":_vm.content.description,"editing":_vm.editing,"truncate":_vm.full},on:{"update":_vm.update}}),_vm._v(" "),(_vm.content.listItems || _vm.content.cells)?_c('list',{attrs:{"listItems":_vm.content.listItems || {value: _vm.content.cells.value.map(function (cell, i) { return i; }), state: 'pending'},"listCards":_vm.content.listCards || {value: _vm.content.cells.value.map(function (cell) { return { description: cell.content } }), state: 'pending'},"full":_vm.full,"allCards":_vm.allCards,"editing":_vm.editing},on:{"cardletClick":_vm.cardletClick}}):_vm._e(),_vm._v(" "),(_vm.full && _vm.content.attachments && _vm.content.attachments.value && _vm.content.attachments.value[0])?_c('img',{class:_vm.content.attachments && _vm.content.attachments.state,attrs:{"src":_vm.content.attachments.value[0].url}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "szWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.away),expression:"away"}],staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_vm._v("\n            Please enter your new memory\n          ")])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.text),expression:"data.text"}],attrs:{"rows":"6","placeholder":"My secret superpower is invisibility"},domProps:{"value":(_vm.data.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data, "text", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer",[_c('button',{staticClass:"modal-default-button",on:{"click":_vm.submitEvent}},[_c('icon',{attrs:{"name":"check"}}),_vm._v("\n              Done\n            ")],1)])],2)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "t8wU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardlet_vue__ = __webpack_require__("bGfq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dece1da6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardlet_vue__ = __webpack_require__("d62z");
function injectStyle (ssrContext) {
  __webpack_require__("8tDu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cardlet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dece1da6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cardlet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tTyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel popup-panel"},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uE8u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_markdown_vue__ = __webpack_require__("lfcg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d90d2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_markdown_vue__ = __webpack_require__("1Dbx");
function injectStyle (ssrContext) {
  __webpack_require__("9SFg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editable_markdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d90d2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_editable_markdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uoWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"explorer",class:{sidebar: _vm.sidebar}},[_c('div',{staticClass:"main-explorer",class:{mouseover : _vm.overMain, 'search-results': _vm.cards.length, 'mode': _vm.mode === 'demo'},attrs:{"uid":"main"},on:{"mouseover":function($event){_vm.overMain = true},"mouseout":function($event){_vm.overMain = false}}},[_c('div',{staticClass:"create-button"},[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"id":"ddown1","text":"➕ Create","variant":"default"}},[_c('b-dropdown-item',{staticClass:"basic",on:{"click":function($event){_vm.createCard(null)}}},[_vm._v("🔖 New Card")])],1)],1),_vm._v(" "),_c('alert',{attrs:{"show":_vm.alertData.show,"type":_vm.alertData.type,"title":_vm.alertData.title}}),_vm._v(" "),(_vm.modal.show)?_c('modal',{attrs:{"data":_vm.modal},on:{"close":function($event){_vm.modal.show = false},"submit":_vm.modal.submit}}):_vm._e(),_vm._v(" "),(!(_vm.$route && _vm.$route.query && _vm.$route.query.q))?_c('div',{staticClass:"header"},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"search"},[_vm._t("greeting"),_vm._v(" "),_c('a',{staticClass:"closeSearch",attrs:{"href":"#"},on:{"click":_vm.closeSearch}},[_c('icon',{attrs:{"name":"close"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],attrs:{"autofocus":"","type":"text","tabindex":"1","placeholder":_vm.searchPlaceholder},domProps:{"value":(_vm.query)},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if(!$event.shiftKey){ return null; }_vm.searchGoogle($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }_vm.search($event)}],"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_vm._v(" "),(!_vm.sidebar)?_c('div',{staticClass:"search-options"},[_c('label',{staticClass:"hint"},[_vm._v("Savvy Hint: "+_vm._s(_vm.hint))]),_vm._v(" "),(_vm.allowSearchStrategy)?_c('b-form-group',{staticClass:"search-strategy-buttons"},[_c('b-form-radio-group',{attrs:{"id":"btnradios1","buttons":"","options":_vm.searchStrategyOptions,"name":"radiosBtnDefault"},model:{value:(_vm.searchStrategy),callback:function ($$v) {_vm.searchStrategy=$$v},expression:"searchStrategy"}})],1):_vm._e()],1):_vm._e()],2),_vm._v(" "),_vm._t("buttons")],2):_vm._e(),_vm._v(" "),((_vm.$route && _vm.$route.query && _vm.$route.query.q))?_c('h2',[_vm._v("Your search results for \""+_vm._s(_vm.query)+"\":")]):_vm._e(),_vm._v(" "),(_vm.cards.length && !(_vm.$route && _vm.$route.query && _vm.$route.query.q))?_c('p',{staticClass:"results-label"},[_vm._v("Your search results for \""+_vm._s(_vm.lastQuery)+"\":")]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"masonry",rawName:"v-masonry"}],staticClass:"cards",attrs:{"transition-duration":"0.5s","item-selector":".card"}},[(_vm.loading && _vm.loader == -1)?_c('spinner'):_vm._e(),_vm._v(" "),(_vm.errorMessage && _vm.errorMessage.length)?_c('p',{staticClass:"message-block error"},[_c('icon',{attrs:{"name":"exclamation-triangle"}}),_vm._v(_vm._s(_vm.errorMessage))],1):_vm._e(),_vm._v(" "),(_vm.loader != -1)?_c('p',{staticClass:"loader-text"},[_vm._v("Importing and processing content...")]):_vm._e(),_vm._v(" "),(_vm.loader != -1)?_c('div',{staticClass:"loader"},[_c('div',{style:({ width: _vm.loader + '%' })})]):_vm._e(),_vm._v(" "),(_vm.loader != -1)?_c('p',{staticClass:"loader-card-text"},[_vm._v(_vm._s(_vm.loaderCards)+" cards generated")]):_vm._e(),_vm._v(" "),_vm._l((_vm.cards),function(card,index){return _c('card',{directives:[{name:"masonry-tile",rawName:"v-masonry-tile"}],key:card.objectID,attrs:{"plugin":_vm.plugin,"data":card,"full":false,"allCards":_vm.allCards,"highlightResult":card._highlightResult,"userRole":_vm.user.data.role,"userTopics":_vm.user.data.topics || [],"mode":_vm.mode},on:{"cardMouseover":_vm.cardMouseover,"cardMouseout":_vm.cardMouseout,"cardClick":_vm.cardClick,"fileClick":_vm.fileClick,"serviceClick":_vm.serviceClick,"updateCard":_vm.updateCard,"verifyCard":_vm.verifyCard,"deleteCard":_vm.deleteCard,"reaction":_vm.reaction,"copy":_vm.copyAlert}})}),_vm._v(" "),(!_vm.cards.length)?_c('div',{staticClass:"no-cards"},[(_vm.lastQuery.length)?_c('p',[_vm._v(_vm._s(_vm.noCardMessage))]):_vm._e(),_vm._v(" "),(_vm.mode === 'demo')?_c('div',{staticClass:"search-suggestions"},[_c('p',[_vm._v("Try searching for:")]),_vm._v(" "),_c('p',[_vm._v("'What batch was Stripe in'")]),_vm._v(" "),_c('p',[_vm._v("'When did Sam go to Waterloo'")]),_vm._v(" "),_c('p',[_vm._v("'How did the Savvy team meet?'")]),_vm._v(" "),_c('p',[_vm._v("'Get me the YC logo'")])]):_vm._e(),_vm._v(" "),_c('img',{attrs:{"src":"/static/images/search-graphic.png","alt":""}})]):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"popup",class:{ active: _vm.popupCards.length },on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.popupFrameClick($event)}}},[_c('div',{staticClass:"cards",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.popupFrameClick($event)}}},[(_vm.popupLoading)?_c('spinner',{staticClass:"div-spinner"}):_vm._e(),_vm._v(" "),(_vm.popupCards.length > 1)?_c('div',{staticClass:"popup-back",on:{"click":_vm.popupBack,"mouseover":_vm.cardMouseoverFromPopup}},[_c('icon',{attrs:{"name":"arrow-left"}}),_vm._v(" Back to \""),_c('span',{staticClass:"name"},[_vm._v(_vm._s((_vm.popupCards[_vm.popupCards.length - 2].title || _vm.popupCards[_vm.popupCards.length - 2].description || '').substring(0, 30))+"...")]),_vm._v("\"")],1):_vm._e(),_vm._v(" "),(_vm.popupCards.length)?_c('card',{attrs:{"plugin":_vm.plugin,"data":_vm.popupCards ? _vm.popupCards[_vm.popupCards.length - 1] : {},"full":true,"allCards":_vm.allCards,"userRole":_vm.user.data.role,"userTopics":_vm.user.data.topics || [],"mode":_vm.mode},on:{"cardMouseover":_vm.cardMouseoverFromPopup,"cardMouseout":_vm.cardMouseout,"cardClick":_vm.cardClickFromPopup,"fileClick":_vm.fileClick,"serviceClick":_vm.serviceClick,"updateCard":_vm.updateCard,"verifyCard":_vm.verifyCard,"deleteCard":_vm.deleteCard,"reaction":_vm.reaction,"copy":_vm.copyAlert}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "va8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.query),expression:"query"}],attrs:{"autofocus":"","type":"text","placeholder":"Search for cards..."},domProps:{"value":(_vm.query)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.query=$event.target.value}}}),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.clearResults),expression:"clearResults"}],staticClass:"results"},_vm._l((_vm.results),function(result){return _c('cardlet',{key:result.objectID,attrs:{"editable":false,"card":result,"editing":false},on:{"cardletClick":_vm.selectResult}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w4qd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__field_vue__ = __webpack_require__("6Pqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list_vue__ = __webpack_require__("qK+6");
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'full', 'allCards', 'position', 'editing'],
  components: {
    Field: __WEBPACK_IMPORTED_MODULE_0__field_vue__["a" /* default */],
    List: __WEBPACK_IMPORTED_MODULE_1__list_vue__["a" /* default */]
  },
  methods: {
    update: function update(data) {
      console.log('update (row)', data);
      if (data.field === 'list') data.field = 'cells';
      this.$emit('update', data);
    },
    cardletClick: function cardletClick(card) {
      console.log('cardletClick (row.vue)', card);
      this.$emit('cardletClick', card);
    }
  }
});

/***/ }),

/***/ "wTBZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xAg5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'editable'],
  mounted: function mounted() {
    this.$el.innerText = this.content;
  },
  watch: {
    editable: function editable(val) {
      this.$el.innerText = this.content;
    },
    content: function content(val) {
      if (!this.editable) this.$el.innerText = this.content;
    }
  },
  methods: {
    update: function update(event) {
      this.$emit('update', event.target.innerText);
    }
  }
});

/***/ }),

/***/ "y9AU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__editable_markdown__ = __webpack_require__("uE8u");
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['content', 'label', 'editing', 'truncate'],
  components: {
    EditableMarkdown: __WEBPACK_IMPORTED_MODULE_0__editable_markdown__["a" /* default */]
  },
  filters: {
    truncateValue: function truncateValue(prop, full) {
      if (!prop || !prop.value) return '';
      var text = prop.value;
      var snippetLength = 100;
      var snippetStart = Math.max(text.indexOf('**') - snippetLength / 2, 0);
      return full ? text : text.trunc(snippetStart, snippetLength, true);
    }
  },
  methods: {
    update: function update(data) {
      console.log('update (field.vue)');
      this.$emit('update', data);
    }
  }
});

/***/ }),

/***/ "ybKc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("eqfd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadcbcd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("szWv");
function injectStyle (ssrContext) {
  __webpack_require__("IPVE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fadcbcd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zj2Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["UkLN"]);


// WEBPACK FOOTER //
// static/js/app.58bc10cc8607e4c3cf0c.js